import React, { useState } from "react";
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { Accordion, Form, InputGroup, Button, Row, Col, Modal, Tabs, Tab, Nav, NavDropdown } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { paths } from "../../Constant/paths";
import { useTranslation } from "react-i18next";

const settings = {
  infinite: false,
  dots: false,
  arrows: true,
  variableWidth: true,
  focusOnSelect: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1300,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        arrows: true,
      },
    },
  ],
};

const upcomingslider = {
  dots: false,
  infinite: false,
  autoplay: true,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
};

const categoryList = {
  infinite: false,
  dots: false,
  arrows: true,
  variableWidth: true,
  focusOnSelect: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1300,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        arrows: true,
      },
    },
  ],
};

export default function HtmlDesign() {
  const {
    admin: {
      projects,
      applicationStatus: {
        root,
        overview,
        chat,
        email,
        logs,
        timeline,
        document,
      },
    },
  } = paths;

  const { pathname } = useLocation();
  const { t } = useTranslation();
  const projectId = "";
  const stageId = "";
  const gid = "";

  const [selected, setSelected] = useState("");

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [NewMeeting, setNewMeeting] = useState(false);

  const [activeKey, setActiveKey] = useState("all");

  const [activeKey2, setActiveKey2] = useState('participant');

  const [activeMeetingTab, setActiveMeetingTab] = useState("about");

  const [activeScheduleTab, setActiveScheduleTab] = useState("startMeeting");

  const PrevArrow = ({ onClick }) => (
    <button className="arrow-btn arrow-prev w-10 h-10 d-flex justify-content-center align-items-center border-transparent bg-white rounded-lg shadow position-absolute z-10" onClick={onClick}
    >
      <i className="bx bx-chevron-left bx-md"></i>
    </button>
  );

  const NextArrow = ({ onClick }) => (
    <button className="arrow-btn arrow-next w-10 h-10 d-flex justify-content-center align-items-center border-transparent bg-white rounded-lg shadow position-absolute z-10" onClick={onClick}
    >
      <i className="bx bx-chevron-right bx-md"></i>
    </button>
  );

  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);

  return (
    <main className="main">

      <div className="mb-5">
        <h2 className="h5 font-semibold">Dashboard Metting</h2>

        <div className="row">
          <div className="col-lg-8 col-md-7 col-sm-12 col-12">
            <div className="pb-3 d-flex flex-wrap justify-content-between align-items-center mb-4 border-bottom border-grey-200">
              <h3 className="mb-0 text-base font-semibold">Pluto Virtual Meeting</h3>
              <button type="button" className="record-box d-flex align-items-center ps-2 pe-3 py-1-5 text-primary-500 rounded-lg border border-primary-200 bg-primary-50">
                <i className="bx bx-radio-circle-marked text-red-500 bx-sm leading-3"></i> <span className="text-xs font-medium">13:03:34</span>
              </button>
            </div>
            <div className="max-w-750 mx-auto">
              <div className="w-full mx-auto">
                <div className="row justify-content-center mb-2">
                  <div className="col-md-10">
                    <Slider
                      asNavFor={nav1}
                      ref={(slider) => setNav2(slider)}
                      infinite={false} 
                      swipeToSlide={true}
                      focusOnSelect={true}
                      arrows={true}
                      nextArrow={<NextArrow />}
                      prevArrow={<PrevArrow />}
                      centerMode={false}
                      className="thumb-slider"
                      slidesToShow={4} // default for desktop

                      responsive={[
                        {
                          breakpoint: 1024,
                          settings: {
                            slidesToShow: 3
                          }
                        },
                        {
                          breakpoint: 768,
                          settings: {
                            slidesToShow: 3
                          }
                        },
                        {
                          breakpoint: 480,
                          settings: {
                            slidesToShow: 2
                          }
                        }
                      ]}
                    >
                      <div className="rounded-xl overflow-hidden">
                        <img src="https://img.freepik.com/free-photo/book-with-green-board-background_1150-3837.jpg" alt="Thumb 1" className="w-100" />
                      </div>
                      <div className="rounded-xl overflow-hidden">
                        <img src="https://img.freepik.com/free-photo/confident-teacher-explaining-lesson-pupils_74855-9751.jpg" alt="Thumb 2" className="w-100" />
                      </div>
                      <div className="rounded-xl overflow-hidden">
                        <img src="https://img.freepik.com/free-photo/book-with-green-board-background_1150-3837.jpg" alt="Thumb 3" className="w-100" />
                      </div>
                      <div className="rounded-xl overflow-hidden">
                        <img src="https://img.freepik.com/free-photo/confident-teacher-explaining-lesson-pupils_74855-9751.jpg" alt="Thumb 2" className="w-100" />
                      </div>
                      <div className="rounded-xl overflow-hidden">
                        <img src="https://img.freepik.com/free-photo/book-with-green-board-background_1150-3837.jpg" alt="Thumb 3" className="w-100" />
                      </div>
                    </Slider>
                  </div>
                </div>

                <Slider
                  asNavFor={nav2}
                  ref={(slider) => setNav1(slider)}
                  infinite={false} 
                  arrows={false}
                  fade={true}
                  slidesToShow={1}
                  slidesToScroll={1}
                  // nextArrow={<NextArrow />}
                  // prevArrow={<PrevArrow />}
                >
                  <div className="rounded-xl overflow-hidden">
                    <img src="https://img.freepik.com/free-photo/book-with-green-board-background_1150-3837.jpg" alt="Slide 1" className="w-100" />
                  </div>
                  <div className="rounded-xl overflow-hidden">
                    <img src="https://img.freepik.com/free-photo/confident-teacher-explaining-lesson-pupils_74855-9751.jpg" alt="Slide 2" className="w-100" />
                  </div>
                  <div className="rounded-xl overflow-hidden">
                    <img src="https://img.freepik.com/free-photo/book-with-green-board-background_1150-3837.jpg" alt="Slide 3" className="w-100" />
                  </div>
                  <div className="rounded-xl overflow-hidden">
                    <img src="https://img.freepik.com/free-photo/confident-teacher-explaining-lesson-pupils_74855-9751.jpg" alt="Slide 2" className="w-100" />
                  </div>
                  <div className="rounded-xl overflow-hidden">
                    <img src="https://img.freepik.com/free-photo/book-with-green-board-background_1150-3837.jpg" alt="Thumb 3" className="w-100" />
                  </div>
                </Slider>
              </div>
            </div>

          </div>
          <div className="col-lg-4 col-md-5 col-sm-12 col-12">
            <div className="d-flex flex-column h-100 bg-grey-50 px-3">
              <Tab.Container activeKey={activeKey2} onSelect={(k) => setActiveKey2(k)} className="h-100 overflow-auto">
                <Nav variant="tabs">
                  <Nav.Item>
                    <Nav.Link eventKey="participant">Participant</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="chat-room">Chat Room</Nav.Link>
                  </Nav.Item>
                </Nav>
                <Tab.Content className="h-100 bg-transparent">
                  <Tab.Pane eventKey="participant">
                    <ul className="participant-list mb-0 list-unstyled d-flex flex-column h-100 overflow-auto">
                      <li>
                        <div className="d-flex align-items-center gap-2 py-2">
                          <div className="flex-auto w-10 h-10 rounded-circle overflow-hidden bg-primary-800 d-flex justify-content-center align-items-center">
                            <img src="../assets/images/avatars/5.jpg" alt="" className="w-100 h-100 object-fit-cover" />
                          </div>
                          <div>
                            <span className="participant-name font-medium text-grey-600">Mélanie Lejeune</span>
                          </div>
                          <div className="ms-auto">
                            <ul className="chatroom-action-list list-unstyled d-flex align-items-center gap-2">
                              <li>
                                <span>Host</span>
                              </li>
                              <li>
                                <button type="button" className="text-xl d-flex justify-content-center align-items-center border-0 bg-transparent">
                                  <i className="bx bx-microphone"></i>
                                </button>
                              </li>
                              <li>
                                <button type="button" className="text-xl d-flex justify-content-center align-items-center border-0 bg-transparent">
                                  <i className="bx bx-video"></i>
                                </button>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="d-flex align-items-center gap-2 py-2">
                          <div className="flex-auto w-10 h-10 rounded-circle overflow-hidden bg-primary-800 d-flex justify-content-center align-items-center">
                            <img src="../assets/images/avatars/12.jpg" alt="" className="w-100 h-100 object-fit-cover" />
                          </div>
                          <div>
                            <span className="participant-name font-medium text-grey-600">Oscar Sørensen</span>
                          </div>
                          <div className="ms-auto">
                            <ul className="chatroom-action-list list-unstyled d-flex align-items-center gap-2">
                              <li>
                                <button type="button" className="text-xl d-flex justify-content-center align-items-center border-0 bg-transparent btn-disable">
                                  <i className="bx bx-microphone-off"></i>
                                </button>
                              </li>
                              <li>
                                <button type="button" className="text-xl d-flex justify-content-center align-items-center border-0 bg-transparent">
                                  <i className="bx bx-video"></i>
                                </button>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="d-flex align-items-center gap-2 py-2">
                          <div className="flex-auto w-10 h-10 rounded-circle overflow-hidden bg-primary-800 d-flex justify-content-center align-items-center">
                            <img src="../assets/images/avatars/8.jpg" alt="" className="w-100 h-100 object-fit-cover" />
                          </div>
                          <div>
                            <span className="participant-name font-medium text-grey-600">Tammy Chapman</span>
                          </div>
                          <div className="ms-auto">
                            <ul className="chatroom-action-list list-unstyled d-flex align-items-center gap-2">
                              <li>
                                <button type="button" className="text-xl d-flex justify-content-center align-items-center border-0 bg-transparent">
                                  <i className="bx bx-microphone"></i>
                                </button>
                              </li>
                              <li>
                                <button type="button" className="text-xl d-flex justify-content-center align-items-center border-0 bg-transparent btn-disable">
                                  <i className="bx bx-video-off"></i>
                                </button>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="d-flex align-items-center gap-2 py-2">
                          <div className="flex-auto w-10 h-10 rounded-circle overflow-hidden bg-primary-800 d-flex justify-content-center align-items-center">
                            <img src="../assets/images/avatars/9.jpg" alt="" className="w-100 h-100 object-fit-cover" />
                          </div>
                          <div>
                            <span className="participant-name font-medium text-grey-600">Antoine Bouvier</span>
                          </div>
                          <div className="ms-auto">
                            <ul className="chatroom-action-list list-unstyled d-flex align-items-center gap-2">
                              <li>
                                <button type="button" className="text-xl d-flex justify-content-center align-items-center border-0 bg-transparent">
                                  <i className="bx bx-microphone"></i>
                                </button>
                              </li>
                              <li>
                                <button type="button" className="text-xl d-flex justify-content-center align-items-center border-0 bg-transparent btn-disable">
                                  <i className="bx bx-video-off"></i>
                                </button>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="d-flex align-items-center gap-2 py-2">
                          <div className="flex-auto w-10 h-10 rounded-circle overflow-hidden bg-primary-800 d-flex justify-content-center align-items-center">
                            <img src="../assets/images/avatars/10.jpg" alt="" className="w-100 h-100 object-fit-cover" />
                          </div>
                          <div>
                            <span className="participant-name font-medium text-grey-600">Macéo Renault</span>
                          </div>
                          <div className="ms-auto">
                            <ul className="chatroom-action-list list-unstyled d-flex align-items-center gap-2">
                              <li>
                                <button type="button" className="text-xl d-flex justify-content-center align-items-center border-0 bg-transparent btn-disable">
                                  <i className="bx bx-microphone-off"></i>
                                </button>
                              </li>
                              <li>
                                <button type="button" className="text-xl d-flex justify-content-center align-items-center border-0 bg-transparent">
                                  <i className="bx bx-video"></i>
                                </button>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="d-flex align-items-center gap-2 py-2">
                          <div className="flex-auto w-10 h-10 rounded-circle overflow-hidden bg-primary-800 d-flex justify-content-center align-items-center">
                            <img src="../assets/images/avatars/11.jpg" alt="" className="w-100 h-100 object-fit-cover" />
                          </div>
                          <div>
                            <span className="participant-name font-medium text-grey-600">Paul Wolf</span>
                          </div>
                          <div className="ms-auto">
                            <ul className="chatroom-action-list list-unstyled d-flex align-items-center gap-2">
                              <li>
                                <button type="button" className="text-xl d-flex justify-content-center align-items-center border-0 bg-transparent btn-disable">
                                  <i className="bx bx-microphone-off"></i>
                                </button>
                              </li>
                              <li>
                                <button type="button" className="text-xl d-flex justify-content-center align-items-center border-0 bg-transparent">
                                  <i className="bx bx-video"></i>
                                </button>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </li>


                      <li>
                        <div className="d-flex align-items-center gap-2 py-2">
                          <div className="flex-auto w-10 h-10 rounded-circle overflow-hidden bg-primary-800 d-flex justify-content-center align-items-center">
                            <img src="../assets/images/avatars/5.jpg" alt="" className="w-100 h-100 object-fit-cover" />
                          </div>
                          <div>
                            <span className="participant-name font-medium text-grey-600">Mélanie Lejeune</span>
                          </div>
                          <div className="ms-auto">
                            <ul className="chatroom-action-list list-unstyled d-flex align-items-center gap-2">
                              <li>
                                <button type="button" className="text-xl d-flex justify-content-center align-items-center border-0 bg-transparent btn-disable">
                                  <i className="bx bx-microphone-off"></i>
                                </button>
                              </li>
                              <li>
                                <button type="button" className="text-xl d-flex justify-content-center align-items-center border-0 bg-transparent">
                                  <i className="bx bx-video"></i>
                                </button>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="d-flex align-items-center gap-2 py-2">
                          <div className="flex-auto w-10 h-10 rounded-circle overflow-hidden bg-primary-800 d-flex justify-content-center align-items-center">
                            <img src="../assets/images/avatars/12.jpg" alt="" className="w-100 h-100 object-fit-cover" />
                          </div>
                          <div>
                            <span className="participant-name font-medium text-grey-600">Oscar Sørensen</span>
                          </div>
                          <div className="ms-auto">
                            <ul className="chatroom-action-list list-unstyled d-flex align-items-center gap-2">
                              <li>
                                <button type="button" className="text-xl d-flex justify-content-center align-items-center border-0 bg-transparent btn-disable">
                                  <i className="bx bx-microphone-off"></i>
                                </button>
                              </li>
                              <li>
                                <button type="button" className="text-xl d-flex justify-content-center align-items-center border-0 bg-transparent">
                                  <i className="bx bx-video"></i>
                                </button>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="d-flex align-items-center gap-2 py-2">
                          <div className="flex-auto w-10 h-10 rounded-circle overflow-hidden bg-primary-800 d-flex justify-content-center align-items-center">
                            <img src="../assets/images/avatars/8.jpg" alt="" className="w-100 h-100 object-fit-cover" />
                          </div>
                          <div>
                            <span className="participant-name font-medium text-grey-600">Tammy Chapman</span>
                          </div>
                          <div className="ms-auto">
                            <ul className="chatroom-action-list list-unstyled d-flex align-items-center gap-2">
                              <li>
                                <button type="button" className="text-xl d-flex justify-content-center align-items-center border-0 bg-transparent">
                                  <i className="bx bx-microphone"></i>
                                </button>
                              </li>
                              <li>
                                <button type="button" className="text-xl d-flex justify-content-center align-items-center border-0 bg-transparent btn-disable">
                                  <i className="bx bx-video-off"></i>
                                </button>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="d-flex align-items-center gap-2 py-2">
                          <div className="flex-auto w-10 h-10 rounded-circle overflow-hidden bg-primary-800 d-flex justify-content-center align-items-center">
                            <img src="../assets/images/avatars/9.jpg" alt="" className="w-100 h-100 object-fit-cover" />
                          </div>
                          <div>
                            <span className="participant-name font-medium text-grey-600">Antoine Bouvier</span>
                          </div>
                          <div className="ms-auto">
                            <ul className="chatroom-action-list list-unstyled d-flex align-items-center gap-2">
                              <li>
                                <button type="button" className="text-xl d-flex justify-content-center align-items-center border-0 bg-transparent">
                                  <i className="bx bx-microphone"></i>
                                </button>
                              </li>
                              <li>
                                <button type="button" className="text-xl d-flex justify-content-center align-items-center border-0 bg-transparent btn-disable">
                                  <i className="bx bx-video-off"></i>
                                </button>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="d-flex align-items-center gap-2 py-2">
                          <div className="flex-auto w-10 h-10 rounded-circle overflow-hidden bg-primary-800 d-flex justify-content-center align-items-center">
                            <img src="../assets/images/avatars/10.jpg" alt="" className="w-100 h-100 object-fit-cover" />
                          </div>
                          <div>
                            <span className="participant-name font-medium text-grey-600">Macéo Renault</span>
                          </div>
                          <div className="ms-auto">
                            <ul className="chatroom-action-list list-unstyled d-flex align-items-center gap-2">
                              <li>
                                <button type="button" className="text-xl d-flex justify-content-center align-items-center border-0 bg-transparent btn-disable">
                                  <i className="bx bx-microphone-off"></i>
                                </button>
                              </li>
                              <li>
                                <button type="button" className="text-xl d-flex justify-content-center align-items-center border-0 bg-transparent">
                                  <i className="bx bx-video"></i>
                                </button>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="d-flex align-items-center gap-2 py-2">
                          <div className="flex-auto w-10 h-10 rounded-circle overflow-hidden bg-primary-800 d-flex justify-content-center align-items-center">
                            <img src="../assets/images/avatars/11.jpg" alt="" className="w-100 h-100 object-fit-cover" />
                          </div>
                          <div>
                            <span className="participant-name font-medium text-grey-600">Paul Wolf</span>
                          </div>
                          <div className="ms-auto">
                            <ul className="chatroom-action-list list-unstyled d-flex align-items-center gap-2">
                              <li>
                                <button type="button" className="text-xl d-flex justify-content-center align-items-center border-0 bg-transparent btn-disable">
                                  <i className="bx bx-microphone-off"></i>
                                </button>
                              </li>
                              <li>
                                <button type="button" className="text-xl d-flex justify-content-center align-items-center border-0 bg-transparent">
                                  <i className="bx bx-video"></i>
                                </button>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="d-flex align-items-center gap-2 py-2">
                          <div className="flex-auto w-10 h-10 rounded-circle overflow-hidden bg-primary-800 d-flex justify-content-center align-items-center">
                            <img src="../assets/images/avatars/5.jpg" alt="" className="w-100 h-100 object-fit-cover" />
                          </div>
                          <div>
                            <span className="participant-name font-medium text-grey-600">Mélanie Lejeune</span>
                          </div>
                          <div className="ms-auto">
                            <ul className="chatroom-action-list list-unstyled d-flex align-items-center gap-2">
                              <li>
                                <button type="button" className="text-xl d-flex justify-content-center align-items-center border-0 bg-transparent btn-disable">
                                  <i className="bx bx-microphone-off"></i>
                                </button>
                              </li>
                              <li>
                                <button type="button" className="text-xl d-flex justify-content-center align-items-center border-0 bg-transparent">
                                  <i className="bx bx-video"></i>
                                </button>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="d-flex align-items-center gap-2 py-2">
                          <div className="flex-auto w-10 h-10 rounded-circle overflow-hidden bg-primary-800 d-flex justify-content-center align-items-center">
                            <img src="../assets/images/avatars/12.jpg" alt="" className="w-100 h-100 object-fit-cover" />
                          </div>
                          <div>
                            <span className="participant-name font-medium text-grey-600">Oscar Sørensen</span>
                          </div>
                          <div className="ms-auto">
                            <ul className="chatroom-action-list list-unstyled d-flex align-items-center gap-2">
                              <li>
                                <button type="button" className="text-xl d-flex justify-content-center align-items-center border-0 bg-transparent btn-disable">
                                  <i className="bx bx-microphone-off"></i>
                                </button>
                              </li>
                              <li>
                                <button type="button" className="text-xl d-flex justify-content-center align-items-center border-0 bg-transparent">
                                  <i className="bx bx-video"></i>
                                </button>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="d-flex align-items-center gap-2 py-2">
                          <div className="flex-auto w-10 h-10 rounded-circle overflow-hidden bg-primary-800 d-flex justify-content-center align-items-center">
                            <img src="../assets/images/avatars/8.jpg" alt="" className="w-100 h-100 object-fit-cover" />
                          </div>
                          <div>
                            <span className="participant-name font-medium text-grey-600">Tammy Chapman</span>
                          </div>
                          <div className="ms-auto">
                            <ul className="chatroom-action-list list-unstyled d-flex align-items-center gap-2">
                              <li>
                                <button type="button" className="text-xl d-flex justify-content-center align-items-center border-0 bg-transparent">
                                  <i className="bx bx-microphone"></i>
                                </button>
                              </li>
                              <li>
                                <button type="button" className="text-xl d-flex justify-content-center align-items-center border-0 bg-transparent btn-disable">
                                  <i className="bx bx-video-off"></i>
                                </button>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="d-flex align-items-center gap-2 py-2">
                          <div className="flex-auto w-10 h-10 rounded-circle overflow-hidden bg-primary-800 d-flex justify-content-center align-items-center">
                            <img src="../assets/images/avatars/9.jpg" alt="" className="w-100 h-100 object-fit-cover" />
                          </div>
                          <div>
                            <span className="participant-name font-medium text-grey-600">Antoine Bouvier</span>
                          </div>
                          <div className="ms-auto">
                            <ul className="chatroom-action-list list-unstyled d-flex align-items-center gap-2">
                              <li>
                                <button type="button" className="text-xl d-flex justify-content-center align-items-center border-0 bg-transparent">
                                  <i className="bx bx-microphone"></i>
                                </button>
                              </li>
                              <li>
                                <button type="button" className="text-xl d-flex justify-content-center align-items-center border-0 bg-transparent btn-disable">
                                  <i className="bx bx-video-off"></i>
                                </button>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="d-flex align-items-center gap-2 py-2">
                          <div className="flex-auto w-10 h-10 rounded-circle overflow-hidden bg-primary-800 d-flex justify-content-center align-items-center">
                            <img src="../assets/images/avatars/10.jpg" alt="" className="w-100 h-100 object-fit-cover" />
                          </div>
                          <div>
                            <span className="participant-name font-medium text-grey-600">Macéo Renault</span>
                          </div>
                          <div className="ms-auto">
                            <ul className="chatroom-action-list list-unstyled d-flex align-items-center gap-2">
                              <li>
                                <button type="button" className="text-xl d-flex justify-content-center align-items-center border-0 bg-transparent btn-disable">
                                  <i className="bx bx-microphone-off"></i>
                                </button>
                              </li>
                              <li>
                                <button type="button" className="text-xl d-flex justify-content-center align-items-center border-0 bg-transparent">
                                  <i className="bx bx-video"></i>
                                </button>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="d-flex align-items-center gap-2 py-2">
                          <div className="flex-auto w-10 h-10 rounded-circle overflow-hidden bg-primary-800 d-flex justify-content-center align-items-center">
                            <img src="../assets/images/avatars/11.jpg" alt="" className="w-100 h-100 object-fit-cover" />
                          </div>
                          <div>
                            <span className="participant-name font-medium text-grey-600">Paul Wolf</span>
                          </div>
                          <div className="ms-auto">
                            <ul className="chatroom-action-list list-unstyled d-flex align-items-center gap-2">
                              <li>
                                <button type="button" className="text-xl d-flex justify-content-center align-items-center border-0 bg-transparent btn-disable">
                                  <i className="bx bx-microphone-off"></i>
                                </button>
                              </li>
                              <li>
                                <button type="button" className="text-xl d-flex justify-content-center align-items-center border-0 bg-transparent">
                                  <i className="bx bx-video"></i>
                                </button>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </li>
                    </ul>
                    <div className="mt-auto pt-3 d-flex justify-content-center align-items-center gap-2 border-top border-grey-200">
                      <button className="btn text-primary-500 bg-primary-50 border-primary-200 d-inline-flex align-items-center gap-1"><i className="bx bx-user-plus text-lg"></i> Invite</button>
                      <button className="btn text-primary-500 bg-primary-50 border-primary-200 d-inline-flex align-items-center gap-1"><i className="bx bx-microphone-off text-lg"></i> Mute All</button>
                    </div>
                  </Tab.Pane>
                  <Tab.Pane eventKey="chat-room" className="h-100">
                    <div className="chat-room d-flex flex-column justify-content-end h-100">
                      <div className="chatbox-body">
                          <ul>                              
                              <li className="my_message">
                                  <div className="messageboard_box">
                                      <div className="avatar-image">
                                          <img src="../assets/images/avatars/10.jpg" alt="" />
                                      </div>
                                      <div className="message_text">
                                          <p>Gender graph of Applied Physics filed</p>
                                      </div>
                                  </div>
                              </li>
                              <li className="client_message">
                                  <div className="messageboard_box">
                                      <div className="avatar-image">
                                          <img src="../assets/images/icons/pluto-bot_icon.svg" alt="" />
                                      </div>
                                      <div className="message_text">
                                          <p>Gender Ratio Graph for Applied Physics</p>
                                      </div>
                                  </div>
                              </li>
                              <li className="my_message">
                                  <div className="messageboard_box">
                                      <div className="avatar-image">
                                          <img src="../assets/images/avatars/10.jpg" alt="" />
                                      </div>
                                      <div className="message_text">
                                          <p>Application No #JU12565829</p>
                                      </div>
                                  </div>
                              </li>
                          </ul>
                      </div>
                      <div className="chatbox-footer">
                          <div className="position-relative">
                            <button type="button" className="w-10 input-group-text position-absolute top-1 bottom-1 left-1 rounded-lg bg-grey-50 d-flex justify-content-center align-items-center">
                              <i className="bx bx-paperclip"></i>
                            </button>
                            <input type="text" className="form-control rounded-xl py-3 px-12" />
                            <button type="button" className="w-10 input-group-text position-absolute top-1 bottom-1 right-1 rounded-lg bg-primary-800 d-flex justify-content-center align-items-center">
                              <i className="bx bxs-send"></i>
                            </button>
                          </div>
                      </div>
                  </div>
                  </Tab.Pane>
                </Tab.Content>
              </Tab.Container>
              
            </div>
          </div>
        </div>
      </div>

      <div className="mb-5">
        <div className="d-flex flex-sm-row flex-column flex-sm-nowrap align-items-center gap-3 mb-3">
          <div className="position-relative w-100">
            <input type="text" className="form-control py-3 pr-24 rounded-xl" placeholder="Paste Meeting Link Here" />
            <button className="btn btn-gray-light position-absolute top-1 bottom-1 right-1 rounded-lg px-5 font-medium">Join</button>
          </div>
          <div className="font-medium text-grey-400 text-nowrap">- Or -</div>
          <button className="btn btn-primary px-5 py-2-5 d-inline-flex align-items-center gap-1 text-nowrap rounded-lg" onClick={() => setNewMeeting(true)}><i className="bx bx-plus-circle bx-sm"></i> New Meeting</button>
        </div>

        <div className="pb-3 d-flex flex-wrap justify-content-between align-items-center">
          <h3 className="mb-0 text-base font-semibold">Upcoming Meeting</h3>
          <button type="button" className="w-10 h-10 d-flex justify-content-center align-items-center p-3 text-primary-500 rounded-lg border border-primary-200 bg-primary-50">
            <i className="bx bx-calendar bx-sm leading-3"></i>
          </button>
        </div>

        <Modal show={NewMeeting}
        onHide={() => setNewMeeting(false)}>
          <Modal.Header closeButton>
            <Modal.Title className="text-md font-medium">Meeting Name</Modal.Title>
          </Modal.Header>
          <Modal.Body>

            <Tab.Container activeKey={activeScheduleTab} onSelect={(k) => setActiveScheduleTab(k)}>
              <Nav variant="pills" className="gap-2">
                <Nav.Item>
                  <Nav.Link eventKey="startMeeting">Start Meeting</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="schedule">Schedule</Nav.Link>
                </Nav.Item>
              </Nav>
              <Tab.Content>
                <Tab.Pane eventKey="startMeeting">
                  <div>
                    <Tab.Container activeKey={activeMeetingTab} onSelect={(k) => setActiveMeetingTab(k)}>
                      <Nav variant="tabs">
                        <Nav.Item>
                          <Nav.Link eventKey="about">
                            About
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="addParticipants">
                            Add Participants
                          </Nav.Link>
                        </Nav.Item>
                      </Nav>

                      <Tab.Content>
                        <Tab.Pane eventKey="about" className="py-3">
                          <Row>
                            <Col lg={12} md={12} sm={12} xs={12}>
                              <div className="mb-3">
                                <label for="meetingName" className="form-label">Meeting Name</label>
                                <input type="text" className="form-control" id="meetingName" />
                              </div>
                            </Col>
                            <Col lg={6} md={6} sm={12} xs={12}>
                              <div className="mb-3">
                                <label for="meetingDate" className="form-label">Date</label>
                                <input type="date" className="form-control" id="meetingDate" />
                              </div>
                            </Col>
                            <Col lg={6} md={6} sm={12} xs={12}>
                              <div className="mb-3">
                                <label for="meetingTime" className="form-label">Time</label>
                                <select className="form-select" id="meetingTime">
                                  <option value="1" selected>00:00</option>
                                  <option value="2">00:30</option>
                                  <option value="3">01:00</option>
                                  <option value="4">01:30</option>
                                  <option value="5">02:00</option>
                                  <option value="6">02:30</option>
                                  <option value="7">03:00</option>
                                  <option value="8">03:30</option>
                                  <option value="9">04:00</option>
                                  <option value="10">04:30</option>
                                </select>

                              </div>
                            </Col>
                            <Col lg={12} md={12} sm={12} xs={12}>
                              <div className="mb-3">
                                <label for="meetingNotes" className="form-label">Notes(If any)</label>
                                <textarea className="form-control resize-none" id="meetingNotes" placeholder="Add Note" rows={6}></textarea>
                              </div>
                            </Col>
                          </Row>
                        </Tab.Pane>
                        <Tab.Pane eventKey="addParticipants" className="py-3">
                          <div className="search-box2 position-relative mb-3">
                            <input type="search" className="form-control pl-10" />
                            <span className="search-icons position-absolute top-0 bottom-0 start-0 w-10 d-flex justify-content-center align-items-center"><i className="pluto-search"></i></span>
                          </div>

                          <ul className="list-unstyled d-flex flex-column row-gap-3 mb-0">
                            <li>
                              <div class="d-flex align-items-center gap-2">
                                <div class="flex-auto avatar-img w-10 h-10 bg-purple-600">
                                  <img src="../assets/images/avatars/8.jpg" alt="" class="w-100 h-100 object-fit-cover"/>
                                </div>
                                <div>
                                  <h4 class="mb-0 text-sm">Reena James</h4>
                                  <span className="text-xs font-medium text-grey-500">Product Designer</span>
                                </div>
                                <button type="button" class="btn btn-light ms-auto">Add</button>
                              </div>
                            </li>
                            <li>
                              <div class="d-flex align-items-center gap-2">
                                <div class="flex-auto avatar-img w-10 h-10 bg-purple-600">
                                  <img src="../assets/images/avatars/8.jpg" alt="" class="w-100 h-100 object-fit-cover"/>
                                </div>
                                <div>
                                  <h4 class="mb-0 text-sm">Reena James</h4>
                                  <span className="text-xs font-medium text-grey-500">Product Designer</span>
                                </div>
                                <button type="button" class="btn btn-light ms-auto">Add</button>
                              </div>
                            </li>
                            <li>
                              <div class="d-flex align-items-center gap-2">
                                <div class="flex-auto avatar-img w-10 h-10 bg-purple-600">
                                  <img src="../assets/images/avatars/8.jpg" alt="" class="w-100 h-100 object-fit-cover"/>
                                </div>
                                <div>
                                  <h4 class="mb-0 text-sm">Reena James</h4>
                                  <span className="text-xs font-medium text-grey-500">Product Designer</span>
                                </div>
                                <button type="button" class="btn btn-light ms-auto">Add</button>
                              </div>
                            </li>
                            <li>
                              <div class="d-flex align-items-center gap-2">
                                <div class="flex-auto avatar-img w-10 h-10 bg-purple-600">
                                  <img src="../assets/images/avatars/8.jpg" alt="" class="w-100 h-100 object-fit-cover"/>
                                </div>
                                <div>
                                  <h4 class="mb-0 text-sm">Reena James</h4>
                                  <span className="text-xs font-medium text-grey-500">Product Designer</span>
                                </div>
                                <button type="button" class="btn btn-light ms-auto">Add</button>
                              </div>
                            </li>
                            <li>
                              <div class="d-flex align-items-center gap-2">
                                <div class="flex-auto avatar-img w-10 h-10 bg-purple-600">
                                  <img src="../assets/images/avatars/8.jpg" alt="" class="w-100 h-100 object-fit-cover"/>
                                </div>
                                <div>
                                  <h4 class="mb-0 text-sm">Reena James</h4>
                                  <span className="text-xs font-medium text-grey-500">Product Designer</span>
                                </div>
                                <button type="button" class="btn btn-light ms-auto">Add</button>
                              </div>
                            </li>
                            <li>
                              <div class="d-flex align-items-center gap-2">
                                <div class="flex-auto avatar-img w-10 h-10 bg-purple-600">
                                  <img src="../assets/images/avatars/8.jpg" alt="" class="w-100 h-100 object-fit-cover"/>
                                </div>
                                <div>
                                  <h4 class="mb-0 text-sm">Reena James</h4>
                                  <span className="text-xs font-medium text-grey-500">Product Designer</span>
                                </div>
                                <button type="button" class="btn btn-light ms-auto">Add</button>
                              </div>
                            </li>
                          </ul>
                        </Tab.Pane>
                      </Tab.Content>
                    </Tab.Container>
                  </div>
                </Tab.Pane>
                <Tab.Pane eventKey="schedule" className="mt-3">
                  <Row>
                    <Col lg={12} md={12} sm={12} xs={12}>
                      <div className="mb-3">
                        <label for="meetingName" className="form-label">Event name <span className="text-red-500">*</span></label>
                        <input type="text" className="form-control" id="meetingName" />
                      </div>
                    </Col>
                    <Col lg={12} md={12} sm={12} xs={12}>
                      <div className="mb-3">
                        <label for="meetingNotes" className="form-label">Notes</label>
                        <textarea className="form-control resize-none" id="meetingNotes" placeholder="Type the note here..." rows={6}></textarea>
                      </div>
                    </Col>
                    <Col lg={12} md={12} sm={12} xs={12}>
                      <div className="mb-3">
                        <label for="meetingDate" className="form-label">Date</label>
                        <input type="date" className="form-control" id="meetingDate" />
                      </div>
                    </Col>
                    <Col lg={6} md={6} sm={12} xs={12}>
                      <div className="mb-3">
                        <label for="meetinStartTime" className="form-label">Start Time</label>
                        <input type="time" className="form-control" id="meetingDate" />
                      </div>
                    </Col>
                    <Col lg={6} md={6} sm={12} xs={12}>
                      <div className="mb-3">
                        <label for="meetinEndTime" className="form-label">End Time</label>
                        <input type="time" className="form-control" id="meetingDate" />
                      </div>
                    </Col>
                    <Col lg={12} md={12} sm={12} xs={12}>
                      <div className="mb-3">
                        <label for="meetingTime" className="form-label">Select a time zone</label>
                        <select className="form-select" id="meetingTime" defaultValue="">
                          <option value="" disabled>Open this select zone</option>
                          <option value="UTC">UTC</option>
                          <option value="Asia/Kolkata">Asia/Kolkata (India Standard Time)</option>
                          <option value="Asia/Dubai">Asia/Dubai (Gulf Standard Time)</option>
                          <option value="Asia/Singapore">Asia/Singapore</option>
                          <option value="Asia/Tokyo">Asia/Tokyo</option>
                          <option value="Europe/London">Europe/London (GMT)</option>
                          <option value="Europe/Berlin">Europe/Berlin (Central European Time)</option>
                          <option value="America/New_York">America/New_York (Eastern Time)</option>
                          <option value="America/Chicago">America/Chicago (Central Time)</option>
                          <option value="America/Denver">America/Denver (Mountain Time)</option>
                          <option value="America/Los_Angeles">America/Los_Angeles (Pacific Time)</option>
                          <option value="Australia/Sydney">Australia/Sydney</option>
                        </select>
                      </div>
                    </Col>

                    <Col lg={12} md={12} sm={12} xs={12}>
                      <div className="mb-3">
                        <label for="meetingDate" className="form-label">Add people</label>
                        <input type="text" className="form-control" id="meetingDate" />
                      </div>
                    </Col>

                    <Col lg={12} md={12} sm={12} xs={12}>
                      <div className="mb-3">
                        <label for="meetingDate" className="form-label">Notify me 30 min before meeting</label>
                        <input type="text" className="form-control" id="meetingDate" />
                      </div>
                    </Col>

                    <Col lg={12} md={12} sm={12} xs={12}>
                      <div className="mb-3">
                        <label for="Addattachment" className="form-label">Add attachment</label>
                        <div className="input-group">
                        <input type="file" className="form-control" id="Addattachment" />
                        {/* <label className="input-group-text" htmlFor="inputGroupFile">Upload</label> */}
                      </div>

                      </div>
                    </Col>
                    
                  </Row>
                </Tab.Pane>
              </Tab.Content>
            </Tab.Container>            
            
          </Modal.Body>

          <hr className="my-0" />
          <Modal.Header closeButton>
            <Modal.Title className="text-md font-medium">Project Meeting</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col lg={12} md={12} sm={12} xs={12}>
                <div className="mb-3">
                  <label for="MeetingLink" className="form-label">Meeting Link</label>
                  <div className="input-group">
                    <input type="text" className="form-control" id="MeetingLink" placeholder="https://link/xyz/meet" />
                    <button type="button" className="input-group-text" htmlFor="inputGroupFile">Copy</button>
                  </div>
                </div>
              </Col>              
            </Row>
          </Modal.Body>

          {/* <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
            <Button variant="primary" onClick={handleClose}>
              Save Changes
            </Button>
          </Modal.Footer> */}
        </Modal>

        <div className="upcoming-slider">
          <Slider {...upcomingslider}>
            <div className="border border-grey-200 success rounded-2 bg-white overflow-hidden">
              <div className="p-3 border-bottom">
                <div className="d-flex align-items-center row-gap-3 mb-1">
                  <h4 className="text-sm mb-0 me-3 text-grey-800">Project Discussion XYZ</h4>
                  <div className="ms-auto">
                    <button
                      className="button bg-transparent border-0 d-flex align-items-center text-primary-500"
                      type="button"
                    >
                      <i className="bx bx-bell bx-sm"></i>
                    </button>
                  </div>
                </div>
                <div>
                  <ul className="list-unstyled d-inline-flex gap-2 text-grey-400 mb-0">
                    <li>Wednesday, 25th June</li>
                    <li>|</li>
                    <li>12:00 - 12:30pm</li>
                  </ul>
                </div>
              </div>
              <div className="p-3 border-bottom">
                <div className="d-flex flex-column mb-1">
                  <span className="text-xs text-grey-600">Participants</span>

                  <div className="d-flex align-items-center">
                    <div className="avatar-group d-flex align-items-center -space-x-3">
                      <div className="avatar rounded-full border-2 border-white bg-primary d-flex justify-content-center align-items-center flex-shrink-0 flex-grow-0 w-8 h-8 overflow-hidden border border-2 border-white bg-grey-100">
                        <img src="../assets/images/avatars/8.jpg" alt="Avatar 1" className="w-full h-full object-cover" />
                      </div>
                      <div className="avatar rounded-full border-2 border-white bg-primary d-flex justify-content-center align-items-center flex-shrink-0 flex-grow-0 w-8 h-8 overflow-hidden border border-2 border-white bg-grey-100">
                        <img src="../assets/images/avatars/6.jpg" alt="Avatar 1" className="w-full h-full object-cover" />
                      </div>
                      <div className="avatar rounded-full border-2 border-white bg-primary d-flex justify-content-center align-items-center flex-shrink-0 flex-grow-0 w-8 h-8 overflow-hidden border border-2 border-white bg-grey-100">
                        <img src="../assets/images/avatars/5.jpg" alt="Avatar 1" className="w-full h-full object-cover" />
                      </div>
                      <div className="avatar rounded-full border-2 border-white bg-primary d-flex justify-content-center align-items-center flex-shrink-0 flex-grow-0 w-8 h-8 overflow-hidden border border-2 border-white bg-grey-100">
                        <img src="../assets/images/avatars/10.jpg" alt="Avatar 1" className="w-full h-full object-cover" />
                      </div>
                      <div className="avatar text-xs fw-medium text-grey-500 d-flex justify-content-center align-items-center flex-shrink-0 flex-grow-0 w-8 h-8 rounded-full border border-2 border-white bg-grey-100">+4</div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="p-3">
                <p className="mb-0 fonty-medium">Notes</p>
                <p className="line-clamp-3 text-grey-500">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>
                <button className="btn text-primary-500 bg-primary-50 border-primary-200 d-block w-100">Join Meeting</button>
              </div>
              <div className="status-line"></div>
            </div>
            <div className="border border-grey-200 success rounded-2 bg-white overflow-hidden">
              <div className="p-3 border-bottom">
                <div className="d-flex align-items-center row-gap-3 mb-1">
                  <h4 className="text-sm mb-0 me-3 text-grey-800">Project Discussion XYZ</h4>
                  <div className="ms-auto">
                    <button
                      className="button bg-transparent border-0 d-flex align-items-center text-primary-500"
                      type="button"
                    >
                      <i className="bx bx-bell bx-sm"></i>
                    </button>
                  </div>
                </div>
                <div>
                  <ul className="list-unstyled d-inline-flex gap-2 text-grey-400 mb-0">
                    <li>Wednesday, 25th June</li>
                    <li>|</li>
                    <li>12:00 - 12:30pm</li>
                  </ul>
                </div>
              </div>
              <div className="p-3 border-bottom">
                <div className="d-flex flex-column mb-1">
                  <span className="text-xs text-grey-600">Participants</span>

                  <div className="d-flex align-items-center">
                    <div className="avatar-group d-flex align-items-center -space-x-3">
                      <div className="avatar rounded-full border-2 border-white bg-primary d-flex justify-content-center align-items-center flex-shrink-0 flex-grow-0 w-8 h-8 overflow-hidden border border-2 border-white bg-grey-100">
                        <img src="../assets/images/avatars/8.jpg" alt="Avatar 1" className="w-full h-full object-cover" />
                      </div>
                      <div className="avatar rounded-full border-2 border-white bg-primary d-flex justify-content-center align-items-center flex-shrink-0 flex-grow-0 w-8 h-8 overflow-hidden border border-2 border-white bg-grey-100">
                        <img src="../assets/images/avatars/6.jpg" alt="Avatar 1" className="w-full h-full object-cover" />
                      </div>
                      <div className="avatar rounded-full border-2 border-white bg-primary d-flex justify-content-center align-items-center flex-shrink-0 flex-grow-0 w-8 h-8 overflow-hidden border border-2 border-white bg-grey-100">
                        <img src="../assets/images/avatars/5.jpg" alt="Avatar 1" className="w-full h-full object-cover" />
                      </div>
                      <div className="avatar rounded-full border-2 border-white bg-primary d-flex justify-content-center align-items-center flex-shrink-0 flex-grow-0 w-8 h-8 overflow-hidden border border-2 border-white bg-grey-100">
                        <img src="../assets/images/avatars/10.jpg" alt="Avatar 1" className="w-full h-full object-cover" />
                      </div>
                      <div className="avatar text-xs fw-medium text-grey-500 d-flex justify-content-center align-items-center flex-shrink-0 flex-grow-0 w-8 h-8 rounded-full border border-2 border-white bg-grey-100">+4</div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="p-3">
                <p className="mb-0 fonty-medium">Notes</p>
                <p className="line-clamp-3 text-grey-500">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>
                <button className="btn text-primary-500 bg-primary-50 border-primary-200 d-block w-100">Join Meeting</button>
              </div>
              <div className="status-line"></div>
            </div>
            <div className="border border-grey-200 success rounded-2 bg-white overflow-hidden">
              <div className="p-3 border-bottom">
                <div className="d-flex align-items-center row-gap-3 mb-1">
                  <h4 className="text-sm mb-0 me-3 text-grey-800">Project Discussion XYZ</h4>
                  <div className="ms-auto">
                    <button
                      className="button bg-transparent border-0 d-flex align-items-center text-primary-500"
                      type="button"
                    >
                      <i className="bx bx-bell bx-sm"></i>
                    </button>
                  </div>
                </div>
                <div>
                  <ul className="list-unstyled d-inline-flex gap-2 text-grey-400 mb-0">
                    <li>Wednesday, 25th June</li>
                    <li>|</li>
                    <li>12:00 - 12:30pm</li>
                  </ul>
                </div>
              </div>
              <div className="p-3 border-bottom">
                <div className="d-flex flex-column mb-1">
                  <span className="text-xs text-grey-600">Participants</span>

                  <div className="d-flex align-items-center">
                    <div className="avatar-group d-flex align-items-center -space-x-3">
                      <div className="avatar rounded-full border-2 border-white bg-primary d-flex justify-content-center align-items-center flex-shrink-0 flex-grow-0 w-8 h-8 overflow-hidden border border-2 border-white bg-grey-100">
                        <img src="../assets/images/avatars/8.jpg" alt="Avatar 1" className="w-full h-full object-cover" />
                      </div>
                      <div className="avatar rounded-full border-2 border-white bg-primary d-flex justify-content-center align-items-center flex-shrink-0 flex-grow-0 w-8 h-8 overflow-hidden border border-2 border-white bg-grey-100">
                        <img src="../assets/images/avatars/6.jpg" alt="Avatar 1" className="w-full h-full object-cover" />
                      </div>
                      <div className="avatar rounded-full border-2 border-white bg-primary d-flex justify-content-center align-items-center flex-shrink-0 flex-grow-0 w-8 h-8 overflow-hidden border border-2 border-white bg-grey-100">
                        <img src="../assets/images/avatars/5.jpg" alt="Avatar 1" className="w-full h-full object-cover" />
                      </div>
                      <div className="avatar rounded-full border-2 border-white bg-primary d-flex justify-content-center align-items-center flex-shrink-0 flex-grow-0 w-8 h-8 overflow-hidden border border-2 border-white bg-grey-100">
                        <img src="../assets/images/avatars/10.jpg" alt="Avatar 1" className="w-full h-full object-cover" />
                      </div>
                      <div className="avatar text-xs fw-medium text-grey-500 d-flex justify-content-center align-items-center flex-shrink-0 flex-grow-0 w-8 h-8 rounded-full border border-2 border-white bg-grey-100">+4</div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="p-3">
                <p className="mb-0 fonty-medium">Notes</p>
                <p className="line-clamp-3 text-grey-500">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>
                <button className="btn text-primary-500 bg-primary-50 border-primary-200 d-block w-100">Join Meeting</button>
              </div>
              <div className="status-line"></div>
            </div>
            <div className="border border-grey-200 success rounded-2 bg-white overflow-hidden">
              <div className="p-3 border-bottom">
                <div className="d-flex align-items-center row-gap-3 mb-1">
                  <h4 className="text-sm mb-0 me-3 text-grey-800">Project Discussion XYZ</h4>
                  <div className="ms-auto">
                    <button
                      className="button bg-transparent border-0 d-flex align-items-center text-primary-500"
                      type="button"
                    >
                      <i className="bx bx-bell bx-sm"></i>
                    </button>
                  </div>
                </div>
                <div>
                  <ul className="list-unstyled d-inline-flex gap-2 text-grey-400 mb-0">
                    <li>Wednesday, 25th June</li>
                    <li>|</li>
                    <li>12:00 - 12:30pm</li>
                  </ul>
                </div>
              </div>
              <div className="p-3 border-bottom">
                <div className="d-flex flex-column mb-1">
                  <span className="text-xs text-grey-600">Participants</span>

                  <div className="d-flex align-items-center">
                    <div className="avatar-group d-flex align-items-center -space-x-3">
                      <div className="avatar rounded-full border-2 border-white bg-primary d-flex justify-content-center align-items-center flex-shrink-0 flex-grow-0 w-8 h-8 overflow-hidden border border-2 border-white bg-grey-100">
                        <img src="../assets/images/avatars/8.jpg" alt="Avatar 1" className="w-full h-full object-cover" />
                      </div>
                      <div className="avatar rounded-full border-2 border-white bg-primary d-flex justify-content-center align-items-center flex-shrink-0 flex-grow-0 w-8 h-8 overflow-hidden border border-2 border-white bg-grey-100">
                        <img src="../assets/images/avatars/6.jpg" alt="Avatar 1" className="w-full h-full object-cover" />
                      </div>
                      <div className="avatar rounded-full border-2 border-white bg-primary d-flex justify-content-center align-items-center flex-shrink-0 flex-grow-0 w-8 h-8 overflow-hidden border border-2 border-white bg-grey-100">
                        <img src="../assets/images/avatars/5.jpg" alt="Avatar 1" className="w-full h-full object-cover" />
                      </div>
                      <div className="avatar rounded-full border-2 border-white bg-primary d-flex justify-content-center align-items-center flex-shrink-0 flex-grow-0 w-8 h-8 overflow-hidden border border-2 border-white bg-grey-100">
                        <img src="../assets/images/avatars/10.jpg" alt="Avatar 1" className="w-full h-full object-cover" />
                      </div>
                      <div className="avatar text-xs fw-medium text-grey-500 d-flex justify-content-center align-items-center flex-shrink-0 flex-grow-0 w-8 h-8 rounded-full border border-2 border-white bg-grey-100">+4</div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="p-3">
                <p className="mb-0 fonty-medium">Notes</p>
                <p className="line-clamp-3 text-grey-500">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>
                <button className="btn text-primary-500 bg-primary-50 border-primary-200 d-block w-100">Join Meeting</button>
              </div>
              <div className="status-line"></div>
            </div>
            <div className="border border-grey-200 success rounded-2 bg-white overflow-hidden">
              <div className="p-3 border-bottom">
                <div className="d-flex align-items-center row-gap-3 mb-1">
                  <h4 className="text-sm mb-0 me-3 text-grey-800">Project Discussion XYZ</h4>
                  <div className="ms-auto">
                    <button
                      className="button bg-transparent border-0 d-flex align-items-center text-primary-500"
                      type="button"
                    >
                      <i className="bx bx-bell bx-sm"></i>
                    </button>
                  </div>
                </div>
                <div>
                  <ul className="list-unstyled d-inline-flex gap-2 text-grey-400 mb-0">
                    <li>Wednesday, 25th June</li>
                    <li>|</li>
                    <li>12:00 - 12:30pm</li>
                  </ul>
                </div>
              </div>
              <div className="p-3 border-bottom">
                <div className="d-flex flex-column mb-1">
                  <span className="text-xs text-grey-600">Participants</span>

                  <div className="d-flex align-items-center">
                    <div className="avatar-group d-flex align-items-center -space-x-3">
                      <div className="avatar rounded-full border-2 border-white bg-primary d-flex justify-content-center align-items-center flex-shrink-0 flex-grow-0 w-8 h-8 overflow-hidden border border-2 border-white bg-grey-100">
                        <img src="../assets/images/avatars/8.jpg" alt="Avatar 1" className="w-full h-full object-cover" />
                      </div>
                      <div className="avatar rounded-full border-2 border-white bg-primary d-flex justify-content-center align-items-center flex-shrink-0 flex-grow-0 w-8 h-8 overflow-hidden border border-2 border-white bg-grey-100">
                        <img src="../assets/images/avatars/6.jpg" alt="Avatar 1" className="w-full h-full object-cover" />
                      </div>
                      <div className="avatar rounded-full border-2 border-white bg-primary d-flex justify-content-center align-items-center flex-shrink-0 flex-grow-0 w-8 h-8 overflow-hidden border border-2 border-white bg-grey-100">
                        <img src="../assets/images/avatars/5.jpg" alt="Avatar 1" className="w-full h-full object-cover" />
                      </div>
                      <div className="avatar rounded-full border-2 border-white bg-primary d-flex justify-content-center align-items-center flex-shrink-0 flex-grow-0 w-8 h-8 overflow-hidden border border-2 border-white bg-grey-100">
                        <img src="../assets/images/avatars/10.jpg" alt="Avatar 1" className="w-full h-full object-cover" />
                      </div>
                      <div className="avatar text-xs fw-medium text-grey-500 d-flex justify-content-center align-items-center flex-shrink-0 flex-grow-0 w-8 h-8 rounded-full border border-2 border-white bg-grey-100">+4</div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="p-3">
                <p className="mb-0 fonty-medium">Notes</p>
                <p className="line-clamp-3 text-grey-500">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>
                <button className="btn text-primary-500 bg-primary-50 border-primary-200 d-block w-100">Join Meeting</button>
              </div>
              <div className="status-line"></div>
            </div>
            <div className="border border-grey-200 success rounded-2 bg-white overflow-hidden">
              <div className="p-3 border-bottom">
                <div className="d-flex align-items-center row-gap-3 mb-1">
                  <h4 className="text-sm mb-0 me-3 text-grey-800">Project Discussion XYZ</h4>
                  <div className="ms-auto">
                    <button
                      className="button bg-transparent border-0 d-flex align-items-center text-primary-500"
                      type="button"
                    >
                      <i className="bx bx-bell bx-sm"></i>
                    </button>
                  </div>
                </div>
                <div>
                  <ul className="list-unstyled d-inline-flex gap-2 text-grey-400 mb-0">
                    <li>Wednesday, 25th June</li>
                    <li>|</li>
                    <li>12:00 - 12:30pm</li>
                  </ul>
                </div>
              </div>
              <div className="p-3 border-bottom">
                <div className="d-flex flex-column mb-1">
                  <span className="text-xs text-grey-600">Participants</span>

                  <div className="d-flex align-items-center">
                    <div className="avatar-group d-flex align-items-center -space-x-3">
                      <div className="avatar rounded-full border-2 border-white bg-primary d-flex justify-content-center align-items-center flex-shrink-0 flex-grow-0 w-8 h-8 overflow-hidden border border-2 border-white bg-grey-100">
                        <img src="../assets/images/avatars/8.jpg" alt="Avatar 1" className="w-full h-full object-cover" />
                      </div>
                      <div className="avatar rounded-full border-2 border-white bg-primary d-flex justify-content-center align-items-center flex-shrink-0 flex-grow-0 w-8 h-8 overflow-hidden border border-2 border-white bg-grey-100">
                        <img src="../assets/images/avatars/6.jpg" alt="Avatar 1" className="w-full h-full object-cover" />
                      </div>
                      <div className="avatar rounded-full border-2 border-white bg-primary d-flex justify-content-center align-items-center flex-shrink-0 flex-grow-0 w-8 h-8 overflow-hidden border border-2 border-white bg-grey-100">
                        <img src="../assets/images/avatars/5.jpg" alt="Avatar 1" className="w-full h-full object-cover" />
                      </div>
                      <div className="avatar rounded-full border-2 border-white bg-primary d-flex justify-content-center align-items-center flex-shrink-0 flex-grow-0 w-8 h-8 overflow-hidden border border-2 border-white bg-grey-100">
                        <img src="../assets/images/avatars/10.jpg" alt="Avatar 1" className="w-full h-full object-cover" />
                      </div>
                      <div className="avatar text-xs fw-medium text-grey-500 d-flex justify-content-center align-items-center flex-shrink-0 flex-grow-0 w-8 h-8 rounded-full border border-2 border-white bg-grey-100">+4</div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="p-3">
                <p className="mb-0 fonty-medium">Notes</p>
                <p className="line-clamp-3 text-grey-500">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>
                <button className="btn text-primary-500 bg-primary-50 border-primary-200 d-block w-100">Join Meeting</button>
              </div>
              <div className="status-line"></div>
            </div>
            <div className="border border-grey-200 success rounded-2 bg-white overflow-hidden">
              <div className="p-3 border-bottom">
                <div className="d-flex align-items-center row-gap-3 mb-1">
                  <h4 className="text-sm mb-0 me-3 text-grey-800">Project Discussion XYZ</h4>
                  <div className="ms-auto">
                    <button
                      className="button bg-transparent border-0 d-flex align-items-center text-primary-500"
                      type="button"
                    >
                      <i className="bx bx-bell bx-sm"></i>
                    </button>
                  </div>
                </div>
                <div>
                  <ul className="list-unstyled d-inline-flex gap-2 text-grey-400 mb-0">
                    <li>Wednesday, 25th June</li>
                    <li>|</li>
                    <li>12:00 - 12:30pm</li>
                  </ul>
                </div>
              </div>
              <div className="p-3 border-bottom">
                <div className="d-flex flex-column mb-1">
                  <span className="text-xs text-grey-600">Participants</span>

                  <div className="d-flex align-items-center">
                    <div className="avatar-group d-flex align-items-center -space-x-3">
                      <div className="avatar rounded-full border-2 border-white bg-primary d-flex justify-content-center align-items-center flex-shrink-0 flex-grow-0 w-8 h-8 overflow-hidden border border-2 border-white bg-grey-100">
                        <img src="../assets/images/avatars/8.jpg" alt="Avatar 1" className="w-full h-full object-cover" />
                      </div>
                      <div className="avatar rounded-full border-2 border-white bg-primary d-flex justify-content-center align-items-center flex-shrink-0 flex-grow-0 w-8 h-8 overflow-hidden border border-2 border-white bg-grey-100">
                        <img src="../assets/images/avatars/6.jpg" alt="Avatar 1" className="w-full h-full object-cover" />
                      </div>
                      <div className="avatar rounded-full border-2 border-white bg-primary d-flex justify-content-center align-items-center flex-shrink-0 flex-grow-0 w-8 h-8 overflow-hidden border border-2 border-white bg-grey-100">
                        <img src="../assets/images/avatars/5.jpg" alt="Avatar 1" className="w-full h-full object-cover" />
                      </div>
                      <div className="avatar rounded-full border-2 border-white bg-primary d-flex justify-content-center align-items-center flex-shrink-0 flex-grow-0 w-8 h-8 overflow-hidden border border-2 border-white bg-grey-100">
                        <img src="../assets/images/avatars/10.jpg" alt="Avatar 1" className="w-full h-full object-cover" />
                      </div>
                      <div className="avatar text-xs fw-medium text-grey-500 d-flex justify-content-center align-items-center flex-shrink-0 flex-grow-0 w-8 h-8 rounded-full border border-2 border-white bg-grey-100">+4</div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="p-3">
                <p className="mb-0 fonty-medium">Notes</p>
                <p className="line-clamp-3 text-grey-500">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>
                <button className="btn text-primary-500 bg-primary-50 border-primary-200 d-block w-100">Join Meeting</button>
              </div>
              <div className="status-line"></div>
            </div>
          </Slider>
        </div>


      </div>

      <div className="mb-5">
        <div className="pb-3 d-flex flex-wrap justify-content-between align-items-center">
          <h3 className="mb-0 text-base font-semibold">Meeting Recordings</h3>
          {/* <button type="button" className="w-10 h-10 d-flex justify-content-center align-items-center p-3 text-primary-500 rounded-lg border border-primary-200 bg-primary-50">
            <i className="bx bx-calendar bx-sm leading-3"></i>
          </button> */}
        </div>
        
        <div className="max-h-350 table-responsive">
        <table className="table table-bordered">
          <thead>
            <tr className="position-sticky top-0">
              <th className="bg-grey-50">Meeting Name</th>
              <th className="bg-grey-50">Date uploaded</th>
              <th className="bg-grey-50">File size</th>
              <th className="bg-grey-50">Participants</th>
              <th className="text-center bg-grey-50">Take action</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <div className="form-check">
                  <input className="form-check-input" type="checkbox" value="" id="check1"/>
                  <label className="form-check-label" for="check1">
                    Project Kickoff Call
                  </label>
                </div>
              </td>
              <td>Apr 4, 2023</td>
              <td>140 MB</td>
              <td>
                <div className="avatar-group d-flex align-items-center -space-x-3">
                  <div className="avatar rounded-full border-2 border-white bg-primary d-flex justify-content-center align-items-center flex-shrink-0 flex-grow-0 w-8 h-8 overflow-hidden border border-2 border-white bg-grey-100">
                    <img src="../assets/images/avatars/8.jpg" alt="Avatar 1" className="w-full h-full object-cover" />
                  </div>
                  <div className="avatar rounded-full border-2 border-white bg-primary d-flex justify-content-center align-items-center flex-shrink-0 flex-grow-0 w-8 h-8 overflow-hidden border border-2 border-white bg-grey-100">
                    <img src="../assets/images/avatars/6.jpg" alt="Avatar 1" className="w-full h-full object-cover" />
                  </div>
                  <div className="avatar rounded-full border-2 border-white bg-primary d-flex justify-content-center align-items-center flex-shrink-0 flex-grow-0 w-8 h-8 overflow-hidden border border-2 border-white bg-grey-100">
                    <img src="../assets/images/avatars/5.jpg" alt="Avatar 1" className="w-full h-full object-cover" />
                  </div>
                  <div className="avatar rounded-full border-2 border-white bg-primary d-flex justify-content-center align-items-center flex-shrink-0 flex-grow-0 w-8 h-8 overflow-hidden border border-2 border-white bg-grey-100">
                    <img src="../assets/images/avatars/10.jpg" alt="Avatar 1" className="w-full h-full object-cover" />
                  </div>
                </div>
              </td>
              <td>
                <div className="d-flex justify-content-center align-items-center gap-1">
                  <button type="button" className="btn btn-outline-light w-8 h-8 d-inline-flex justify-content-center align-items-center"><i className="bx bx-show-alt"></i></button>
                  <button type="button" className="btn btn-outline-light w-8 h-8 d-inline-flex justify-content-center align-items-center"><i className="bx bx-download"></i></button>
                  <button type="button" className="btn btn-outline-light w-8 h-8 d-inline-flex justify-content-center align-items-center"><i className="bx bx-trash"></i></button>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div className="form-check">
                  <input className="form-check-input" type="checkbox" value="" id="check2"/>
                  <label className="form-check-label" for="check2">
                    Quarterly Business Review
                  </label>
                </div>
              </td>
              <td>Apr 4, 2023</td>
              <td>140 MB</td>
              <td>
                <div className="avatar-group d-flex align-items-center -space-x-3">
                  <div className="avatar rounded-full border-2 border-white bg-primary d-flex justify-content-center align-items-center flex-shrink-0 flex-grow-0 w-8 h-8 overflow-hidden border border-2 border-white bg-grey-100">
                    <img src="../assets/images/avatars/8.jpg" alt="Avatar 1" className="w-full h-full object-cover" />
                  </div>
                  <div className="avatar rounded-full border-2 border-white bg-primary d-flex justify-content-center align-items-center flex-shrink-0 flex-grow-0 w-8 h-8 overflow-hidden border border-2 border-white bg-grey-100">
                    <img src="../assets/images/avatars/6.jpg" alt="Avatar 1" className="w-full h-full object-cover" />
                  </div>
                  <div className="avatar rounded-full border-2 border-white bg-primary d-flex justify-content-center align-items-center flex-shrink-0 flex-grow-0 w-8 h-8 overflow-hidden border border-2 border-white bg-grey-100">
                    <img src="../assets/images/avatars/5.jpg" alt="Avatar 1" className="w-full h-full object-cover" />
                  </div>
                  <div className="avatar rounded-full border-2 border-white bg-primary d-flex justify-content-center align-items-center flex-shrink-0 flex-grow-0 w-8 h-8 overflow-hidden border border-2 border-white bg-grey-100">
                    <img src="../assets/images/avatars/10.jpg" alt="Avatar 1" className="w-full h-full object-cover" />
                  </div>
                </div>
              </td>
              <td>
                <div className="d-flex justify-content-center align-items-center gap-1">
                  <button type="button" className="btn btn-outline-light w-8 h-8 d-inline-flex justify-content-center align-items-center"><i className="bx bx-show-alt"></i></button>
                  <button type="button" className="btn btn-outline-light w-8 h-8 d-inline-flex justify-content-center align-items-center"><i className="bx bx-download"></i></button>
                  <button type="button" className="btn btn-outline-light w-8 h-8 d-inline-flex justify-content-center align-items-center"><i className="bx bx-trash"></i></button>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div className="form-check">
                  <input className="form-check-input" type="checkbox" value="" id="check3"/>
                  <label className="form-check-label" for="check3">
                    Marketing Strategy Workshop
                  </label>
                </div>
              </td>
              <td>Apr 4, 2023</td>
              <td>140 MB</td>
              <td>
                <div className="avatar-group d-flex align-items-center -space-x-3">
                  <div className="avatar rounded-full border-2 border-white bg-primary d-flex justify-content-center align-items-center flex-shrink-0 flex-grow-0 w-8 h-8 overflow-hidden border border-2 border-white bg-grey-100">
                    <img src="../assets/images/avatars/8.jpg" alt="Avatar 1" className="w-full h-full object-cover" />
                  </div>
                  <div className="avatar rounded-full border-2 border-white bg-primary d-flex justify-content-center align-items-center flex-shrink-0 flex-grow-0 w-8 h-8 overflow-hidden border border-2 border-white bg-grey-100">
                    <img src="../assets/images/avatars/6.jpg" alt="Avatar 1" className="w-full h-full object-cover" />
                  </div>
                  <div className="avatar rounded-full border-2 border-white bg-primary d-flex justify-content-center align-items-center flex-shrink-0 flex-grow-0 w-8 h-8 overflow-hidden border border-2 border-white bg-grey-100">
                    <img src="../assets/images/avatars/5.jpg" alt="Avatar 1" className="w-full h-full object-cover" />
                  </div>
                  <div className="avatar rounded-full border-2 border-white bg-primary d-flex justify-content-center align-items-center flex-shrink-0 flex-grow-0 w-8 h-8 overflow-hidden border border-2 border-white bg-grey-100">
                    <img src="../assets/images/avatars/10.jpg" alt="Avatar 1" className="w-full h-full object-cover" />
                  </div>
                </div>
              </td>
              <td>
                <div className="d-flex justify-content-center align-items-center gap-1">
                  <button type="button" className="btn btn-outline-light w-8 h-8 d-inline-flex justify-content-center align-items-center"><i className="bx bx-show-alt"></i></button>
                  <button type="button" className="btn btn-outline-light w-8 h-8 d-inline-flex justify-content-center align-items-center"><i className="bx bx-download"></i></button>
                  <button type="button" className="btn btn-outline-light w-8 h-8 d-inline-flex justify-content-center align-items-center"><i className="bx bx-trash"></i></button>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div className="form-check">
                  <input className="form-check-input" type="checkbox" value="" id="check4"/>
                  <label className="form-check-label" for="check4">
                    Design Sprint Planning
                  </label>
                </div>
              </td>
              <td>Apr 4, 2023</td>
              <td>140 MB</td>
              <td>
                <div className="avatar-group d-flex align-items-center -space-x-3">
                  <div className="avatar rounded-full border-2 border-white bg-primary d-flex justify-content-center align-items-center flex-shrink-0 flex-grow-0 w-8 h-8 overflow-hidden border border-2 border-white bg-grey-100">
                    <img src="../assets/images/avatars/8.jpg" alt="Avatar 1" className="w-full h-full object-cover" />
                  </div>
                  <div className="avatar rounded-full border-2 border-white bg-primary d-flex justify-content-center align-items-center flex-shrink-0 flex-grow-0 w-8 h-8 overflow-hidden border border-2 border-white bg-grey-100">
                    <img src="../assets/images/avatars/6.jpg" alt="Avatar 1" className="w-full h-full object-cover" />
                  </div>
                  <div className="avatar rounded-full border-2 border-white bg-primary d-flex justify-content-center align-items-center flex-shrink-0 flex-grow-0 w-8 h-8 overflow-hidden border border-2 border-white bg-grey-100">
                    <img src="../assets/images/avatars/5.jpg" alt="Avatar 1" className="w-full h-full object-cover" />
                  </div>
                  <div className="avatar rounded-full border-2 border-white bg-primary d-flex justify-content-center align-items-center flex-shrink-0 flex-grow-0 w-8 h-8 overflow-hidden border border-2 border-white bg-grey-100">
                    <img src="../assets/images/avatars/10.jpg" alt="Avatar 1" className="w-full h-full object-cover" />
                  </div>
                </div>
              </td>
              <td>
                <div className="d-flex justify-content-center align-items-center gap-1">
                  <button type="button" className="btn btn-outline-light w-8 h-8 d-inline-flex justify-content-center align-items-center"><i className="bx bx-show-alt"></i></button>
                  <button type="button" className="btn btn-outline-light w-8 h-8 d-inline-flex justify-content-center align-items-center"><i className="bx bx-download"></i></button>
                  <button type="button" className="btn btn-outline-light w-8 h-8 d-inline-flex justify-content-center align-items-center"><i className="bx bx-trash"></i></button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        </div>
      </div>

      <hr />
      <div className="mb-5">
        <h2 className="h5 font-semibold mb-4">Pluto Connect</h2>
        <div className="d-flex">
          <div className="d-flex flex-wrap flex-auto">
            <div className="flex-auto w-20 border-end border-grey-200">
              <ul className="list-unstyled connect-list-pluto d-flex flex-column row-gap-2">
                <li className="active">
                  <Link className="d-flex flex-column align-items-center gap-1">
                    <div className="connect-icon w-11 h-11 rounded-lg d-flex justify-content-center align-items-center">
                      <i className="bx bx-home-alt-2 bx-sm"></i>
                    </div>
                    <span className="text-xs">Rooms</span>
                  </Link>
                </li>
                <li>
                  <Link className="d-flex flex-column align-items-center gap-1">
                    <div className="connect-icon w-11 h-11 rounded-lg d-flex justify-content-center align-items-center">
                      <i className="bx bx-message-square-dots bx-sm"></i>
                    </div>
                    <span className="text-xs">Index</span>
                  </Link>
                </li>
                <li>
                  <Link className="d-flex flex-column align-items-center gap-1">
                    <div className="connect-icon w-11 h-11 rounded-lg d-flex justify-content-center align-items-center">
                      <i className="bx bx-bell bx-sm"></i>
                    </div>
                    <span className="text-xs">Activity</span>
                  </Link>
                </li>
                <li>
                  <Link className="d-flex flex-column align-items-center gap-1">
                    <div className="connect-icon w-11 h-11 rounded-lg d-flex justify-content-center align-items-center">
                      <i className="bx bx-bell bx-sm"></i>
                    </div>
                    <span className="text-xs">Later</span>
                  </Link>
                </li>
                <li>
                  <Link className="d-flex flex-column align-items-center gap-1">
                    <div className="connect-icon w-11 h-11 rounded-lg d-flex justify-content-center align-items-center">
                      <i className="bx bx-dots-horizontal-rounded bx-sm"></i>
                    </div>
                    <span className="text-xs">More</span>
                  </Link>
                </li>
              </ul>
            </div>
            <div className="flex-auto w-60 border-end border-grey-200 py-4">
              <div>
                <div className="px-4 d-flex justify-content-between align-items-center gap-3 mb-2">
                  <h3 className="mb-0 text-md font-medium">Rooms</h3>
                </div>
                <div className="px-4">
                  <ul className="sub-connect-list list-unstyled d-flex flex-column row-gap-1">
                    <li>
                      <Link className="d-flex align-items-center gap-2 px-2 py-2 rounded-md">
                        <i className="bx bx-hash"></i>
                        <span className="line-clamp-1">Pluto-implement</span>
                      </Link>
                    </li>
                    <li>
                      <Link className="d-flex align-items-center gap-2 px-2 py-2 rounded-md">
                        <i className="bx bx-hash"></i>
                        <span className="line-clamp-1">change-approval</span>
                      </Link>
                    </li>
                    <li>
                      <Link className="d-flex align-items-center gap-2 px-2 py-2 rounded-md">
                        <i className="bx bx-hash"></i>
                        <span className="line-clamp-1">culture-club</span>
                      </Link>
                    </li>
                    <li>
                      <Link className="d-flex align-items-center gap-2 px-2 py-2 rounded-md">
                        <i className="bx bx-hash"></i>
                        <span className="line-clamp-1">student success</span>
                      </Link>
                    </li>
                    <li className="active">
                      <Link className="d-flex align-items-center gap-2 px-2 py-2 rounded-md">
                        <i className="bx bx-lock-alt"></i>
                        <span className="line-clamp-1">approval-team</span>
                      </Link>
                    </li>
                  </ul>
                  <button type="button" className="px-2 py-2 w-100 d-flex align-items-center gap-1 rounded-md border-0 bg-transparent">
                    <i className="bx bx-plus-circle"></i>
                    Add channels
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="w-100 d-flex flex-column">
            <div className="d-flex flex-column position-sticky top-0 z-10">
              <div className="px-4 pb-3 w-100 d-flex justify-content-between align-items-center border-bottom border-grey-200 bg-white">
                <div className="d-flex align-items-center">
                  <div className="input-group">
                    <span className="input-group-text border-transparent bg-white pe-0" id="basic-addon1"><i className="bx bx-lock-alt"></i></span>
                    <select name="" id="" className="form-select border-transparent font-semibold ps-1">
                      <option value="">approval-team</option>
                    </select>
                  </div>
                </div>
                <div className="d-flex align-items-center gap-3">
                  <div className="d-flex align-items-center border rounded-md w-100">
                    <button className="px-2 py-2 border-0 bg-transparent border-end d-flex justify-content-center align-items-center text-grey-500">
                      <i className="bx bx-search text-xl"></i>
                    </button>
                    <button className="px-2 py-2 border-0 bg-transparent d-flex justify-content-center align-items-center text-grey-500">
                      <i className="bx bx-chevron-right text-xl"></i>
                    </button>
                  </div>

                  <div className="d-flex align-items-center border rounded-md w-100 px-2 py-1">
                    <div className="avatar-group d-flex align-items-center -space-x-3">
                      <div className="avatar rounded-full border-2 border-white bg-primary d-flex justify-content-center align-items-center flex-shrink-0 flex-grow-0 w-8 h-8 overflow-hidden border border-2 border-white bg-grey-100">
                        <img src="../assets/images/avatars/8.jpg" alt="Avatar 1" className="w-full h-full object-cover" />
                      </div>
                      <div className="avatar rounded-full border-2 border-white bg-primary d-flex justify-content-center align-items-center flex-shrink-0 flex-grow-0 w-8 h-8 overflow-hidden border border-2 border-white bg-grey-100">
                        <img src="../assets/images/avatars/6.jpg" alt="Avatar 1" className="w-full h-full object-cover" />
                      </div>
                      <div className="avatar rounded-full border-2 border-white bg-primary d-flex justify-content-center align-items-center flex-shrink-0 flex-grow-0 w-8 h-8 overflow-hidden border border-2 border-white bg-grey-100">
                        <img src="../assets/images/avatars/5.jpg" alt="Avatar 1" className="w-full h-full object-cover" />
                      </div>
                      <div className="avatar text-sm fw-bold text-gray-600 d-flex justify-content-center align-items-center flex-shrink-0 flex-grow-0 w-8 h-8 rounded-full border border-2 border-white bg-grey-100">8</div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="px-4 py-2 w-100 d-flex justify-content-between align-items-center border-bottom border-grey-200 bg-grey-50">
                <div className="d-flex align-items-center">
                  <div className="input-group input-group-sm bg-grey-100 rounded-md">
                    <span className="input-group-text border-transparent bg-grey-100 pe-0" id="basic-addon1"><i className="bx bx-pin"></i></span>
                    <select name="" id="" className="form-select border-transparent font-medium ps-1 text-grey-500 bg-grey-100">
                      <option value="">5 pinned</option>
                    </select>
                  </div>  
                
                  <div>
                    <button type="button" className="d-inline-flex align-items-center gap-1 text-nowrap font-medium text-grey-700 border-transparent bg-transparent">
                      <i className="bx bx-plus-circle"></i> Add a bookmark
                    </button>
                  </div>  
                </div>
              </div>
            </div>

            <div className="p-4 connect-post-msg">
              <ul className="connect-msg list-unstyled mb-4 d-flex flex-column row-gap-3 overflow-y-auto">
                <li>
                  <div className="d-flex align-items-start">
                    <div className="w-10 h-10 me-2 flex-none rounded-lg overflow-hidden">
                      <img src="../assets/images/avatars/8.jpg" alt="" className="w-100 h-100 object-fit-cover" />
                    </div>
                    <div className="d-flex flex-column">
                      <div>
                        <span className="font-semibold me-2">Dann Parker</span> <span className="text-xs font-medium text-slate-400">4:37pm</span>
                      </div>
                      <p>Hardeep, can you share the specific shades they had in mind? Meanwhile, @Tasha Smith, the font you used in the last mockup was spot on! Can we reuse?</p>
                    </div>
                  </div>
                </li>
                <li>
                  <div className="d-flex align-items-start">
                    <div className="w-10 h-10 me-2 flex-none rounded-lg overflow-hidden">
                      <img src="../assets/images/avatars/8.jpg" alt="" className="w-100 h-100 object-fit-cover" />
                    </div>
                    <div className="d-flex flex-column">
                      <div>
                        <span className="font-semibold me-2">Mia Alvarez</span> <span className="text-xs font-medium text-slate-400">4:42 pm</span>
                      </div>
                      <p>Morning! 👋 I just got feedback from marketing. They'd like to see some pop of color in the call-to-action buttons. <a href="#">@Lena Olsson</a> , would you like to take this up?</p>
                    </div>
                  </div>
                </li>
                <li className="py-3">
                  <div className="time-divider position-relative text-center">
                    <span className="ps-3 pe-2 py-1 text-xs font-medium text-grey-500 rounded-pill border border-grey-200 bg-white position-relative z-1">Yesterday <i className="bx bx-chevron-down"></i></span>
                  </div>
                </li>
                <li>
                  <div className="d-flex align-items-start">
                    <div className="w-10 h-10 me-2 flex-none rounded-lg overflow-hidden">
                      <img src="../assets/images/avatars/8.jpg" alt="" className="w-100 h-100 object-fit-cover" />
                    </div>
                    <div className="d-flex flex-column">
                      <div>
                        <span className="font-semibold me-2">Gabriella Kim</span> <span className="text-xs font-medium text-slate-400">2:37pm</span>
                      </div>
                      <p>Team! Reminder about our brainstorm at 3 PM. Looking forward to some fresh ideas!</p>

                      <div className="max-w-400 d-flex align-items-center gap-2 border rounded-md w-100 px-2 py-1 mt-2">
                        <div className="avatar-group d-flex align-items-center -space-x-3">
                          <div className="avatar rounded-full border-2 border-white bg-primary d-flex justify-content-center align-items-center flex-shrink-0 flex-grow-0 w-8 h-8 overflow-hidden border border-2 border-white bg-grey-100">
                            <img src="../assets/images/avatars/8.jpg" alt="Avatar 1" className="w-full h-full object-cover" />
                          </div>
                          <div className="avatar rounded-full border-2 border-white bg-primary d-flex justify-content-center align-items-center flex-shrink-0 flex-grow-0 w-8 h-8 overflow-hidden border border-2 border-white bg-grey-100">
                            <img src="../assets/images/avatars/6.jpg" alt="Avatar 1" className="w-full h-full object-cover" />
                          </div>
                          <div className="avatar rounded-full border-2 border-white bg-primary d-flex justify-content-center align-items-center flex-shrink-0 flex-grow-0 w-8 h-8 overflow-hidden border border-2 border-white bg-grey-100">
                            <img src="../assets/images/avatars/5.jpg" alt="Avatar 1" className="w-full h-full object-cover" />
                          </div>
                          <div className="avatar text-sm fw-bold text-gray-600 d-flex justify-content-center align-items-center flex-shrink-0 flex-grow-0 w-8 h-8 rounded-full border border-2 border-white bg-grey-100">4</div>
                        </div>
                        <div className="d-flex align-items-center gap-3">
                          <span className="text-primary-500 font-medium">4 replies </span>
                          <Link className="text-grey-500 font-medium text-decoration-none">View thread</Link>
                        </div>
                        <Link className="ms-auto d-flex align-items-center text-decoration-none text-grey-400"><i className="bx bx-chevron-right bx-sm"></i></Link>
                      </div>
                    </div>
                  </div>
                </li>
                <li>
                  <div className="d-flex align-items-start">
                    <div className="w-10 h-10 me-2 flex-none rounded-lg overflow-hidden">
                      <img src="../assets/images/avatars/8.jpg" alt="" className="w-100 h-100 object-fit-cover" />
                    </div>
                    <div className="d-flex flex-column">
                      <div>
                        <span className="font-semibold me-2">Gabriella Kim</span> <span className="text-xs font-medium text-slate-400">2:40pm</span>
                      </div>
                      <p>Team! Reminder about our brainstorm at 3 PM. Looking forward to some fresh ideas!</p>
                    </div>
                  </div>
                </li>
                <li>
                  <div className="d-flex align-items-start">
                    <div className="w-10 h-10 me-2 flex-none rounded-lg overflow-hidden">
                      <img src="../assets/images/avatars/5.jpg" alt="" className="w-100 h-100 object-fit-cover" />
                    </div>
                    <div className="d-flex flex-column">
                      <div>
                        <span className="font-semibold me-2">Isaac Goldberg</span> <span className="text-xs font-medium text-slate-400">2:45 pm</span>
                      </div>
                      <p>Quick question: Who was behind the tablet designs? Need to discuss a small tweak.</p>
                    </div>
                  </div>
                </li>
                <li>
                  <div className="d-flex align-items-start">
                    <div className="w-10 h-10 me-2 flex-none rounded-lg overflow-hidden">
                      <img src="../assets/images/avatars/5.jpg" alt="" className="w-100 h-100 object-fit-cover" />
                    </div>
                    <div className="d-flex flex-column">
                      <div>
                        <span className="font-semibold me-2">Isaac Goldberg</span> <span className="text-xs font-medium text-slate-400">4:37pm</span>
                      </div>
                      <p><strong>Quick question:</strong> Who was behind the tablet designs? Need to discuss a small tweak.</p>
                    </div>
                  </div>
                </li>
                <li>
                  <div className="d-flex align-items-start">
                    <div className="w-10 h-10 me-2 flex-none rounded-lg overflow-hidden">
                      <img src="../assets/images/avatars/5.jpg" alt="" className="w-100 h-100 object-fit-cover" />
                    </div>
                    <div className="d-flex flex-column">
                      <div>
                        <span className="font-semibold me-2">Isaac Goldberg</span> <span className="text-xs font-medium text-slate-400">5:45 pm</span>
                      </div>
                      <p>Quick question: Who was behind the tablet designs? Need to discuss a small tweak.</p>
                    </div>
                  </div>
                </li>

                <li className="py-3">
                  <div className="time-divider position-relative text-center">
                    <span className="ps-3 pe-2 py-1 text-xs font-medium text-grey-500 rounded-pill border border-grey-200 bg-white position-relative z-1">Today <i className="bx bx-chevron-down"></i></span>
                  </div>
                </li>
                <li>
                  <div className="d-flex align-items-start">
                    <div className="w-10 h-10 me-2 flex-none rounded-lg overflow-hidden">
                      <img src="../assets/images/avatars/12.jpg" alt="" className="w-100 h-100 object-fit-cover" />
                    </div>
                    <div className="d-flex flex-column">
                      <div>
                        <span className="font-semibold me-2">Dann Cox</span> <span className="text-xs font-medium text-slate-400">10 min ago</span>
                      </div>
                      <p>Team! Reminder about our brainstorm at 3 PM. Looking forward to some fresh ideas!</p>

                      <ul className="list-unstyled d-inline-flex gap-2 mt-2">
                        <li>
                          <span className="px-2 py-0-5 d-inline-flex align-items-center gap-1 text-xs font-medium rounded text-red-500 bg-red-100">
                            <i className="bx bx-message-alt-error text-base"></i> Urgent
                          </span>
                        </li>
                        <li>
                          <span className="px-2 py-0-5 d-inline-flex align-items-center gap-1 text-xs font-medium rounded text-grey-500 bg-grey-100">
                            <img src="../assets/images/icons/date-time-calendar.svg" alt="" /> Response required in <strong>2 hours, 13 mins</strong>
                          </span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </li>
                <li>
                  <div className="d-flex align-items-start">
                    <div className="w-10 h-10 me-2 flex-none rounded-lg overflow-hidden">
                      <img src="../assets/images/avatars/12.jpg" alt="" className="w-100 h-100 object-fit-cover" />
                    </div>
                    <div className="d-flex flex-column">
                      <div>
                        <span className="font-semibold me-2">Dann Cox</span> <span className="text-xs font-medium text-slate-400">Now</span>
                      </div>
                      <p>Does anyone know how to recover the "Foundations" project in Figma? 🙈</p>
                    </div>
                  </div>
                </li>
              </ul>
              <div>
                <textarea name="" id="" className="form-control"></textarea>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="mb-5">
        <div className="d-flex">
          <div className="d-flex flex-wrap flex-auto">
            <div className="flex-auto w-20 border-end border-grey-200">
              <ul className="list-unstyled connect-list-pluto d-flex flex-column row-gap-2">
                <li>
                  <Link className="d-flex flex-column align-items-center gap-1">
                    <div className="connect-icon w-11 h-11 rounded-lg d-flex justify-content-center align-items-center">
                      <i className="bx bx-home-alt-2 bx-sm"></i>
                    </div>
                    <span className="text-xs">Rooms</span>
                  </Link>
                </li>
                <li>
                  <Link className="d-flex flex-column align-items-center gap-1">
                    <div className="connect-icon w-11 h-11 rounded-lg d-flex justify-content-center align-items-center">
                      <i className="bx bx-message-square-dots bx-sm"></i>
                    </div>
                    <span className="text-xs">Index</span>
                  </Link>
                </li>
                <li className="active">
                  <Link className="d-flex flex-column align-items-center gap-1">
                    <div className="connect-icon w-11 h-11 rounded-lg d-flex justify-content-center align-items-center">
                      <i className="bx bx-bell bx-sm"></i>
                    </div>
                    <span className="text-xs">Activity</span>
                  </Link>
                </li>
                <li>
                  <Link className="d-flex flex-column align-items-center gap-1">
                    <div className="connect-icon w-11 h-11 rounded-lg d-flex justify-content-center align-items-center">
                      <i className="bx bx-bell bx-sm"></i>
                    </div>
                    <span className="text-xs">Later</span>
                  </Link>
                </li>
                <li>
                  <Link className="d-flex flex-column align-items-center gap-1">
                    <div className="connect-icon w-11 h-11 rounded-lg d-flex justify-content-center align-items-center">
                      <i className="bx bx-dots-horizontal-rounded bx-sm"></i>
                    </div>
                    <span className="text-xs">More</span>
                  </Link>
                </li>
              </ul>
            </div>
            <div className="flex-auto w-96 border-end border-grey-200 pt-4">
              <div>
                <div className="px-4 d-flex justify-content-between align-items-center gap-3 mb-2">
                  <h3 className="mb-0 text-md font-medium">Rooms</h3>
                  <div className="form-check form-switch d-flex gap-2 min-h-unset">
                    <label className="form-check-label text-grey-500 text-xs" for="switchCheckDefault">Unreads</label>
                    <input className="form-check-input float-none mt-0 ms-0 w-8 h-5" type="checkbox" role="switch" id="switchCheckDefault" />
                  </div>
                </div>
                
                <Tab.Container activeKey={activeKey} onSelect={(k) => setActiveKey(k)}>
                  <Nav variant="tabs">
                    <Nav.Item>
                      <Nav.Link eventKey="all">
                        All
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="mentions">
                        Mentions
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="threads">
                        Threads
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="reactions">
                        Reactions
                      </Nav.Link>
                    </Nav.Item>
                    <NavDropdown 
                      title={<i className="bx bx-dots-horizontal-rounded"></i>}
                      id="nav-dropdown"
                      className="no-arrow"
                    >
                      <NavDropdown.Item eventKey="more">
                        <i className="bx bx-cog mr-1"></i> Settings
                      </NavDropdown.Item>
                    </NavDropdown>
                  </Nav>

                  <Tab.Content>
                    <Tab.Pane eventKey="all">
                      <ul className="connect-msg-shortlist list-unstyled mb-0 overflow-y-auto">
                        <li className="active">
                          <Link className="d-flex flex-column row-gap-2 px-4 py-3 text-inherit text-decoration-none">
                            <div className="d-flex justify-content-between align-items-center gap-3 position-relative">
                              <span className="d-flex align-items-center gap-1 text-grey-600">
                                <i className="bx bx-at"></i> Mention in #approval_team
                              </span>
                              <div className="d-flex justify-content-between align-items-center gap-1">
                                <span className="text-xs font-medium text-slate-400">10 min ago</span>
                                {/* <span className="badge bg-red-500 px-1-5 d-flex align-items-center font-normal leading-none rounded-md end-0">1</span> */}
                              </div>
                            </div>
                            <div className="d-flex align-items-start">
                              <div className="w-10 h-10 me-2 flex-none rounded-lg overflow-hidden">
                                <img src="../assets/images/avatars/8.jpg" alt="" className="w-100 h-100 object-fit-cover" />
                              </div>
                              <div className="d-flex flex-column">
                                <div>
                                  <span className="font-semibold me-2">Mia Alvarez</span>
                                </div>
                                <div className="d-flex flex-column">
                                  <span className="line-clamp-1 text-grey-500">replied to: New expenditures for the entire text</span>
                                  <span className="line-clamp-2 mt-2">Morning! 👋 I just got feedback from marketing. They"d like to see some pop of color in the call-to-action buttons. <a href="#">@Lena Olsson</a> , would you like to take this up?</span>
                                </div>
                              </div>
                            </div>
                          </Link>
                        </li>
                        
                        <li>
                          <Link className="d-flex flex-column row-gap-2 px-4 py-3 text-inherit text-decoration-none">
                            <div className="d-flex justify-content-between align-items-center gap-3">
                              <span className="d-flex align-items-center gap-1 text-grey-600">
                                <i className="bx bx-message-square-detail" ></i> Thread in direct message
                              </span>
                              <div className="d-flex justify-content-between align-items-center gap-1">
                                <span className="text-xs font-medium text-slate-400">5:50pm</span>
                                <span className="badge bg-red-500 px-1-5 d-flex align-items-center font-normal leading-none rounded-md end-0">4</span>
                              </div>
                            </div>
                            <div className="d-flex align-items-start">
                              <div className="w-10 h-10 me-2 flex-none rounded-lg overflow-hidden">
                                <img src="../assets/images/avatars/9.jpg" alt="" className="w-100 h-100 object-fit-cover" />
                              </div>
                              <div className="d-flex flex-column">
                                <div>
                                  <span className="font-semibold me-2">Lena Olsson</span>
                                </div>
                                <div className="d-flex flex-column">
                                  {/* <span className="line-clamp-1 text-grey-500">replied to: New expenditures for the entire text</span> */}
                                  <span className="line-clamp-2 mt-2">Thanks @Lena Olsson! Sure thing, it's called "Modern Muse". I'll drop the lice...</span>
                                </div>
                              </div>
                            </div>
                          </Link>
                        </li>
                        
                        <li>
                          <Link className="d-flex flex-column row-gap-2 px-4 py-3 text-inherit text-decoration-none">
                            <div className="d-flex justify-content-between align-items-center gap-3">
                              <span className="d-flex align-items-center gap-1 text-grey-600">
                                 <i className="bx bx-at"></i> Mention in #product-updates
                              </span>
                              <div className="d-flex justify-content-between align-items-center gap-1">
                                <span className="text-xs font-medium text-slate-400">Yesterday</span>
                                <span className="badge bg-red-500 px-1-5 d-flex align-items-center font-normal leading-none rounded-md end-0">4</span>
                              </div>
                            </div>
                            <div className="d-flex align-items-start">
                              <div className="w-10 h-10 me-2 flex-none rounded-lg overflow-hidden">
                                <img src="../assets/images/avatars/10.jpg" alt="" className="w-100 h-100 object-fit-cover" />
                              </div>
                              <div className="d-flex flex-column">
                                <div>
                                  <span className="font-semibold me-2">Hardeep Kaur</span>
                                </div>
                                <div className="d-flex flex-column">
                                  {/* <span className="line-clamp-1 text-grey-500">replied to: New expenditures for the entire text</span> */}
                                  <span className="line-clamp-2 mt-2">Hola Lena 👋 here’s the file you asked for</span>
                                </div>
                              </div>
                            </div>
                          </Link>
                        </li>
                        
                        <li>
                          <Link className="d-flex flex-column row-gap-2 px-4 py-3 text-inherit text-decoration-none">
                            <div className="d-flex justify-content-between align-items-center gap-3">
                              <span className="d-flex align-items-center gap-1 text-grey-600">
                                 <i className="bx bx-at"></i> Mention in #product-updates
                              </span>
                              <div className="d-flex justify-content-between align-items-center gap-1">
                                <span className="text-xs font-medium text-slate-400">6/7/25</span>
                                <span className="badge bg-red-500 px-1-5 d-flex align-items-center font-normal leading-none rounded-md end-0">4</span>
                              </div>
                            </div>
                            <div className="d-flex align-items-start">
                              <div className="w-10 h-10 me-2 flex-none rounded-lg overflow-hidden">
                                <img src="../assets/images/avatars/11.jpg" alt="" className="w-100 h-100 object-fit-cover" />
                              </div>
                              <div className="d-flex flex-column">
                                <div>
                                  <span className="font-semibold me-2">Derek Nguyen</span>
                                </div>
                                <div className="d-flex flex-column">
                                  {/* <span className="line-clamp-1 text-grey-500">replied to: New expenditures for the entire text</span> */}
                                  <span className="line-clamp-2 mt-2">Thank you for kicking this off @Lena Olsson. Feel free to send that request...</span>
                                </div>
                              </div>
                            </div>
                          </Link>
                        </li>
                        
                        <li>
                          <Link className="d-flex flex-column row-gap-2 px-4 py-3 text-inherit text-decoration-none">
                            <div className="d-flex justify-content-between align-items-center gap-3">
                              <span className="d-flex align-items-center gap-1 text-grey-600">
                                 <i className="bx bx-at"></i> Mention in #dunder-mifflin-collab
                              </span>
                              <div className="d-flex justify-content-between align-items-center gap-1">
                                <span className="text-xs font-medium text-slate-400">5/7/25</span>
                                <span className="badge bg-red-500 px-1-5 d-flex align-items-center font-normal leading-none rounded-md end-0">4</span>
                              </div>
                            </div>
                            <div className="d-flex align-items-start">
                              <div className="w-10 h-10 me-2 flex-none rounded-lg overflow-hidden">
                                <img src="../assets/images/avatars/12.jpg" alt="" className="w-100 h-100 object-fit-cover" />
                              </div>
                              <div className="d-flex flex-column">
                                <div>
                                  <span className="font-semibold me-2">Tasha Smith</span>
                                </div>
                                <div className="d-flex flex-column">
                                  {/* <span className="line-clamp-1 text-grey-500">replied to: New expenditures for the entire text</span> */}
                                  <span className="line-clamp-2 mt-2">Hola! Could you please upload the file you’re referring to? Once I have it, I’ll be able to read and share the full text or help with anything you need related to it.</span>
                                </div>
                              </div>
                            </div>
                          </Link>
                        </li>

                        <li>
                          <Link className="d-flex flex-column row-gap-2 px-4 py-3 text-inherit text-decoration-none">
                            <div className="d-flex justify-content-between align-items-center gap-3 position-relative">
                              <span className="d-flex align-items-center gap-1 text-grey-600">
                                <i className="bx bx-message-square-detail"></i> Mention in #approval_team
                              </span>
                              <div className="d-flex justify-content-between align-items-center gap-1">
                                <span className="text-xs font-medium text-slate-400">25/06/25</span>
                                {/* <span className="badge bg-red-500 px-1-5 d-flex align-items-center font-normal leading-none rounded-md end-0">1</span> */}
                              </div>
                            </div>
                            <div className="d-flex align-items-start">
                              <div className="w-10 h-10 me-2 flex-none rounded-lg overflow-hidden">
                                <img src="../assets/images/avatars/6.jpg" alt="" className="w-100 h-100 object-fit-cover" />
                              </div>
                              <div className="d-flex flex-column">
                                <div>
                                  <span className="font-semibold me-2">Olivia Brown</span>
                                </div>
                                <div className="d-flex flex-column">
                                  <span className="line-clamp-1 text-grey-500">replied to: New expenditures for the entire text</span>
                                  <span className="line-clamp-2 mt-2">Morning! 👋 I just got feedback from marketing. They"d like to see some pop of color in the call-to-action buttons. <a href="#">@Lena Olsson</a> , would you like to take this up?</span>
                                </div>
                              </div>
                            </div>
                          </Link>
                        </li>

                        <li>
                          <Link className="d-flex flex-column row-gap-2 px-4 py-3 text-inherit text-decoration-none">
                            <div className="d-flex justify-content-between align-items-center gap-3">
                              <span className="d-flex align-items-center gap-1 text-grey-600">
                                 <i className="bx bx-at"></i> Mention in #dunder-mifflin-collab
                              </span>
                              <div className="d-flex justify-content-between align-items-center gap-1">
                                <span className="text-xs font-medium text-slate-400">5/7/25</span>
                                <span className="badge bg-red-500 px-1-5 d-flex align-items-center font-normal leading-none rounded-md end-0">4</span>
                              </div>
                            </div>
                            <div className="d-flex align-items-start">
                              <div className="w-10 h-10 me-2 flex-none rounded-lg overflow-hidden">
                                <img src="../assets/images/avatars/12.jpg" alt="" className="w-100 h-100 object-fit-cover" />
                              </div>
                              <div className="d-flex flex-column">
                                <div>
                                  <span className="font-semibold me-2">Tasha Smith</span>
                                </div>
                                <div className="d-flex flex-column">
                                  {/* <span className="line-clamp-1 text-grey-500">replied to: New expenditures for the entire text</span> */}
                                  <span className="line-clamp-2 mt-2">Hola! Could you please upload the file you’re referring to? Once I have it, I’ll be able to read and share the full text or help with anything you need related to it.</span>
                                </div>
                              </div>
                            </div>
                          </Link>
                        </li>
                      </ul>
                    </Tab.Pane>
                    <Tab.Pane eventKey="mentions">
                      <ul className="connect-msg-shortlist list-unstyled mb-0 overflow-y-auto">
                        <li className="active">
                          <Link className="d-flex flex-column row-gap-2 px-4 py-3 text-inherit text-decoration-none">
                            <div className="d-flex justify-content-between align-items-center gap-3 position-relative">
                              <span className="d-flex align-items-center gap-1 text-grey-600">
                                <i className="bx bx-at"></i> Mention in #approval_team
                              </span>
                              <div className="d-flex justify-content-between align-items-center gap-1">
                                <span className="text-xs font-medium text-slate-400">10 min ago</span>
                                {/* <span className="badge bg-red-500 px-1-5 d-flex align-items-center font-normal leading-none rounded-md end-0">1</span> */}
                              </div>
                            </div>
                            <div className="d-flex align-items-start">
                              <div className="w-10 h-10 me-2 flex-none rounded-lg overflow-hidden">
                                <img src="../assets/images/avatars/8.jpg" alt="" className="w-100 h-100 object-fit-cover" />
                              </div>
                              <div className="d-flex flex-column">
                                <div>
                                  <span className="font-semibold me-2">Mia Alvarez</span>
                                </div>
                                <div className="d-flex flex-column">
                                  <span className="line-clamp-1 text-grey-500">replied to: New expenditures for the entire text</span>
                                  <span className="line-clamp-2 mt-2">Morning! 👋 I just got feedback from marketing. They"d like to see some pop of color in the call-to-action buttons. <a href="#">@Lena Olsson</a> , would you like to take this up?</span>
                                </div>
                              </div>
                            </div>
                          </Link>
                        </li>
                        
                        <li>
                          <Link className="d-flex flex-column row-gap-2 px-4 py-3 text-inherit text-decoration-none">
                            <div className="d-flex justify-content-between align-items-center gap-3">
                              <span className="d-flex align-items-center gap-1 text-grey-600">
                                <i className="bx bx-message-square-detail" ></i> Thread in direct message
                              </span>
                              <div className="d-flex justify-content-between align-items-center gap-1">
                                <span className="text-xs font-medium text-slate-400">5:50pm</span>
                                <span className="badge bg-red-500 px-1-5 d-flex align-items-center font-normal leading-none rounded-md end-0">4</span>
                              </div>
                            </div>
                            <div className="d-flex align-items-start">
                              <div className="w-10 h-10 me-2 flex-none rounded-lg overflow-hidden">
                                <img src="../assets/images/avatars/9.jpg" alt="" className="w-100 h-100 object-fit-cover" />
                              </div>
                              <div className="d-flex flex-column">
                                <div>
                                  <span className="font-semibold me-2">Lena Olsson</span>
                                </div>
                                <div className="d-flex flex-column">
                                  {/* <span className="line-clamp-1 text-grey-500">replied to: New expenditures for the entire text</span> */}
                                  <span className="line-clamp-2 mt-2">Thanks @Lena Olsson! Sure thing, it's called "Modern Muse". I'll drop the lice...</span>
                                </div>
                              </div>
                            </div>
                          </Link>
                        </li>
                        
                        <li>
                          <Link className="d-flex flex-column row-gap-2 px-4 py-3 text-inherit text-decoration-none">
                            <div className="d-flex justify-content-between align-items-center gap-3">
                              <span className="d-flex align-items-center gap-1 text-grey-600">
                                 <i className="bx bx-at"></i> Mention in #product-updates
                              </span>
                              <div className="d-flex justify-content-between align-items-center gap-1">
                                <span className="text-xs font-medium text-slate-400">Yesterday</span>
                                <span className="badge bg-red-500 px-1-5 d-flex align-items-center font-normal leading-none rounded-md end-0">4</span>
                              </div>
                            </div>
                            <div className="d-flex align-items-start">
                              <div className="w-10 h-10 me-2 flex-none rounded-lg overflow-hidden">
                                <img src="../assets/images/avatars/10.jpg" alt="" className="w-100 h-100 object-fit-cover" />
                              </div>
                              <div className="d-flex flex-column">
                                <div>
                                  <span className="font-semibold me-2">Hardeep Kaur</span>
                                </div>
                                <div className="d-flex flex-column">
                                  {/* <span className="line-clamp-1 text-grey-500">replied to: New expenditures for the entire text</span> */}
                                  <span className="line-clamp-2 mt-2">Hola Lena 👋 here’s the file you asked for</span>
                                </div>
                              </div>
                            </div>
                          </Link>
                        </li>
                        
                        <li>
                          <Link className="d-flex flex-column row-gap-2 px-4 py-3 text-inherit text-decoration-none">
                            <div className="d-flex justify-content-between align-items-center gap-3">
                              <span className="d-flex align-items-center gap-1 text-grey-600">
                                 <i className="bx bx-at"></i> Mention in #product-updates
                              </span>
                              <div className="d-flex justify-content-between align-items-center gap-1">
                                <span className="text-xs font-medium text-slate-400">6/7/25</span>
                                <span className="badge bg-red-500 px-1-5 d-flex align-items-center font-normal leading-none rounded-md end-0">4</span>
                              </div>
                            </div>
                            <div className="d-flex align-items-start">
                              <div className="w-10 h-10 me-2 flex-none rounded-lg overflow-hidden">
                                <img src="../assets/images/avatars/11.jpg" alt="" className="w-100 h-100 object-fit-cover" />
                              </div>
                              <div className="d-flex flex-column">
                                <div>
                                  <span className="font-semibold me-2">Derek Nguyen</span>
                                </div>
                                <div className="d-flex flex-column">
                                  {/* <span className="line-clamp-1 text-grey-500">replied to: New expenditures for the entire text</span> */}
                                  <span className="line-clamp-2 mt-2">Thank you for kicking this off @Lena Olsson. Feel free to send that request...</span>
                                </div>
                              </div>
                            </div>
                          </Link>
                        </li>
                      </ul>
                    </Tab.Pane>
                    <Tab.Pane eventKey="threads">Tab content for Threads</Tab.Pane>
                    <Tab.Pane eventKey="reactions">Tab content for Reactions</Tab.Pane>
                    <Tab.Pane eventKey="more">Tab content for Settings</Tab.Pane>
                  </Tab.Content>
                </Tab.Container>
              </div>
            </div>
          </div>
          <div className="w-100 d-flex flex-column">
            <div className="d-flex flex-column position-sticky top-0 z-10">
              <div className="px-4 pb-3 w-100 d-flex justify-content-between align-items-center border-bottom border-grey-200 bg-white">
                <div className="d-flex align-items-center">
                  <div className="input-group">
                    <span className="input-group-text border-transparent bg-white pe-0" id="basic-addon1"><i className="bx bx-lock-alt"></i></span>
                    <select name="" id="" className="form-select border-transparent font-semibold ps-1">
                      <option value="">approval-team</option>
                    </select>
                  </div>
                </div>
                <div className="d-flex align-items-center gap-3">
                  <div className="d-flex align-items-center border rounded-md w-100">
                    <button className="px-2 py-2 border-0 bg-transparent border-end d-flex justify-content-center align-items-center text-grey-500">
                      <i className="bx bx-search text-xl"></i>
                    </button>
                    <button className="px-2 py-2 border-0 bg-transparent d-flex justify-content-center align-items-center text-grey-500">
                      <i className="bx bx-chevron-right text-xl"></i>
                    </button>
                  </div>

                  <div className="d-flex align-items-center border rounded-md w-100 px-2 py-1">
                    <div className="avatar-group d-flex align-items-center -space-x-3">
                      <div className="avatar rounded-full border-2 border-white bg-primary d-flex justify-content-center align-items-center flex-shrink-0 flex-grow-0 w-8 h-8 overflow-hidden border border-2 border-white bg-grey-100">
                        <img src="../assets/images/avatars/8.jpg" alt="Avatar 1" className="w-full h-full object-cover" />
                      </div>
                      <div className="avatar rounded-full border-2 border-white bg-primary d-flex justify-content-center align-items-center flex-shrink-0 flex-grow-0 w-8 h-8 overflow-hidden border border-2 border-white bg-grey-100">
                        <img src="../assets/images/avatars/6.jpg" alt="Avatar 1" className="w-full h-full object-cover" />
                      </div>
                      <div className="avatar rounded-full border-2 border-white bg-primary d-flex justify-content-center align-items-center flex-shrink-0 flex-grow-0 w-8 h-8 overflow-hidden border border-2 border-white bg-grey-100">
                        <img src="../assets/images/avatars/5.jpg" alt="Avatar 1" className="w-full h-full object-cover" />
                      </div>
                      <div className="avatar text-sm fw-bold text-gray-600 d-flex justify-content-center align-items-center flex-shrink-0 flex-grow-0 w-8 h-8 rounded-full border border-2 border-white bg-grey-100">8</div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="px-4 py-2 w-100 d-flex justify-content-between align-items-center border-bottom border-grey-200 bg-grey-50">
                <div className="d-flex align-items-center">
                  <div className="input-group input-group-sm bg-grey-100 rounded-md">
                    <span className="input-group-text border-transparent bg-grey-100 pe-0" id="basic-addon1"><i className="bx bx-pin"></i></span>
                    <select name="" id="" className="form-select border-transparent font-medium ps-1 text-grey-500 bg-grey-100">
                      <option value="">5 pinned</option>
                    </select>
                  </div>  
                
                  <div>
                    <button type="button" className="d-inline-flex align-items-center gap-1 text-nowrap font-medium text-grey-700 border-transparent bg-transparent">
                      <i className="bx bx-plus-circle"></i> Add a bookmark
                    </button>
                  </div>  
                </div>
              </div>
            </div>

            <div className="p-4 connect-post-msg">
              <ul className="connect-msg list-unstyled mb-4 d-flex flex-column row-gap-3 overflow-y-auto">
                <li>
                  <div className="d-flex align-items-start">
                    <div className="w-10 h-10 me-2 flex-none rounded-lg overflow-hidden">
                      <img src="../assets/images/avatars/8.jpg" alt="" className="w-100 h-100 object-fit-cover" />
                    </div>
                    <div className="d-flex flex-column">
                      <div>
                        <span className="font-semibold me-2">Dann Parker</span> <span className="text-xs font-medium text-slate-400">4:37pm</span>
                      </div>
                      <p>Hardeep, can you share the specific shades they had in mind? Meanwhile, @Tasha Smith, the font you used in the last mockup was spot on! Can we reuse?</p>
                    </div>
                  </div>
                </li>
                <li>
                  <div className="d-flex align-items-start">
                    <div className="w-10 h-10 me-2 flex-none rounded-lg overflow-hidden">
                      <img src="../assets/images/avatars/8.jpg" alt="" className="w-100 h-100 object-fit-cover" />
                    </div>
                    <div className="d-flex flex-column">
                      <div>
                        <span className="font-semibold me-2">Mia Alvarez</span> <span className="text-xs font-medium text-slate-400">4:42 pm</span>
                      </div>
                      <p>Morning! 👋 I just got feedback from marketing. They'd like to see some pop of color in the call-to-action buttons. <a href="#">@Lena Olsson</a> , would you like to take this up?</p>
                    </div>
                  </div>
                </li>
                <li className="py-3">
                  <div className="time-divider position-relative text-center">
                    <span className="ps-3 pe-2 py-1 text-xs font-medium text-grey-500 rounded-pill border border-grey-200 bg-white position-relative z-1">Yesterday <i className="bx bx-chevron-down"></i></span>
                  </div>
                </li>
                <li>
                  <div className="d-flex align-items-start">
                    <div className="w-10 h-10 me-2 flex-none rounded-lg overflow-hidden">
                      <img src="../assets/images/avatars/8.jpg" alt="" className="w-100 h-100 object-fit-cover" />
                    </div>
                    <div className="d-flex flex-column">
                      <div>
                        <span className="font-semibold me-2">Gabriella Kim</span> <span className="text-xs font-medium text-slate-400">2:37pm</span>
                      </div>
                      <p>Team! Reminder about our brainstorm at 3 PM. Looking forward to some fresh ideas!</p>

                      <div className="max-w-400 d-flex align-items-center gap-2 border rounded-md w-100 px-2 py-1 mt-2">
                        <div className="avatar-group d-flex align-items-center -space-x-3">
                          <div className="avatar rounded-full border-2 border-white bg-primary d-flex justify-content-center align-items-center flex-shrink-0 flex-grow-0 w-8 h-8 overflow-hidden border border-2 border-white bg-grey-100">
                            <img src="../assets/images/avatars/8.jpg" alt="Avatar 1" className="w-full h-full object-cover" />
                          </div>
                          <div className="avatar rounded-full border-2 border-white bg-primary d-flex justify-content-center align-items-center flex-shrink-0 flex-grow-0 w-8 h-8 overflow-hidden border border-2 border-white bg-grey-100">
                            <img src="../assets/images/avatars/6.jpg" alt="Avatar 1" className="w-full h-full object-cover" />
                          </div>
                          <div className="avatar rounded-full border-2 border-white bg-primary d-flex justify-content-center align-items-center flex-shrink-0 flex-grow-0 w-8 h-8 overflow-hidden border border-2 border-white bg-grey-100">
                            <img src="../assets/images/avatars/5.jpg" alt="Avatar 1" className="w-full h-full object-cover" />
                          </div>
                          <div className="avatar text-sm fw-bold text-gray-600 d-flex justify-content-center align-items-center flex-shrink-0 flex-grow-0 w-8 h-8 rounded-full border border-2 border-white bg-grey-100">4</div>
                        </div>
                        <div className="d-flex align-items-center gap-3">
                          <span className="text-primary-500 font-medium">4 replies </span>
                          <Link className="text-grey-500 font-medium text-decoration-none">View thread</Link>
                        </div>
                        <Link className="ms-auto d-flex align-items-center text-decoration-none text-grey-400"><i className="bx bx-chevron-right bx-sm"></i></Link>
                      </div>
                    </div>
                  </div>
                </li>
                <li>
                  <div className="d-flex align-items-start">
                    <div className="w-10 h-10 me-2 flex-none rounded-lg overflow-hidden">
                      <img src="../assets/images/avatars/8.jpg" alt="" className="w-100 h-100 object-fit-cover" />
                    </div>
                    <div className="d-flex flex-column">
                      <div>
                        <span className="font-semibold me-2">Gabriella Kim</span> <span className="text-xs font-medium text-slate-400">2:40pm</span>
                      </div>
                      <p>Team! Reminder about our brainstorm at 3 PM. Looking forward to some fresh ideas!</p>
                    </div>
                  </div>
                </li>
                <li>
                  <div className="d-flex align-items-start">
                    <div className="w-10 h-10 me-2 flex-none rounded-lg overflow-hidden">
                      <img src="../assets/images/avatars/5.jpg" alt="" className="w-100 h-100 object-fit-cover" />
                    </div>
                    <div className="d-flex flex-column">
                      <div>
                        <span className="font-semibold me-2">Isaac Goldberg</span> <span className="text-xs font-medium text-slate-400">2:45 pm</span>
                      </div>
                      <p>Quick question: Who was behind the tablet designs? Need to discuss a small tweak.</p>
                    </div>
                  </div>
                </li>
                <li>
                  <div className="d-flex align-items-start">
                    <div className="w-10 h-10 me-2 flex-none rounded-lg overflow-hidden">
                      <img src="../assets/images/avatars/5.jpg" alt="" className="w-100 h-100 object-fit-cover" />
                    </div>
                    <div className="d-flex flex-column">
                      <div>
                        <span className="font-semibold me-2">Isaac Goldberg</span> <span className="text-xs font-medium text-slate-400">4:37pm</span>
                      </div>
                      <p><strong>Quick question:</strong> Who was behind the tablet designs? Need to discuss a small tweak.</p>
                    </div>
                  </div>
                </li>
                <li>
                  <div className="d-flex align-items-start">
                    <div className="w-10 h-10 me-2 flex-none rounded-lg overflow-hidden">
                      <img src="../assets/images/avatars/5.jpg" alt="" className="w-100 h-100 object-fit-cover" />
                    </div>
                    <div className="d-flex flex-column">
                      <div>
                        <span className="font-semibold me-2">Isaac Goldberg</span> <span className="text-xs font-medium text-slate-400">5:45 pm</span>
                      </div>
                      <p>Quick question: Who was behind the tablet designs? Need to discuss a small tweak.</p>
                    </div>
                  </div>
                </li>

                <li className="py-3">
                  <div className="time-divider position-relative text-center">
                    <span className="ps-3 pe-2 py-1 text-xs font-medium text-grey-500 rounded-pill border border-grey-200 bg-white position-relative z-1">Today <i className="bx bx-chevron-down"></i></span>
                  </div>
                </li>
                <li>
                  <div className="d-flex align-items-start">
                    <div className="w-10 h-10 me-2 flex-none rounded-lg overflow-hidden">
                      <img src="../assets/images/avatars/12.jpg" alt="" className="w-100 h-100 object-fit-cover" />
                    </div>
                    <div className="d-flex flex-column">
                      <div>
                        <span className="font-semibold me-2">Dann Cox</span> <span className="text-xs font-medium text-slate-400">10 min ago</span>
                      </div>
                      <p>Team! Reminder about our brainstorm at 3 PM. Looking forward to some fresh ideas!</p>

                      <ul className="list-unstyled d-inline-flex gap-2 mt-2">
                        <li>
                          <span className="px-2 py-0-5 d-inline-flex align-items-center gap-1 text-xs font-medium rounded text-red-500 bg-red-100">
                            <i className="bx bx-message-alt-error text-base"></i> Urgent
                          </span>
                        </li>
                        <li>
                          <span className="px-2 py-0-5 d-inline-flex align-items-center gap-1 text-xs font-medium rounded text-grey-500 bg-grey-100">
                            <img src="../assets/images/icons/date-time-calendar.svg" alt="" /> Response required in <strong>2 hours, 13 mins</strong>
                          </span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </li>
                <li>
                  <div className="d-flex align-items-start">
                    <div className="w-10 h-10 me-2 flex-none rounded-lg overflow-hidden">
                      <img src="../assets/images/avatars/12.jpg" alt="" className="w-100 h-100 object-fit-cover" />
                    </div>
                    <div className="d-flex flex-column">
                      <div>
                        <span className="font-semibold me-2">Dann Cox</span> <span className="text-xs font-medium text-slate-400">Now</span>
                      </div>
                      <p>Does anyone know how to recover the "Foundations" project in Figma? 🙈</p>
                    </div>
                  </div>
                </li>
              </ul>
              <div>
                <textarea name="" id="" className="form-control"></textarea>
              </div>
            </div>
          </div>
        </div>
      </div>
      

      <div className="row align-items-start">
        <div className="col-xl-9 col-lg-9 col-md-12 col-sm-12 col-12">
          <div className="d-flex flex-column row-gap-3">
            <div className="rounded-lg border border-grey-200 bg-white">
              <div className="cover-img-box w-100 h-32 rounded-xl overflow-hidden">
                <img src="/assets/images/profile-cover-img.jpg" alt="" className="w-100 h-100 object-fit-cover" />
              </div>
              <div className="p-4 d-flex flex-column row-gap-2 -mt-14 w-100">
                <div className="d-flex align-items-end gap-3">
                  <div className="profile-user-img w-28 h-28 rounded-circle border border-4 border-yellow-500 overflow-hidden">
                    <img src="/assets/images/avatars/5.jpg" alt="" className="w-100 h-100 object-fit-cover"/>
                  </div>
                  <div className="ms-auto">
                    <ul className="list-unstyled mb-0 d-flex flex-wrap align-items-center gap-2">
                      <li>
                        <button type="button" className="w-9 h-9 text-xl text-grey-600 d-flex justify-content-center align-items-center rounded-lg border border-grey-200 bg-white"><i className="bx bx-dots-horizontal-rounded"></i></button>
                      </li>
                      <li>
                        <button type="button" className="w-9 h-9 text-xl text-grey-600 d-flex justify-content-center align-items-center rounded-lg border border-grey-200 bg-white"><i className="bx bx-user-plus"></i></button>
                      </li>
                      <li>
                        <button type="button" className="w-9 h-9 text-xl text-grey-600 d-flex justify-content-center align-items-center rounded-lg border border-grey-200 bg-white"><i className='bx bx-note' ></i></button>
                      </li>
                      <li>
                        <button type="button" className="btn btn-primary rounded-lg d-inline-flex align-items-center gap-1">
                          <i className="bx bx-envelope"></i> Email
                        </button>
                      </li>
                      <li>
                        <button type="button" className="btn btn-gray-light rounded-lg d-inline-flex align-items-center gap-1">
                          <i className="bx bx-pencil"></i> Edit
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>
              
                <div>
                  <ul className="mb-0 list-unstyled d-inline-flex flex-wrap gap-2">
                    <li><h3 className="mb-0 text-lg font-semibold text-grey-800">Stacy Neprokin</h3></li>
                    <li className="text-grey-300">|</li>
                    <li><span>Delhi University, Batch of 2025</span></li>
                  </ul>                  
                </div>

                <div className="last-online text-sm">
                  <span className="text-grey-500 me-2">Last Online</span> <span className="font-medium">Last Online April 25, 2025</span>
                </div>

                <div>
                  <ul className="mb-0 list-unstyled d-inline-flex flex-wrap gap-3">
                    <li>
                      <span className="d-flex align-items-center gap-1"><i className="bx bx-briefcase"></i> Internship Seeker</span></li>
                    <li><span className="d-flex align-items-center gap-1"><i className="bx bx-map"></i> Delhi, India</span></li>
                    <li><span className="d-flex align-items-center gap-1"><i className="bx bx-link-alt"></i> myprofile.com</span></li>
                    <li><span className="d-flex align-items-center gap-1"><i className="bx bx-calendar-check"></i> Available from May 2025</span></li>
                  </ul>                  
                </div>

                <div>
                  <span><span className="font-semibold">143</span> in Network</span>
                </div>

              </div>
            </div>

            <div className="p-4 rounded-lg border border-grey-200 bg-white">
              <h4 className="mb-0 text-md font-semibold text-grey-800">Resume</h4>
              <span className="text-primary-600">Request updated resume</span>
              <ul className="resume-uploaded-list list-unstyled mt-3 mb-0 d-flex flex-column justify-content-center row-gap-2">
                <li>
                  <a href="#" className="p-3 rounded-lg border border-primary-200 bg-primary-50 d-flex justify-content-between align-items-center gap-3 text-decoration-none">
                    <div>
                      <h5 className="mb-1 text-base font-semibold text-grey-800">arifa_ux_resume_2025</h5>
                      <span className="text-sm text-grey-500">Uploaded on March 2025</span>
                    </div>
                    <div className="d-flex align-items-center gap-1">
                      <button type="button" className="border-0 bg-transparent text-xl text-grey-800"><i className="bx bx-download"></i></button>
                      <button type="button" className="border-0 bg-transparent text-xl text-grey-800"><i className="bx bx-trash"></i></button>
                    </div>
                  </a>
                </li>
                <li>
                  <a href="#" className="p-3 rounded-lg border border-primary-200 bg-primary-50 d-flex justify-content-between align-items-center gap-3 text-decoration-none">
                    <div>
                      <h5 className="mb-1 text-base font-semibold text-grey-800">arifa_ux_resume_2025</h5>
                      <span className="text-sm text-grey-500">Uploaded on March 2025</span>
                    </div>
                    <div className="d-flex align-items-center gap-1">
                      <button type="button" className="border-0 bg-transparent text-xl text-grey-800"><i className="bx bx-download"></i></button>
                      <button type="button" className="border-0 bg-transparent text-xl text-grey-800"><i className="bx bx-trash"></i></button>
                    </div>
                  </a>
                </li>
              </ul>
            </div>

            <div className="p-4 rounded-lg border border-grey-200 bg-white d-flex flex-column gap-0">
              <div className="d-flex justify-content-between align-items-center gap-3 mb-3">
                <h4 className="text-md font-semibold text-grey-800">About Me</h4>
                <div className="d-flex align-items-center gap-1">
                  <button type="button" className="btn btn-gray-light rounded-lg d-inline-flex align-items-center gap-1 border-transparent">
                    <i className="bx bx-pencil"></i> Edit
                  </button>
                  <button type="button" className="p-0 w-8 h-8 text-grey-500 d-flex justify-content-center align-items-center border-0 bg-transparent">
                    <i className="bx bx-grid-alt bx-sm"></i>
                  </button>
                </div>
              </div>
              <div>
                <p>My research focuses on genome-editing strategies for monogenic diseases. At Cambridge, I developed CRISPR-Cas12a interventions for β-thalassemia and led single-cell RNA-seq analysis to identify transcriptional regulators. I aim to bridge lab research and clinical applications in gene therapy, with long-term goals of leading a lab at the intersection of synthetic biology and precision medicine.</p>
              </div>
            </div>

            <div className="p-4 rounded-lg border border-grey-200 bg-white d-flex flex-column gap-0">
              <div className="d-flex justify-content-between align-items-center gap-3">
                <h4 className="text-md font-semibold text-grey-800">Experience & Highlights</h4>
                <div className="d-flex align-items-center gap-1">
                  <button type="button" className="btn btn-gray-light rounded-lg d-inline-flex align-items-center gap-1 border-transparent" onClick={handleShow}>
                    <i className="bx bx-pencil"></i> Edit
                  </button>
                  <button type="button" className="p-0 w-8 h-8 text-grey-500 d-flex justify-content-center align-items-center border-0 bg-transparent">
                    <i className="bx bx-grid-alt bx-sm"></i>
                  </button>
                </div>
              </div>
              <ul className="exp-highlight-list list-unstyled mb-0 d-flex flex-column justify-content-center row-gap-1">
                <li>
                  <div className="d-flex flex-wrap gap-3 py-4">
                    <div className="w-16 h-16 flex-auto rounded-circle overflow-hidden d-flex justify-content-center align-items-center bg-grey-100">
                      <img src="/assets/images/avatars/7.jpg" alt="" className="w-100 h-100 object-fit-cover"/>
                    </div>
                    <div className="d-flex flex-column gap-2">
                      <h5 className="mb-0 text-sm font-semibold text-grey-800">Marketing Intern <small className="px-2 py-1 text-xs rounded-md badge badge-green-500">Internship</small></h5>
                      <span>Freshwave Media, Bangalore, India</span>
                      <span>May 2024 - July 2024(<strong>4 months</strong>)</span>
                      <span>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed dapibus eros eu vehicula interdum. Cras nec ultricies massa. Curabitur rutrum, diam id consequat consequat</span>
                    </div>
                  </div>
                </li>
                <li>
                  <div className="d-flex flex-wrap gap-3 py-4">
                    <div className="w-16 h-16 flex-auto rounded-circle overflow-hidden d-flex justify-content-center align-items-center bg-grey-100">
                      <img src="/assets/images/avatars/7.jpg" alt="" className="w-100 h-100 object-fit-cover"/>
                    </div>
                    <div className="d-flex flex-column gap-2">
                      <h5 className="mb-0 text-sm font-semibold text-grey-800">Marketing Intern <small className="px-2 py-1 text-xs rounded-lg badge badge-purple-500">Internship</small></h5>
                      <span>Freshwave Media, Bangalore, India</span>
                      <span>May 2024 - July 2024(<strong>4 months</strong>)</span>
                      <span>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed dapibus eros eu vehicula interdum. Cras nec ultricies massa. Curabitur rutrum, diam id consequat consequat</span>
                    </div>
                  </div>
                </li>
              </ul>
            </div>

            <Modal show={show} onHide={handleClose} className="highlightsModal">
              <Modal.Header closeButton>
                <Modal.Title className="text-md font-medium">Experience & Highlights</Modal.Title>
                
                <Button className="ms-auto bg-grey-50 border border-grey-200 text-grey-800">
                  <i className="bx bx-plus"></i> Add
                </Button>
              </Modal.Header>
              <Modal.Body>
                <Accordion defaultActiveKey="0" className="accordion-style-three">
                  <Accordion.Item eventKey="0" className="border-bottom rounded-0">
                    <Accordion.Header className="px-0">
                      <div className="d-flex w-100 justify-content-between align-items-center">
                        <span className="text-base font-medium">Marketing Intern</span>
                        <div className="d-flex align-items-center gap-1 mr-5">
                          <Button
                            size="sm"
                            // variant="success"
                            className="btn-transparent text-md text-grey-800 w-6 h-6 d-flex justify-centent-center align-items-center p-0"
                            onClick={(e) => {
                              e.stopPropagation();
                              alert("Add clicked");
                            }}
                          >
                            <i className="bx bx-trash"></i>
                          </Button>
                          <Button
                            size="sm"
                            // variant="primary"
                            className="btn-transparent text-md text-grey-800 w-6 h-6 d-flex justify-centent-center align-items-center p-0"
                            onClick={(e) => {
                              e.stopPropagation();
                              alert("Edit clicked");
                            }}
                          >
                            <i className="bx bx-pencil"></i>
                          </Button>
                        </div>
                      </div>
                    </Accordion.Header>
                    <Accordion.Body>
                      <div className="row">
                        <div className="col-md-12 col-sm-12 col-12">
                          <div className="mb-3">
                            <label for="OrganizationInput" className="form-label">Company/Organization</label>
                            <input type="text" className="form-control" id="OrganizationInput" placeholder="Freshwave Media" />
                          </div>
                        </div>
                      
                        <div className="col-md-12 col-sm-12 col-12">
                          <div className="mb-3">
                            <label for="ExperienceInput" className="form-label">Experience Type</label>
                            <select className="form-select" id="ExperienceInput" aria-label="Default select example">
                              <option selected>Open this select menu</option>
                              <option value="1">One</option>
                              <option value="2">Two</option>
                              <option value="3">Three</option>
                            </select>
                          </div>
                        </div>
                        <div className="col-md-12 col-sm-12 col-12">
                          <div className="mb-3">
                            <label for="LocationInput" className="form-label">Location</label>
                            <div className="input-group">
                              <input type="text" className="form-control" id="LocationInput" placeholder="Freshwave Media" />
                              <span className="input-group-text" id="basic-addon2"><i className="bx bx-map"></i></span>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6 col-sm-6 col-12">
                          <div className="mb-3">
                            <label for="StartdateInput" className="form-label">Start date</label>
                            <input type="date" className="form-control" id="StartdateInput" placeholder="Freshwave Media" />
                          </div>
                        </div>
                        <div className="col-md-6 col-sm-6 col-12">
                          <div className="mb-3">
                            <label for="EndtdateInput" className="form-label">End date</label>
                            <input type="date" className="form-control" id="EndtdateInput" placeholder="Freshwave Media" />
                          </div>
                        </div>
                        <div className="col-md-12 col-sm-12 col-12">
                          <div className="mb-3">
                            <label for="ResponsibilityInput" className="form-label">Responsibility</label>
                            <textarea  type="text" className="form-control" id="ResponsibilityInput" placeholder="Message" rows="3"></textarea>
                          </div>
                        </div>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="1">
                    <Accordion.Header>
                      <div className="d-flex w-100 justify-content-between align-items-center">
                        <span className="text-base font-medium">Product Design Intern</span>
                        <div className="d-flex align-items-center gap-1 mr-5">
                          <Button
                            size="sm"
                            // variant="success"
                            className="btn-transparent text-md text-grey-800 w-6 h-6 d-flex justify-centent-center align-items-center p-0"
                            onClick={(e) => {
                              e.stopPropagation();
                              alert("Add clicked");
                            }}
                          >
                            <i className="bx bx-trash"></i>
                          </Button>
                          <Button
                            size="sm"
                            // variant="primary"
                            className="btn-transparent text-md text-grey-800 w-6 h-6 d-flex justify-centent-center align-items-center p-0"
                            onClick={(e) => {
                              e.stopPropagation();
                              alert("Edit clicked");
                            }}
                          >
                            <i className="bx bx-pencil"></i>
                          </Button>
                        </div>
                      </div>
                    </Accordion.Header>
                    <Accordion.Body>
                      Product Design Intern
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="primary" onClick={handleClose}>
                  Save
                </Button>
              </Modal.Footer>
            </Modal>

            <div className="p-4 rounded-lg border border-grey-200 bg-white d-flex flex-column gap-0">
              <div className="d-flex justify-content-between align-items-center gap-3">
                <h4 className="text-md font-semibold text-grey-800">Education</h4>
                <div className="d-flex align-items-center gap-1">
                  <button type="button" className="btn btn-gray-light rounded-lg d-inline-flex align-items-center gap-1 border-transparent">
                    <i className="bx bx-pencil"></i> Edit
                  </button>
                  <button type="button" className="p-0 w-8 h-8 text-grey-500 d-flex justify-content-center align-items-center border-0 bg-transparent">
                    <i className="bx bx-grid-alt bx-sm"></i>
                  </button>
                </div>
              </div>
              
              <ul className="exp-highlight-list list-unstyled mb-0 d-flex flex-column justify-content-center row-gap-1">
                <li>
                  <div className="d-flex flex-wrap gap-3 py-4">
                    <div className="w-16 h-16 flex-auto rounded-circle overflow-hidden d-flex justify-content-center align-items-center bg-grey-100">
                      <img src="/assets/images/avatars/7.jpg" alt="" className="w-100 h-100 object-fit-cover"/>
                    </div>
                    <div className="d-flex flex-column gap-2">
                      <h5 className="mb-0 text-sm font-semibold text-grey-800">Degree | Bachelor of Business Administration (B.B.A)</h5>
                      <span>Delhi University, Delhi</span>
                      <span>August 2020 - June 2024</span>
                      <span>GPA: 3.7/4.0</span>
                    </div>
                  </div>
                </li>
                <li>
                  <div className="d-flex flex-wrap gap-3 py-4">
                    <div className="w-16 h-16 flex-auto rounded-circle overflow-hidden d-flex justify-content-center align-items-center bg-grey-100">
                      <img src="/assets/images/avatars/7.jpg" alt="" className="w-100 h-100 object-fit-cover"/>
                    </div>
                    <div className="d-flex flex-column gap-2">
                      <h5 className="mb-0 text-sm font-semibold text-grey-800">Certificate | UX Design Professional Certificate</h5>
                      <span>Google Career Certificates, Coursera</span>
                      <span>March 2024</span>
                      <span>Credential ID: 1234-5678-UXD</span>
                    </div>
                  </div>
                </li>
              </ul>
            </div>            

            <div className="p-4 rounded-lg border border-grey-200 bg-white d-flex flex-column gap-0">
              <div className="d-flex justify-content-between align-items-center gap-3 mb-3">
                <h4 className="text-md font-semibold text-grey-800">Research Summary Section</h4>
                <div className="d-flex align-items-center gap-1">
                  <button type="button" className="btn btn-gray-light rounded-lg d-inline-flex align-items-center gap-1 border-transparent">
                    <i className="bx bx-pencil"></i> Edit
                  </button>
                  <button type="button" className="p-0 w-8 h-8 text-grey-500 d-flex justify-content-center align-items-center border-0 bg-transparent">
                    <i className="bx bx-grid-alt bx-sm"></i>
                  </button>
                </div>
              </div>
              <div>
                <p>My research focuses on genome-editing strategies for monogenic diseases. At Cambridge, I developed CRISPR-Cas12a interventions for β-thalassemia and led single-cell RNA-seq analysis to identify transcriptional regulators. I aim to bridge lab research and clinical applications in gene therapy, with long-term goals of leading a lab at the intersection of synthetic biology and precision medicine.</p>
              </div>
            </div>

            <div className="p-4 rounded-lg border border-grey-200 bg-white d-flex flex-column gap-0">
              <div className="d-flex justify-content-between align-items-center gap-3">
                <h4 className="text-md font-semibold text-grey-800">Publications</h4>
                <div className="d-flex align-items-center gap-1">
                  <button type="button" className="btn btn-gray-light rounded-lg d-inline-flex align-items-center gap-1 border-transparent">
                    <i className="bx bx-pencil"></i> Edit
                  </button>
                  <button type="button" className="p-0 w-8 h-8 text-grey-500 d-flex justify-content-center align-items-center border-0 bg-transparent">
                    <i className="bx bx-grid-alt bx-sm"></i>
                  </button>
                </div>
              </div>
              
              <ul className="exp-highlight-list list-unstyled mb-0 d-flex flex-column justify-content-center row-gap-1">
                <li>
                  <div className="d-flex flex-wrap justify-content-between gap-3 py-4">
                    <div className="d-flex flex-column gap-2">
                      <h5 className="mb-0 text-sm font-semibold text-grey-800">CRISPR-Cas12a as a Targeted Therapeutic in β-Thalassemia</h5>
                      <span>Cell, 2024 - <span className="font-bold text-primary-800">DOI</span></span>
                    </div>
                    <button type="button" className="bg-transparent border-0 text-lg text-primary-800">
                      <i className="bx bx-expand-alt"></i>
                    </button>
                  </div>
                </li>
                <li>
                  <div className="d-flex flex-wrap justify-content-between gap-3 py-4">
                    <div className="d-flex flex-column gap-2">
                      <h5 className="mb-0 text-sm font-semibold text-grey-800">Single-cell RNA-Seq Uncovers Genetic Circuitry of Fetal Hemoglobin Induction</h5>
                      <span>Nature, 2023 - <span className="font-bold text-primary-800">DOI</span></span>
                    </div>
                    <button type="button" className="bg-transparent border-0 text-lg text-primary-800">
                      <i className="bx bx-expand-alt"></i>
                    </button>
                  </div>
                </li>
                <li>
                  <div className="d-flex flex-wrap justify-content-between gap-3 py-4">
                    <div className="d-flex flex-column gap-2">
                      <h5 className="mb-0 text-sm font-semibold text-grey-800">Zebrafish as a Model for In Vivo Genome Engineering</h5>
                      <span>Developmental Genetics, 2019 - <span className="font-bold text-primary-800">DOI</span></span>
                    </div>
                    <button type="button" className="bg-transparent border-0 text-lg text-primary-800">
                      <i className="bx bx-expand-alt"></i>
                    </button>
                  </div>
                </li>
              </ul>
            </div>

            <div className="p-4 rounded-lg border border-grey-200 bg-white d-flex flex-column gap-0">
              <div className="d-flex justify-content-between align-items-center gap-3">
                <h4 className="text-md font-semibold text-grey-800">Grants & Funding</h4>
                <div className="d-flex align-items-center gap-1">
                  <button type="button" className="btn btn-gray-light rounded-lg d-inline-flex align-items-center gap-1 border-transparent">
                    <i className="bx bx-pencil"></i> Edit
                  </button>
                  <button type="button" className="p-0 w-8 h-8 text-grey-500 d-flex justify-content-center align-items-center border-0 bg-transparent">
                    <i className="bx bx-grid-alt bx-sm"></i>
                  </button>
                </div>
              </div>
              
              <ul className="exp-highlight-list list-unstyled mb-0 d-flex flex-column justify-content-center row-gap-1">
                <li>
                  <div className="d-flex flex-wrap gap-3 py-4">
                    <div className="w-16 h-16 flex-auto rounded-circle overflow-hidden d-flex justify-content-center align-items-center bg-grey-100">
                      <img src="/assets/images/avatars/7.jpg" alt="" className="w-100 h-100 object-fit-cover"/>
                    </div>
                    <div className="d-flex flex-column gap-2">
                      <h5 className="mb-0 text-sm font-semibold text-grey-800">Wellcome Trust Early Career Fellowship</h5>
                      <span>Principal Investigator</span>
                      <span>Amount: £150,000</span>
                      <span>2023-2025</span>
                    </div>
                  </div>
                </li>
              </ul>
            </div>

            <div className="p-4 rounded-lg border border-grey-200 bg-white d-flex flex-column gap-0">
              <div className="d-flex justify-content-between align-items-center gap-3">
                <h4 className="text-md font-semibold text-grey-800">Recognition & Outreach</h4>
                <div className="d-flex align-items-center gap-1">
                  <button type="button" className="btn btn-gray-light rounded-lg d-inline-flex align-items-center gap-1 border-transparent">
                    <i className="bx bx-pencil"></i> Edit
                  </button>
                  <button type="button" className="p-0 w-8 h-8 text-grey-500 d-flex justify-content-center align-items-center border-0 bg-transparent">
                    <i className="bx bx-grid-alt bx-sm"></i>
                  </button>
                </div>
              </div>
              
              <ul className="list-border-style list-unstyled mb-0 d-flex flex-column justify-content-center row-gap-0">
                <li>
                  <div className="d-flex flex-wrap align-items-center gap-3 py-4">
                    <div className="w-12 h-12 flex-auto rounded-circle overflow-hidden d-flex justify-content-center align-items-center bg-grey-100">
                      <img src="/assets/images/avatars/7.jpg" alt="" className="w-100 h-100 object-fit-cover"/>
                    </div>
                    <div className="d-flex flex-column gap-1">
                      <h5 className="mb-0 text-sm font-semibold text-grey-800">Cambridge Postdoc Excellence Award</h5>
                      <ul className="inline-list-pipe-style list-unstyled d-inline-flex align-items-center">
                        <li>Award</li>
                        <li>2023</li>
                      </ul>
                    </div>
                  </div>
                </li>
                <li>
                  <div className="d-flex flex-wrap align-items-center gap-3 py-4">
                    <div className="w-12 h-12 flex-auto rounded-circle overflow-hidden d-flex justify-content-center align-items-center bg-grey-100">
                      <img src="/assets/images/avatars/7.jpg" alt="" className="w-100 h-100 object-fit-cover"/>
                    </div>
                    <div className="d-flex flex-column gap-1">
                      <h5 className="mb-0 text-sm font-semibold text-grey-800">Cambridge Postdoc Excellence Award</h5>
                      <ul className="inline-list-pipe-style list-unstyled d-inline-flex align-items-center">
                        <li>Award</li>
                        <li>2023</li>
                      </ul>
                    </div>
                  </div>
                </li>
                <li>
                  <div className="d-flex flex-wrap align-items-center gap-3 py-4">
                    <div className="w-12 h-12 flex-auto rounded-circle overflow-hidden d-flex justify-content-center align-items-center bg-grey-100">
                      <img src="/assets/images/avatars/7.jpg" alt="" className="w-100 h-100 object-fit-cover"/>
                    </div>
                    <div className="d-flex flex-column gap-1">
                      <h5 className="mb-0 text-sm font-semibold text-grey-800">Cambridge Postdoc Excellence Award</h5>
                      <ul className="inline-list-pipe-style list-unstyled d-inline-flex align-items-center">
                        <li>Award</li>
                        <li>2023</li>
                      </ul>
                    </div>
                  </div>
                </li>
                <li>
                  <div className="d-flex flex-wrap align-items-center gap-3 py-4">
                    <div className="w-12 h-12 flex-auto rounded-circle overflow-hidden d-flex justify-content-center align-items-center bg-grey-100">
                      <img src="/assets/images/avatars/7.jpg" alt="" className="w-100 h-100 object-fit-cover"/>
                    </div>
                    <div className="d-flex flex-column gap-1">
                      <h5 className="mb-0 text-sm font-semibold text-grey-800">Cambridge Postdoc Excellence Award</h5>
                      <ul className="inline-list-pipe-style list-unstyled d-inline-flex align-items-center">
                        <li>Award</li>
                        <li>2023</li>
                      </ul>
                    </div>
                  </div>
                </li>
              </ul>
            </div>

            <div className="p-4 rounded-lg border border-grey-200 bg-white d-flex flex-column gap-0">
              <div className="d-flex justify-content-between align-items-center gap-3">
                <h4 className="text-md font-semibold text-grey-800">Personal Details</h4>
                <div className="d-flex align-items-center gap-1">
                  <button type="button" className="btn btn-gray-light rounded-lg d-inline-flex align-items-center gap-1 border-transparent">
                    <i className="bx bx-pencil"></i> Edit
                  </button>
                  <button type="button" className="p-0 w-8 h-8 text-grey-500 d-flex justify-content-center align-items-center border-0 bg-transparent">
                    <i className="bx bx-grid-alt bx-sm"></i>
                  </button>
                </div>
              </div>
              <div className="row gy-3">
                <div className="col-md-4 col-sm-6 co-12">
                  <div className="">
                    <label for="dobInput" className="form-label mb-0">Date of Birth</label>
                    {/* <input type="date" className="form-control" id="dobInput" placeholder="name@example.com"/> */}
                    <div className="text-sm font-semibold text-grey-800">March 15, 2002</div>
                  </div>
                </div>
                <div className="col-md-4 col-sm-6 co-12">
                  <div className="">
                    <label for="nationalityInput" className="form-label mb-0">Nationality</label>
                    {/* <select className="form-select" id="nationalityInput" aria-label="Default select example">
                      <option selected>Open this select Nationality</option>
                      <option value="1">Indian</option>
                      <option value="2">Two</option>
                      <option value="3">Three</option>
                    </select> */}
                    <div className="text-sm font-semibold text-grey-800">Indian</div>
                  </div>
                </div>
                <div className="col-md-4 col-sm-6 co-12">
                  <div className="">
                    <label for="langInput" className="form-label mb-0">Language spoken</label>
                    {/* <select className="form-select" id="langInput" aria-label="Default select example">
                      <option selected>Open this select Nationality</option>
                      <option value="1">Indian</option>
                      <option value="2">Two</option>
                      <option value="3">Three</option>
                    </select> */}
                    <div className="text-sm font-semibold text-grey-800">March 15, 2002</div>
                  </div>
                </div>

                <div className="col-md-4 col-sm-6 co-12">
                  <div className="">
                    <label for="dobInput" className="form-label mb-0">Marital  Status</label>
                    {/* <input type="date" className="form-control" id="dobInput" placeholder="name@example.com"/> */}
                    <div className="text-sm font-semibold text-grey-800">Single</div>
                  </div>
                </div>
                <div className="col-md-4 col-sm-6 co-12">
                  <div className="">
                    <label for="nationalityInput" className="form-label mb-0">Current City</label>
                    {/* <select className="form-select" id="nationalityInput" aria-label="Default select example">
                      <option selected>Open this select Nationality</option>
                      <option value="1">Indian</option>
                      <option value="2">Two</option>
                      <option value="3">Three</option>
                    </select> */}
                    <div className="text-sm font-semibold text-grey-800">Hyderabad, India</div>
                  </div>
                </div>
                <div className="col-md-4 col-sm-6 co-12">
                  <div className="">
                    <label for="langInput" className="form-label mb-0">Availability to Start</label>
                    {/* <select className="form-select" id="langInput" aria-label="Default select example">
                      <option selected>Open this select Nationality</option>
                      <option value="1">Indian</option>
                      <option value="2">Two</option>
                      <option value="3">Three</option>
                    </select> */}
                    <div className="text-sm font-semibold text-grey-800">from May 2025</div>
                  </div>
                </div>
                <div className="col-md-4 col-sm-6 co-12">
                  <div className="">
                    <label for="langInput" className="form-label mb-0">Gender</label>
                    {/* <select className="form-select" id="langInput" aria-label="Default select example">
                      <option selected>Open this select Nationality</option>
                      <option value="1">Indian</option>
                      <option value="2">Two</option>
                      <option value="3">Three</option>
                    </select> */}
                    <div className="text-sm font-semibold text-grey-800">Male</div>
                  </div>
                </div>
                <div className="col-md-4 col-sm-6 co-12">
                  <div className="">
                    <label for="langInput" className="form-label mb-0">Relocation Preference</label>
                    {/* <select className="form-select" id="langInput" aria-label="Default select example">
                      <option selected>Open this select Nationality</option>
                      <option value="1">Indian</option>
                      <option value="2">Two</option>
                      <option value="3">Three</option>
                    </select> */}
                    <div className="text-sm font-semibold text-grey-800">Open to relocate within India</div>
                  </div>
                </div>
                <div className="col-md-4 col-sm-6 co-12">
                  <div className="">
                    <label for="langInput" className="form-label mb-0">Remote Work Preference</label>
                    {/* <select className="form-select" id="langInput" aria-label="Default select example">
                      <option selected>Open this select Nationality</option>
                      <option value="1">Indian</option>
                      <option value="2">Two</option>
                      <option value="3">Three</option>
                    </select> */}
                    <div className="text-sm font-semibold text-grey-800">Open to remote internships</div>
                  </div>
                </div>
              </div>
            </div>

            <div className="p-4 rounded-lg border border-grey-200 bg-white">
              <div className="d-flex justify-content-between align-items-center gap-3">
                <h4 className="mb-0 text-md font-semibold text-grey-800">Other Documents</h4>
                <div className="d-flex align-items-center gap-1">
                  {/* <button type="button" className="btn btn-gray-light rounded-lg d-inline-flex align-items-center gap-1 border-transparent">
                    <i className="bx bx-pencil"></i> Edit
                  </button> */}
                  <button type="button" className="p-0 w-8 h-8 text-grey-500 d-flex justify-content-center align-items-center border-0 bg-transparent">
                    <i className="bx bx-grid-alt bx-sm"></i>
                  </button>
                </div>
              </div>
              <ul className="resume-uploaded-list list-unstyled mt-3 mb-0 d-flex flex-column justify-content-center row-gap-2">
                <li>
                  <a href="#" className="p-3 rounded-lg border border-primary-200 bg-primary-50 d-flex justify-content-between align-items-center gap-3 text-decoration-none">
                    <div>
                      <h5 className="mb-1 text-base font-semibold text-grey-800">arifa_ux_resume_2025</h5>
                      <span className="text-sm text-grey-500">Uploaded on March 2025</span>
                    </div>
                    <div className="d-flex align-items-center gap-1">
                      <button type="button" className="border-0 bg-transparent text-xl text-grey-800"><i className="bx bx-download"></i></button>
                      <button type="button" className="border-0 bg-transparent text-xl text-grey-800"><i className="bx bx-trash"></i></button>
                    </div>
                  </a>
                </li>
                <li>
                  <a href="#" className="p-3 rounded-lg border border-primary-200 bg-primary-50 d-flex justify-content-between align-items-center gap-3 text-decoration-none">
                    <div>
                      <h5 className="mb-1 text-base font-semibold text-grey-800">arifa_ux_resume_2025</h5>
                      <span className="text-sm text-grey-500">Uploaded on March 2025</span>
                    </div>
                    <div className="d-flex align-items-center gap-1">
                      <button type="button" className="border-0 bg-transparent text-xl text-grey-800"><i className="bx bx-download"></i></button>
                      <button type="button" className="border-0 bg-transparent text-xl text-grey-800"><i className="bx bx-trash"></i></button>
                    </div>
                  </a>
                </li>
              </ul>
            </div>

            <div className="p-4 rounded-lg border border-grey-200 bg-white">              
              <div className="d-flex justify-content-between align-items-center gap-3">
                <h4 className="mb-0 text-md font-semibold text-grey-800">Online Profile</h4>
                <div className="d-flex align-items-center gap-1">
                  <button type="button" className="btn btn-gray-light rounded-lg d-inline-flex align-items-center gap-1 border-transparent">
                    <i className="bx bx-pencil"></i> Edit
                  </button>
                  <button type="button" className="p-0 w-8 h-8 text-grey-500 d-flex justify-content-center align-items-center border-0 bg-transparent">
                    <i className="bx bx-grid-alt bx-sm"></i>
                  </button>
                </div>
              </div>
              <ul className="resume-uploaded-list list-unstyled mt-3 mb-0 d-flex flex-column justify-content-center row-gap-3">
                <li>
                  <div className="d-flex flex-column row-gap-0">
                    <span>Portfolio Website</span>
                    <a href="#" className="text-medium">myportfolio.com</a>
                  </div>
                </li>
                <li>
                  <div className="d-flex flex-column row-gap-0">
                    <span>LinkedIn Profile</span>
                    <a href="#" className="text-medium">linkedin.com/in/username</a>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12 position-sticky top-lg-20">
          <div className="d-flex flex-column justify-content-center row-gap-3">
            <ul className="list-unstyled d-flex flex-column row-gap-2">
              <li>
                <label className="d-block w-100">
                  <input
                    type="radio"
                    name="requestOption"
                    value="resume"
                    className="d-none peer"
                  />
                  <div className="radio-box p-2 d-flex align-items-center gap-2 rounded-lg border border-grey-200 bg-grey-50 peer-checked:border-primary peer-checked:bg-light">
                    <div className="icon-box w-10 h-10 flex-auto rounded-md text-white bg-primary-800 d-flex justify-content-center align-items-center peer-checked:bg-primary">
                      <i className="bx bxs-file-pdf text-xl"></i>
                    </div>
                    <span className="font-medium">Request Updated Resume</span>
                    <span className="ms-auto d-none radio-check-icon text-lg-2xl text-xl text-green-600">
                      <i className="bx bx-check-circle"></i>
                    </span>
                  </div>
                </label>
              </li>

              <li>
                <label className="d-block w-100">
                  <input
                    type="radio"
                    name="requestOption"
                    value="cover"
                    className="d-none peer"
                  />
                  <div className="radio-box p-2 d-flex align-items-center gap-2 rounded-lg border border-grey-200 bg-grey-50 peer-checked:border-primary peer-checked:bg-light">
                    <div className="icon-box w-10 h-10 flex-auto rounded-md text-white bg-primary-800 d-flex justify-content-center align-items-center peer-checked:bg-primary">
                      <i className="bx bx-note text-xl"></i>
                    </div>
                    <span className="font-medium">Request Cover Letter</span>
                    <span className="ms-auto d-none radio-check-icon text-lg-2xl text-xl text-green-600">
                      <i className="bx bx-check-circle"></i>
                    </span>
                  </div>
                </label>
              </li>

              <li>
                <label className="d-block w-100">
                  <input
                    type="radio"
                    name="requestOption"
                    value="portfolio"
                    className="d-none peer"
                  />
                  <div className="radio-box p-2 d-flex align-items-center gap-2 rounded-lg border border-grey-200 bg-grey-50 peer-checked:border-primary peer-checked:bg-light">
                    <div className="icon-box w-10 h-10 flex-auto rounded-md text-white bg-primary-800 d-flex justify-content-center align-items-center peer-checked:bg-primary">
                      <i className="bx bx-link text-xl"></i>
                    </div>
                    <span className="font-medium">Request Portfolio Link</span>
                    <span className="ms-auto d-none radio-check-icon text-lg-2xl text-xl text-green-600">
                      <i className="bx bx-check-circle"></i>
                    </span>
                  </div>
                </label>
              </li>
            </ul>

            <div className="p-4 rounded-lg border border-grey-200 bg-white d-flex flex-column gap-0">
              <h4 className="text-md font-semibold text-grey-800">Skills</h4>
              <ul className="list-unstyled mb-0 d-inline-flex flex-wrap gap-2">
                <li>
                  <span className="d-inline-block px-4 py-2 text-xs font-medium text-dark rounded-pill bg-grey-100">UX Research</span>
                </li>
                <li>
                  <span className="d-inline-block px-4 py-2 text-xs font-medium text-dark rounded-pill bg-grey-100">Canva</span>
                </li>
                <li>
                  <span className="d-inline-block px-4 py-2 text-xs font-medium text-dark rounded-pill bg-grey-100">SEO</span>
                </li>
                <li>
                  <span className="d-inline-block px-4 py-2 text-xs font-medium text-dark rounded-pill bg-grey-100">Digital Marketing</span>
                </li>
                <li>
                  <span className="d-inline-block px-4 py-2 text-xs font-medium text-dark rounded-pill bg-grey-100">Figma</span>
                </li>
              </ul>
            </div>

            <div className="p-4 rounded-lg border border-grey-200 bg-white d-flex flex-column gap-0">
              <h4 className="text-md font-semibold text-grey-800">Career Interest</h4>

              <ul className="careerInterest-list list-unstyled mb-0 d-flex flex-column">
                <li className="py-3">
                  <div className="">
                    <label className="form-label mb-0">Preferred Industries</label>
                    <div className="text-sm font-medium text-grey-800">
                      <ul className="careerlink-list list-unstyled mb-0 d-inline-flex flex-wrap">
                        <li><a href="#">Media</a></li>
                        <li><a href="#">Tech</a></li>
                        <li><a href="#">Finance</a></li>
                      </ul>
                    </div>
                  </div>
                </li>
                <li className="py-3">
                  <div className="">
                    <label className="form-label mb-0">Internship Type</label>
                    <div className="text-sm font-medium text-grey-800">
                      <ul className="careerlink-list list-unstyled mb-0 d-inline-flex flex-wrap">
                        <li><a href="#">Remote</a></li>
                        <li><a href="#">On-site</a></li>
                        <li><a href="#">Hybrid</a></li>
                      </ul>
                    </div>
                  </div>
                </li>
                <li className="py-3">
                  <div className="">
                    <label className="form-label mb-0">Availability</label>
                    <div className="text-sm font-medium text-grey-800">
                      <ul className="careerlink-list list-unstyled mb-0 d-inline-flex flex-wrap">
                        <li><a href="#">May–July 2025</a></li>
                      </ul>
                    </div>
                  </div>
                </li>
                <li className="py-3">
                  <div className="">
                    <label className="form-label mb-0">Open to</label>
                    <div className="text-sm font-medium text-grey-800">
                      <ul className="careerlink-list list-unstyled mb-0 d-inline-flex flex-wrap">
                        <li><a href="#">Internship</a></li>
                        <li><a href="#">Part-time</a></li>
                        <li><a href="#">Volunteering</a></li>
                      </ul>
                    </div>
                  </div>
                </li>
              </ul>
              
            </div>

            <div className="p-4 rounded-lg border border-orange-200 bg-orange-50">
              <div className="card-body">
                <h5 className="text-base fw-bold mb-2">You're Just a Few Steps Away from Getting Noticed!</h5>
                <p className="mb-3">Finish setting up your profile.</p>

                <div className="position-relative mb-2">
                  <div className="progress h-2">
                    <div
                      className="progress-bar bg-gredient-orange"
                      role="progressbar"
                      style={{ width: "70%" }}
                      aria-valuenow="70"
                      aria-valuemin="0"
                      aria-valuemax="100"
                    ></div>
                  </div>
                  <div
                    className="position-absolute top-50 translate-middle-y"
                    style={{ left: "70%" }}
                  >
                    <i className="bi bi-exclamation-triangle-fill text-warning"></i>
                  </div>
                </div>

                <div className="mb-3">
                  <strong>Profile Completion:</strong> 70%
                </div>
                <small className="text-muted">
                  Profiles with 90%+ completion get shortlisted 3x faster.
                </small>
              </div>
            </div>

            <div className="p-4 rounded-lg border border-grey-200 bg-white d-flex flex-column gap-0">
              <h4 className="text-md font-semibold text-grey-800">People Who Can Help</h4>
              <ul className="people-help-list list-unstyled mb-0 flex flex-column">
                <li className="py-3">
                  <div className="d-flex flex-wrap justify-content-between align-items-center gap-3">
                    <div className="d-flex flex-wrap align-items-center gap-2">
                      <div className="w-12 h-12 rounded-circle border border-gray-200 d-flex justify-content-center align-items-center overflow-hidden">
                        <img src="/assets/images/avatars/6.jpg" alt="" className="w-100 h-100 object-fit-cover"/>
                      </div>
                      <div>
                        <h5 className="mb-0 text-sm font-medium">Karl Mill</h5>
                        <span className="text-xs">Recruiter</span>
                      </div>
                    </div>

                    <button className="btn btn-gray-light d-inline-flex align-items-center gap-1">
                      <i className="bx bx-user-plus bx-sm"></i>
                      Network
                    </button>
                  </div>
                </li>
                <li className="py-3">
                  <div className="d-flex flex-wrap justify-content-between align-items-center gap-3">
                    <div className="d-flex flex-wrap align-items-center gap-2">
                      <div className="w-12 h-12 rounded-circle border border-gray-200 d-flex justify-content-center align-items-center overflow-hidden">
                        <img src="/assets/images/avatars/6.jpg" alt="" className="w-100 h-100 object-fit-cover"/>
                      </div>
                      <div>
                        <h5 className="mb-0 text-sm font-medium">Karl Mill</h5>
                        <span className="text-xs">Recruiter</span>
                      </div>
                    </div>

                    <button className="btn btn-gray-light d-inline-flex align-items-center gap-1">
                      <i className="bx bx-user-plus bx-sm"></i>
                      Network
                    </button>
                  </div>
                </li>
                <li className="py-3">
                  <div className="d-flex flex-wrap justify-content-between align-items-center gap-3">
                    <div className="d-flex flex-wrap align-items-center gap-2">
                      <div className="w-12 h-12 rounded-circle border border-gray-200 d-flex justify-content-center align-items-center overflow-hidden">
                        <img src="/assets/images/avatars/6.jpg" alt="" className="w-100 h-100 object-fit-cover"/>
                      </div>
                      <div>
                        <h5 className="mb-0 text-sm font-medium">Karl Mill</h5>
                        <span className="text-xs">Recruiter</span>
                      </div>
                    </div>

                    <button className="btn btn-gray-light d-inline-flex align-items-center gap-1">
                      <i className="bx bx-user-plus bx-sm"></i>
                      Network
                    </button>
                  </div>
                </li>
              </ul>
            </div>            

            <div className="p-4 rounded-lg border border-grey-200 bg-white d-flex flex-column gap-0">
              <h4 className="text-md font-semibold text-grey-800">Other Jobs you might like</h4>
              <ul className="people-help-list list-unstyled mb-0 flex flex-column">
                <li className="py-3">
                  <div className="d-flex flex-wrap justify-content-between align-items-center gap-3">
                    <div className="d-flex flex-wrap align-items-center gap-2">
                      <div className="w-12 h-12 rounded-circle border border-gray-200 d-flex justify-content-center align-items-center overflow-hidden">
                        <img src="/assets/images/avatars/7.jpg" alt="" className="w-100 h-100 object-fit-cover"/>
                      </div>
                      <div>
                        <h5 className="mb-0 text-sm font-medium">Page Job</h5>
                        <span className="text-xs">Cars and Insurance</span>
                      </div>
                    </div>

                    <button className="btn btn-gray-light d-inline-flex align-items-center gap-1">
                      <i className="bx bx-plus bx-xs"></i> Apply
                    </button>
                  </div>
                </li>
                <li className="py-3">
                  <div className="d-flex flex-wrap justify-content-between align-items-center gap-3">
                    <div className="d-flex flex-wrap align-items-center gap-2">
                      <div className="w-12 h-12 rounded-circle border border-gray-200 d-flex justify-content-center align-items-center overflow-hidden">
                        <img src="/assets/images/avatars/7.jpg" alt="" className="w-100 h-100 object-fit-cover"/>
                      </div>
                      <div>
                        <h5 className="mb-0 text-sm font-medium">Page Job</h5>
                        <span className="text-xs">Cars and Insurance</span>
                      </div>
                    </div>

                    <button className="btn btn-gray-light d-inline-flex align-items-center gap-1">
                      <i className="bx bx-plus bx-xs"></i> Apply
                    </button>
                  </div>
                </li>
                <li className="py-3">
                  <div className="d-flex flex-wrap justify-content-between align-items-center gap-3">
                    <div className="d-flex flex-wrap align-items-center gap-2">
                      <div className="w-12 h-12 rounded-circle border border-gray-200 d-flex justify-content-center align-items-center overflow-hidden">
                        <img src="/assets/images/avatars/7.jpg" alt="" className="w-100 h-100 object-fit-cover"/>
                      </div>
                      <div>
                        <h5 className="mb-0 text-sm font-medium">Page Job</h5>
                        <span className="text-xs">Cars and Insurance</span>
                      </div>
                    </div>

                    <button className="btn btn-gray-light d-inline-flex align-items-center gap-1">
                      <i className="bx bx-plus bx-xs"></i> Apply
                    </button>
                  </div>
                </li>
              </ul>
            </div>            
            
          </div>
        </div>
      </div>


      <div className="p-3 pb-5 text-white bg-gredient-1 rounded-3">
        <div className="row align-items-center gy-3">
          <div className="col-md-8 col-sm-12 col-12">
            <h1 className="h4 mb-0">Explore & Create Events!</h1>
          </div>
          <div className="col-md-4 col-sm-12 col-12 text-md-end">
            <button className="btn btn-light" data-bs-toggle="modal" data-bs-target="#createEvent">
              <i className="bx bxs-magic-wand bx-sm me-1 align-middle"></i>{" "}
              Event Creation Wizard
            </button>
          </div>
        </div>
      </div>

      <div className="modal fade" id="createEvent" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="staticBackdropLabel">Create New Event</h1>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body py-xl-4">
              <div className="row gy-4">
                <div className="col-md-4 col-sm-12 col-12">
                  <div className="text-center">
                    <div className="mb-2 p-4 rounded-3 border bg-light d-flex justify-content-center align-items-center w-100">
                      <div className="w-100">
                        <div className="iconbox mb-2 w-10 h-10 mx-auto text-white rounded-circle bg-orange-400 d-flex justify-content-center align-items-center">
                          <i className="bx bx-plus"></i>
                        </div>
                        <h4 className="mb-0 text-sm font-semibold text-black-800">Create from Scratch</h4>
                      </div>
                    </div>
                    <p className="mb-0 text-sm fomt-medium text-grey-900">Design your event exactly how you envision it, with complete creative</p>
                  </div>
                </div>
                <div className="col-md-4 col-sm-12 col-12">
                  <div className="text-center">
                    <div className="mb-2 p-4 rounded-3 border bg-light d-flex justify-content-center align-items-center w-100">
                      <div className="w-100">
                        <div className="iconbox mb-2 w-10 h-10 mx-auto text-white rounded-circle bg-purple-600 d-flex justify-content-center align-items-center">
                          <i className="bx bxs-magic-wand"></i>
                        </div>
                        <h4 className="mb-0 text-sm font-semibold text-black-800">Create with AI</h4>
                      </div>
                    </div>
                    <p className="mb-0 text-sm fomt-medium text-grey-900">Let AI help you generate an event based on your preferences.</p>
                  </div>
                </div>
                <div className="col-md-4 col-sm-12 col-12">
                  <div className="text-center">
                    <div className="mb-2 p-4 rounded-3 border bg-light d-flex justify-content-center align-items-center w-100">
                      <div className="w-100">
                        <div className="iconbox mb-2 w-10 h-10 mx-auto text-white rounded-circle bg-blue-400 d-flex justify-content-center align-items-center">
                          <span className="material-symbols-outlined">browse</span>
                        </div>
                        <h4 className="mb-0 text-sm font-semibold text-black-800">Choose from Template</h4>
                      </div>
                    </div>
                    <p className="mb-0 text-sm fomt-medium text-grey-900">Choose from variety of pre-made templates to quickly set up your event.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="-mt-4">
        <div className="row">
          <div className="col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12">
            <div className="mb-4 p-3 rounded-3 bg-white position-relative">
              <div className="d-flex flex-wrap align-items-center row-gap-3 mb-3">
                <div className="">
                  <h3 className="text-md font-semibold text-slate-600 mb-0">Campus Calendars</h3>
                </div>
                <div className="ms-md-auto">
                  <div
                    className="btn-group"
                    role="group"
                    aria-label="Basic example"
                  >
                    <button
                      type="button"
                      className="btn btn-white border-2 border-grey-700"
                    >
                      Academic
                    </button>
                    <button
                      type="button"
                      className="btn btn-white border-2 border-grey-700"
                    >
                      Events
                    </button>
                  </div>
                  <button
                    type="button"
                    className="btn btn-transparent border-0"
                  >
                    <i className="bx bx-expand-alt bx-sm"></i>
                  </button>
                </div>
              </div>
              <div className="p-3 rounded-3 border border-grey-300 position-relative"></div>
            </div>
            <div className="p-3 rounded-3 bg-white position-relative">
              <div className="d-flex flex-wrap align-items-center row-gap-3 mb-3">
                <div className="">
                  <h3 className="text-md font-semibold text-slate-600 mb-0">
                    Campus Connect : Engage & Earn
                  </h3>
                </div>
                <div className="ms-md-auto">
                  <button
                    type="button"
                    className="btn btn-transparent border-0"
                  >
                    <i className="bx bx-expand-alt bx-sm"></i>
                  </button>
                </div>
              </div>
              <div className="position-relative">
                <div className="mb-3 d-flex align-items-center">
                  <div className="me-2 flex-auto avatar-img w-12 h-12 bg-purple-600">
                    <img
                      src="../assets/images/avatars/8.jpg"
                      alt=""
                      className="w-100 h-100 object-fit-cover"
                    />
                  </div>
                  <div className="w-100 px-3 py-2 border border-grey-200 rounded-2 bg-grey-100">
                    <div className="d-flex align-items-center">
                      <div className="w-100 me-3">
                        <input
                          type="text"
                          name=""
                          id=""
                          placeholder="What's on your mind?"
                          className="p-0 form-control bg-transparent border-0"
                        />
                      </div>
                      <div className="ms-auto">
                        <ul className="list-unstyled m-0 p-0 d-inline-flex gap-2">
                          <li>
                            <div className="pe-1 d-flex align-items-center rounded-pill border border-blue-600 bg-blue-50">
                              <div className="flex-auto avatar-img w-8 h-8 d-flex justify-content-center align-items-center bg-white shadow-sm">
                                ✍️
                              </div>
                              <span className="d-inline-block p-2 text-sm font-medium">
                                MicroBlog
                              </span>
                            </div>
                          </li>
                          <li>
                            <div className="pe-1 d-flex align-items-center rounded-pill border border-pink-600 bg-pink-50">
                              <div className="flex-auto avatar-img w-8 h-8 d-flex justify-content-center align-items-center bg-white shadow-sm">
                                🏆
                              </div>
                              <span className="d-inline-block p-2 text-sm font-medium">
                                Challenge
                              </span>
                            </div>
                          </li>
                          <li>
                            <div className="pe-1 d-flex align-items-center rounded-pill border border-green-600 bg-green-50">
                              <div className="flex-auto avatar-img w-8 h-8 d-flex justify-content-center align-items-center bg-white shadow-sm">
                                📚
                              </div>
                              <span className="d-inline-block p-2 text-sm font-medium">
                                BookMint
                              </span>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="d-flex flex-column row-gap-3">
                  <div className="p-3 rounded-3 border border-grey-300 position-relative">
                    <div className="d-flex">
                      <div className="mb-3 me-3 d-flex align-items-center">
                        <div className="me-2 flex-auto avatar-img w-10 h-10 bg-purple-600">
                          <img
                            src="../assets/images/avatars/8.jpg"
                            alt=""
                            className="w-100 h-100 object-fit-cover"
                          />
                        </div>
                        <div>
                          <h4 className="mb-0 text-sm">Jennie Smith</h4>
                          <ul className="list-unstyled m-0 p-0 d-inline-flex align-items-center gap-2">
                            <li>
                              <span className="d-block text-xs font-semibold text-black-600">
                                30m{" "}
                                <i className="bx bx-world text-grey-700"></i>
                              </span>
                            </li>
                          </ul>
                        </div>
                        <button className="ms-2 border border-blue-600 rounded-2 bg-blue-50 w-8 h-8 d-flex justify-content-center align-items-center">
                          ✍️
                        </button>
                      </div>
                      <div className="ms-auto">
                        <div className="dropdown">
                          <button
                            className="d-block p-0 text-black-600 border-0 bg-transparent dropdown-toggle no-arrow"
                            type="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            <i className="bx bx-dots-horizontal-rounded bx-sm"></i>
                          </button>
                          <ul className="dropdown-menu">
                            <li>
                              <a className="dropdown-item" href="#">
                                Action
                              </a>
                            </li>
                            <li>
                              <a className="dropdown-item" href="#">
                                Another action
                              </a>
                            </li>
                            <li>
                              <a className="dropdown-item" href="#">
                                Something else here
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="text-sm">
                      <p>
                        Discovered the perfect study playlist on Spotify today.
                        It’s amazing how the right background music can boost
                        concentration. Sharing it here for my fellow night owls!{" "}
                        <a href="https://open.spotify.com/playlist">
                          https://open.spotify.com/playlist
                        </a>{" "}
                        🎧 #StudyHacks"
                      </p>
                    </div>
                    <div className="mt-3 d-flex align-items-center">
                      <ul className="list-unstyled m-0 p-0 d-inline-flex align-items-center gap-2 me-3">
                        <li className="text-black-800 hover-inherit text-sm">
                          <button
                            type="button"
                            className="d-flex align-items-center gap-1 border-0 bg-transparent"
                          >
                            <i className="bx bx-heart bx-sm"></i>{" "}
                            <span className="font-semibold">23</span>
                          </button>
                        </li>
                        <li className="text-black-800 hover-inherit text-sm">
                          <button
                            type="button"
                            className="d-flex align-items-center gap-1 border-0 bg-transparent"
                          >
                            <i className="bx bx-message-rounded-dots bx-sm"></i>{" "}
                            <span className="font-semibold">65</span>
                          </button>
                        </li>
                        <li className="text-black-800 hover-inherit text-sm">
                          <button
                            type="button"
                            className="d-flex align-items-center gap-1 border-0 bg-transparent"
                          >
                            <i className="bx bx-share bx-sm"></i>{" "}
                            <span className="font-semibold">12</span>
                          </button>
                        </li>
                      </ul>
                      <div className="ms-auto">
                        <button
                          type="button"
                          className="m-0 p-0 d-flex align-items-center gap-1 border-0 bg-transparent"
                        >
                          <i className="bx bx-bookmark bx-sm"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="p-3 rounded-3 border border-grey-300 position-relative">
                    <div className="d-flex">
                      <div className="mb-3 me-3 d-flex align-items-center">
                        <div className="me-2 flex-auto avatar-img w-10 h-10 bg-purple-600">
                          <img
                            src="../assets/images/avatars/8.jpg"
                            alt=""
                            className="w-100 h-100 object-fit-cover"
                          />
                        </div>
                        <div>
                          <h4 className="mb-0 text-sm">Jennie Smith</h4>
                          <ul className="list-unstyled m-0 p-0 d-inline-flex align-items-center gap-2">
                            <li>
                              <span className="d-block text-xs font-semibold text-black-600">
                                30m{" "}
                                <i className="bx bx-world text-grey-700"></i>
                              </span>
                            </li>
                          </ul>
                        </div>
                        <button className="ms-2 border border-pink-600 rounded-2 bg-pink-50 w-8 h-8 d-flex justify-content-center align-items-center">
                          🏆
                        </button>
                      </div>
                      <div className="ms-auto">
                        <div className="dropdown">
                          <button
                            className="d-block p-0 text-black-600 border-0 bg-transparent dropdown-toggle no-arrow"
                            type="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            <i className="bx bx-dots-horizontal-rounded bx-sm"></i>
                          </button>
                          <ul className="dropdown-menu">
                            <li>
                              <a className="dropdown-item" href="#">
                                Action
                              </a>
                            </li>
                            <li>
                              <a className="dropdown-item" href="#">
                                Another action
                              </a>
                            </li>
                            <li>
                              <a className="dropdown-item" href="#">
                                Something else here
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="text-sm">
                      <p>
                        Capture the essence of campus life through your lens.
                        Share your best snapshot of a hidden campus gem.
                      </p>

                      <button className="px-2 py-1 text-xs border border-yellow-600 rounded-2 bg-yellow-50 d-flex justify-content-center align-items-center">
                        <img src="../assets/images/openmoji_coin.svg" alt="" />{" "}
                        Earn 10 coins
                      </button>

                      <div className="my-3 p-4 rounded-3 bg-black-200 h-350"></div>
                    </div>
                    <div className="mt-3 d-flex align-items-center">
                      <ul className="list-unstyled m-0 p-0 d-inline-flex align-items-center gap-2 me-3">
                        <li className="text-black-800 hover-inherit text-sm">
                          <button
                            type="button"
                            className="d-flex align-items-center gap-1 border-0 bg-transparent"
                          >
                            <i className="bx bx-heart bx-sm"></i>{" "}
                            <span className="font-semibold">23</span>
                          </button>
                        </li>
                        <li className="text-black-800 hover-inherit text-sm">
                          <button
                            type="button"
                            className="d-flex align-items-center gap-1 border-0 bg-transparent"
                          >
                            <i className="bx bx-message-rounded-dots bx-sm"></i>{" "}
                            <span className="font-semibold">65</span>
                          </button>
                        </li>
                        <li className="text-black-800 hover-inherit text-sm">
                          <button
                            type="button"
                            className="d-flex align-items-center gap-1 border-0 bg-transparent"
                          >
                            <i className="bx bx-share bx-sm"></i>{" "}
                            <span className="font-semibold">12</span>
                          </button>
                        </li>
                      </ul>
                      <div className="ms-auto">
                        <button
                          type="button"
                          className="m-0 p-0 d-flex align-items-center gap-1 border-0 bg-transparent"
                        >
                          <i className="bx bx-bookmark bx-sm"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-4 col-lg-12 col-md-12 col-sm-12 col-12">
            <div className="mb-4 p-3 rounded-3 bg-white position-relative">
              <div className="d-flex flex-wrap align-items-center row-gap-3 mb-3">
                <div className="">
                  <h3 className="text-md font-semibold text-slate-600 mb-0">Upcoming Events</h3>
                  <span className="text-sm font-medium text-black-500">
                    246 events
                  </span>
                </div>
                <div className="ms-md-auto">
                  <button
                    className="btn btn-transparent border-0"
                    type="button"
                  >
                    <i className="bx bx-expand-alt bx-sm"></i>
                  </button>
                </div>
              </div>
              <div className="upcoming-event pe-1 d-flex flex-column row-gap-3 overflow-y-auto">
                <div className="p-3 rounded-3 border border-grey-300 bg-grey-100 position-relative">
                  <div className="mb-3 d-flex align-items-center">
                    <div>
                      <h4 className="mb-0 me-3 text-base">
                        Tech Talks: The Future of AI
                      </h4>
                      <ul className="list-unstyled m-0 p-0 d-inline-flex align-items-center gap-2 text-xs font-medium text-black-500">
                        <li>12 Jan 23</li>
                        <li>|</li>
                        <li>9:00 AM</li>
                      </ul>
                    </div>
                    <div className="ms-auto w-18 h-14 flex-auto rounded-2 bg-purple-600 overflow-hidden">
                      <img
                        src="../assets/images/img-2.jpg"
                        alt=""
                        className="w-100 h-100 object-fit-cover"
                      />
                    </div>
                  </div>
                  <div className="text-sm font-medium text-black-600">
                    <div className="d-inline-flex align-items-center">
                      <i className="bx bx-map bx-sm align-middle"></i> Gillz
                      Hall, University Campus
                    </div>
                  </div>
                  <div className="mt-3 d-flex align-items-center">
                    <div className="me-auto">
                      <div className="header_img">
                        <div className="img-box overflow-hidden rounded-circle bg-white">
                          <img
                            src="../assets/images/avatars/9.jpg"
                            alt=""
                            className="w-100 h-100 object-fit-cover"
                          />
                        </div>
                        <div className="img-box overflow-hidden rounded-circle bg-white">
                          <img
                            src="../assets/images/avatars/10.jpg"
                            alt=""
                            className="w-100 h-100 object-fit-cover"
                          />
                        </div>
                        <div className="img-box overflow-hidden rounded-circle bg-white">
                          <img
                            src="../assets/images/avatars/8.jpg"
                            alt=""
                            className="w-100 h-100 object-fit-cover"
                          />
                        </div>
                        <div className="img-box overflow-hidden rounded-circle bg-white">
                          <img
                            src="../assets/images/avatars/6.jpg"
                            alt=""
                            className="w-100 h-100 object-fit-cover"
                          />
                        </div>
                        <a href="#" className="more-img">
                          +50
                        </a>
                      </div>
                    </div>
                    <ul className="list-unstyled m-0 p-0 d-inline-flex align-items-center gap-2 ms-3">
                      <li className="hover-inherit">
                        <button
                          className="d-flex align-items-center gap-1 text-black-600 border-0 bg-transparent"
                          type="button"
                        >
                          <i className="bx bx-heart bx-sm"></i>
                        </button>
                      </li>
                      <li className="hover-inherit">
                        <button
                          className="d-flex align-items-center gap-1 text-black-600 border-0 bg-transparent"
                          type="button"
                        >
                          <i className="bx bx-share-alt bx-sm"></i>
                        </button>
                      </li>
                      <li className="hover-inherit">
                        <button
                          className="d-flex align-items-center gap-1 text-black-600 border-0 bg-transparent"
                          type="button"
                        >
                          <i className="bx bx-fullscreen bx-sm"></i>
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="p-3 rounded-3 border border-grey-300 bg-grey-100 position-relative">
                  <div className="mb-3 d-flex align-items-center">
                    <div>
                      <h4 className="mb-0 me-3 text-base">
                        Tech Talks: The Future of AI
                      </h4>
                      <ul className="list-unstyled m-0 p-0 d-inline-flex align-items-center gap-2 text-xs font-medium text-black-500">
                        <li>12 Jan 23</li>
                        <li>|</li>
                        <li>9:00 AM</li>
                      </ul>
                    </div>
                    <div className="ms-auto w-18 h-14 flex-auto rounded-2 bg-purple-600 overflow-hidden">
                      <img
                        src="../assets/images/img-2.jpg"
                        alt=""
                        className="w-100 h-100 object-fit-cover"
                      />
                    </div>
                  </div>
                  <div className="text-sm font-medium text-black-600">
                    <div className="d-inline-flex align-items-center">
                      <i className="bx bx-map bx-sm align-middle"></i> Gillz
                      Hall, University Campus
                    </div>
                  </div>
                  <div className="mt-3 d-flex align-items-center">
                    <div className="me-auto">
                      <div className="header_img">
                        <div className="img-box overflow-hidden rounded-circle bg-white">
                          <img
                            src="../assets/images/avatars/9.jpg"
                            alt=""
                            className="w-100 h-100 object-fit-cover"
                          />
                        </div>
                        <div className="img-box overflow-hidden rounded-circle bg-white">
                          <img
                            src="../assets/images/avatars/10.jpg"
                            alt=""
                            className="w-100 h-100 object-fit-cover"
                          />
                        </div>
                        <div className="img-box overflow-hidden rounded-circle bg-white">
                          <img
                            src="../assets/images/avatars/8.jpg"
                            alt=""
                            className="w-100 h-100 object-fit-cover"
                          />
                        </div>
                        <div className="img-box overflow-hidden rounded-circle bg-white">
                          <img
                            src="../assets/images/avatars/6.jpg"
                            alt=""
                            className="w-100 h-100 object-fit-cover"
                          />
                        </div>
                        <a href="#" className="more-img">
                          +50
                        </a>
                      </div>
                    </div>
                    <ul className="list-unstyled m-0 p-0 d-inline-flex align-items-center gap-2 ms-3">
                      <li className="hover-inherit">
                        <button
                          className="d-flex align-items-center gap-1 text-black-600 border-0 bg-transparent"
                          type="button"
                        >
                          <i className="bx bx-heart bx-sm"></i>
                        </button>
                      </li>
                      <li className="hover-inherit">
                        <button
                          className="d-flex align-items-center gap-1 text-black-600 border-0 bg-transparent"
                          type="button"
                        >
                          <i className="bx bx-share-alt bx-sm"></i>
                        </button>
                      </li>
                      <li className="hover-inherit">
                        <button
                          className="d-flex align-items-center gap-1 text-black-600 border-0 bg-transparent"
                          type="button"
                        >
                          <i className="bx bx-fullscreen bx-sm"></i>
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="p-3 rounded-3 border border-grey-300 bg-grey-100 position-relative">
                  <div className="mb-3 d-flex align-items-center">
                    <div>
                      <h4 className="mb-0 me-3 text-base">
                        Tech Talks: The Future of AI
                      </h4>
                      <ul className="list-unstyled m-0 p-0 d-inline-flex align-items-center gap-2 text-xs font-medium text-black-500">
                        <li>12 Jan 23</li>
                        <li>|</li>
                        <li>9:00 AM</li>
                      </ul>
                    </div>
                    <div className="ms-auto w-18 h-14 flex-auto rounded-2 bg-purple-600 overflow-hidden">
                      <img
                        src="../assets/images/img-2.jpg"
                        alt=""
                        className="w-100 h-100 object-fit-cover"
                      />
                    </div>
                  </div>
                  <div className="text-sm font-medium text-black-600">
                    <div className="d-inline-flex align-items-center">
                      <i className="bx bx-map bx-sm align-middle"></i> Gillz
                      Hall, University Campus
                    </div>
                  </div>
                  <div className="mt-3 d-flex align-items-center">
                    <div className="me-auto">
                      <div className="header_img">
                        <div className="img-box overflow-hidden rounded-circle bg-white">
                          <img
                            src="../assets/images/avatars/9.jpg"
                            alt=""
                            className="w-100 h-100 object-fit-cover"
                          />
                        </div>
                        <div className="img-box overflow-hidden rounded-circle bg-white">
                          <img
                            src="../assets/images/avatars/10.jpg"
                            alt=""
                            className="w-100 h-100 object-fit-cover"
                          />
                        </div>
                        <div className="img-box overflow-hidden rounded-circle bg-white">
                          <img
                            src="../assets/images/avatars/8.jpg"
                            alt=""
                            className="w-100 h-100 object-fit-cover"
                          />
                        </div>
                        <div className="img-box overflow-hidden rounded-circle bg-white">
                          <img
                            src="../assets/images/avatars/6.jpg"
                            alt=""
                            className="w-100 h-100 object-fit-cover"
                          />
                        </div>
                        <a href="#" className="more-img">
                          +50
                        </a>
                      </div>
                    </div>
                    <ul className="list-unstyled m-0 p-0 d-inline-flex align-items-center gap-2 ms-3">
                      <li className="hover-inherit">
                        <button
                          className="d-flex align-items-center gap-1 text-black-600 border-0 bg-transparent"
                          type="button"
                        >
                          <i className="bx bx-heart bx-sm"></i>
                        </button>
                      </li>
                      <li className="hover-inherit">
                        <button
                          className="d-flex align-items-center gap-1 text-black-600 border-0 bg-transparent"
                          type="button"
                        >
                          <i className="bx bx-share-alt bx-sm"></i>
                        </button>
                      </li>
                      <li className="hover-inherit">
                        <button
                          className="d-flex align-items-center gap-1 text-black-600 border-0 bg-transparent"
                          type="button"
                        >
                          <i className="bx bx-fullscreen bx-sm"></i>
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="p-3 rounded-3 border border-grey-300 bg-grey-100 position-relative">
                  <div className="mb-3 d-flex align-items-center">
                    <div>
                      <h4 className="mb-0 me-3 text-base">
                        Tech Talks: The Future of AI
                      </h4>
                      <ul className="list-unstyled m-0 p-0 d-inline-flex align-items-center gap-2 text-xs font-medium text-black-500">
                        <li>12 Jan 23</li>
                        <li>|</li>
                        <li>9:00 AM</li>
                      </ul>
                    </div>
                    <div className="ms-auto w-18 h-14 flex-auto rounded-2 bg-purple-600 overflow-hidden">
                      <img
                        src="../assets/images/img-2.jpg"
                        alt=""
                        className="w-100 h-100 object-fit-cover"
                      />
                    </div>
                  </div>
                  <div className="text-sm font-medium text-black-600">
                    <div className="d-inline-flex align-items-center">
                      <i className="bx bx-map bx-sm align-middle"></i> Gillz
                      Hall, University Campus
                    </div>
                  </div>
                  <div className="mt-3 d-flex align-items-center">
                    <div className="me-auto">
                      <div className="header_img">
                        <div className="img-box overflow-hidden rounded-circle bg-white">
                          <img
                            src="../assets/images/avatars/9.jpg"
                            alt=""
                            className="w-100 h-100 object-fit-cover"
                          />
                        </div>
                        <div className="img-box overflow-hidden rounded-circle bg-white">
                          <img
                            src="../assets/images/avatars/10.jpg"
                            alt=""
                            className="w-100 h-100 object-fit-cover"
                          />
                        </div>
                        <div className="img-box overflow-hidden rounded-circle bg-white">
                          <img
                            src="../assets/images/avatars/8.jpg"
                            alt=""
                            className="w-100 h-100 object-fit-cover"
                          />
                        </div>
                        <div className="img-box overflow-hidden rounded-circle bg-white">
                          <img
                            src="../assets/images/avatars/6.jpg"
                            alt=""
                            className="w-100 h-100 object-fit-cover"
                          />
                        </div>
                        <a href="#" className="more-img">
                          +50
                        </a>
                      </div>
                    </div>
                    <ul className="list-unstyled m-0 p-0 d-inline-flex align-items-center gap-2 ms-3">
                      <li className="hover-inherit">
                        <button
                          className="d-flex align-items-center gap-1 text-black-600 border-0 bg-transparent"
                          type="button"
                        >
                          <i className="bx bx-heart bx-sm"></i>
                        </button>
                      </li>
                      <li className="hover-inherit">
                        <button
                          className="d-flex align-items-center gap-1 text-black-600 border-0 bg-transparent"
                          type="button"
                        >
                          <i className="bx bx-share-alt bx-sm"></i>
                        </button>
                      </li>
                      <li className="hover-inherit">
                        <button
                          className="d-flex align-items-center gap-1 text-black-600 border-0 bg-transparent"
                          type="button"
                        >
                          <i className="bx bx-fullscreen bx-sm"></i>
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="mb-4 p-3 rounded-3 bg-white position-relative">
              <div className="d-flex flex-wrap align-items-center row-gap-3 mb-3">
                <div className="">
                  <h3 className="text-md font-semibold text-slate-600 mb-0">Campus Live</h3>
                  <span className="text-sm font-medium text-black-500">
                    12 Live Streamer
                  </span>
                </div>
                <div className="ms-md-auto">
                  <button
                    className="btn btn-transparent border-0"
                    type="button"
                  >
                    <i className="bx bx-expand-alt bx-sm"></i>
                  </button>
                </div>
              </div>
              <div className="upcoming-event pe-1 d-flex flex-column row-gap-3 overflow-y-auto">
                <div className="position-relative">
                  <div className="mb-3 ms-auto rounded-2 bg-purple-600 h-250 overflow-hidden position-relative">
                    <div className="badge badge-live px-2 py-1 text-sm font-semibold text-uppercase text-white rounded-1 bg-red-600 position-absolute top-2 left-2 z-1">
                      Live
                    </div>
                    <img
                      src="../assets/images/img-2.jpg"
                      alt=""
                      className="w-100 h-100 object-fit-cover"
                    />
                  </div>
                  <div className="mb-3 d-flex flex-wrap align-items-start">
                    <div className=" d-flex align-items-start">
                      <div className="me-2 w-12 h-12 flex-auto rounded-circle bg-purple-600 overflow-hidden position-relative">
                        <img
                          src="../assets/images/img-2.jpg"
                          alt=""
                          className="w-100 h-100 object-fit-cover"
                        />
                      </div>
                      <div className="me-2">
                        <h4 className="mb-0 text-base ellipsis-1">
                          A Day with the Campus President
                        </h4>
                        <ul className="list-unstyled m-0 p-0 d-inline-flex align-items-center gap-2 text-xs font-medium text-black-500">
                          <li>58.3K viewers</li>
                        </ul>
                        <button className="mt-2 px-2 py-1 text-xs border border-black-200 rounded-2 bg-black-50 d-flex justify-content-center align-items-center">
                          🤝 Social
                        </button>
                      </div>
                    </div>
                    <div className="ms-lg-auto">
                      <span className="text-sm">@anne783</span>
                    </div>
                  </div>
                </div>
                <div className="position-relative">
                  <div className="mb-3 ms-auto rounded-2 bg-purple-600 h-250 overflow-hidden position-relative">
                    <div className="badge badge-live px-2 py-1 text-sm font-semibold text-uppercase text-white rounded-1 bg-red-600 position-absolute top-2 left-2 z-1">
                      Live
                    </div>
                    <img
                      src="../assets/images/img-2.jpg"
                      alt=""
                      className="w-100 h-100 object-fit-cover"
                    />
                  </div>
                  <div className="mb-3 d-flex flex-wrap align-items-start">
                    <div className=" d-flex align-items-start">
                      <div className="me-2 w-12 h-12 flex-auto rounded-circle bg-purple-600 overflow-hidden position-relative">
                        <img
                          src="../assets/images/img-2.jpg"
                          alt=""
                          className="w-100 h-100 object-fit-cover"
                        />
                      </div>
                      <div className="me-2">
                        <h4 className="mb-0 text-base ellipsis-1">
                          A Day with the Campus President
                        </h4>
                        <ul className="list-unstyled m-0 p-0 d-inline-flex align-items-center gap-2 text-xs font-medium text-black-500">
                          <li>58.3K viewers</li>
                        </ul>
                        <button className="mt-2 px-2 py-1 text-xs border border-black-200 rounded-2 bg-black-50 d-flex justify-content-center align-items-center">
                          🤝 Social
                        </button>
                      </div>
                    </div>
                    <div className="ms-lg-auto">
                      <span className="text-sm">@anne783</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div className="mb-4">
        <div className="p-3 rounded-3 bg-white position-relative">
          <div className="d-flex flex-wrap align-items-center row-gap-3 mb-3">
            <div className="">
              <h3 className="text-md font-semibold mb-0">
                Create Your Event
              </h3>
            </div>
            <div className="ms-md-auto">
              <button type="button" className="btn btn-transparent border-0">
                <i className="bx bx-expand-alt bx-sm"></i>
              </button>
            </div>
          </div>

          <div className="">
            <div className="d-flex justify-content-center">
              <ul className="event-step-list list-unstyled d-inline-flex justify-content-center p-4 bg-slate-50 rounded-2">
                <li className="pt-5 px-5 position-relative active">
                  <span className="font-medium text-slate-400">Basic Details</span>
                </li>
                <li className="pt-5 px-5 position-relative"><span className="font-medium text-slate-400">Location & Accessibility</span></li>
                <li className="pt-5 px-5 position-relative"><span className="font-medium text-slate-400">Final Touches</span></li>
              </ul>
            </div>
            <div className="d-flex align-items-center mb-3">
              <h3 className="me-3 mb-0 text-sm text-nowrap text-grey-700">
                Basic Details
              </h3>
              <div className="bg-slate-200 w-100 h-1"></div>
            </div>
            <Row>
              <Col lg={6} md={12} sm={12} xs={12}>
                <div className="mb-3">
                  <label for="eventType" className="form-label">Type of Event</label>
                  <select className="form-select" aria-label="Default select example" id="eventType">
                    <option selected>Open this select menu</option>
                    <option value="1">One</option>
                    <option value="2">Two</option>
                    <option value="3">Three</option>
                  </select>

                </div>
              </Col>
              <Col lg={6} md={12} sm={12} xs={12}>
                <div className="mb-3">
                  <label for="" className="form-label">Is this event Private or Public?</label>
                  <div>
                    <div className="form-check form-check-inline">
                      <input className="form-check-input" type="radio" name="eventOption" id="privateEvent" value="option1" />
                      <label className="form-check-label" for="privateEvent">Private</label>
                    </div>
                    <div className="form-check form-check-inline">
                      <input className="form-check-input" type="radio" name="eventOption" id="publicEvent" value="option2" />
                      <label className="form-check-label" for="publicEvent">Public</label>
                    </div>
                  </div>
                </div>
              </Col>
              <Col lg={12} md={12} sm={12} xs={12}>
                <div className="mb-3">
                  <label for="locationType" className="form-label">Location Type</label>
                  <select className="form-select" aria-label="Default select example" id="locationType">
                    <option>Open this select menu</option>
                    <option selected value="1">Hybrid</option>
                    <option value="2">Remote</option>
                    <option value="3">Onsite</option>
                  </select>
                </div>
              </Col>
              <Col lg={6} md={12} sm={12} xs={12}>
                <div className="mb-3">
                  <label for="virtualLink" className="form-label">Enter Virtual Link
                    <button type="button" className="border rounded-2 bg-transparent ms-3" data-bs-toggle="modal" data-bs-target="#virtualEventModal">Add Virtual Event</button>
                  </label>
                  <input className="form-control" type="text" placeholder="" id="virtualLink" />
                </div>

                <div className="modal fade" id="virtualEventModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="virtualEventModalLabel" aria-hidden="true">
                  <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h3 className="modal-title fs-5 text-slate-600" id="virtualEventModalLabel">Add Virtual Event link </h3>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                      </div>
                      <div className="modal-body">
                        <ul className="list-unstyled d-flex flex-column row-gap-3">
                          <li>
                            <div className="h-12 px-3 py-2 border border-slate-300 rounded text-sm font-medium text-slate-500 bg-slate-50 d-flex align-items-center">Enter Livestream link from PlutoEdu <a href="" className="text-primary">Events</a></div>
                          </li>
                          <li className="text-center"><span className="mx-auto d-flex justify-content-center align-items-center text-sm font-semibold text-slate-700 w-8 h-8 rounded-circle border border-slate-400 bg-slate-100">Or</span></li>
                          <li>
                            <div className="h-14 px-3 py-2 border border-slate-300 rounded text-sm font-medium text-slate-500 bg-white d-flex align-items-center">
                              <span className="me-2 d-flex justify-content-center align-items-center text-sm font-semibold text-slate-700 flex-none w-6 h-6 rounded-circle border border-slate-400 bg-slate-100"><i className="bx bx-check bx-sm"></i></span>
                              <div className="me-2">Enter Livestream link from PlutoEdu <a href="" className="text-primary">Events</a></div>
                              <div className="ms-auto">
                                <img src="../assets/images/icons/g-meet.svg" alt="" className="img-fluid" />
                              </div>
                            </div>
                          </li>
                          <li>
                            <div className="h-14 px-3 py-2 border border-slate-300 rounded text-sm font-medium text-slate-500 bg-white d-flex align-items-center">
                              <span className="me-2 d-flex justify-content-center align-items-center text-sm font-semibold text-slate-700 flex-none w-6 h-6 rounded-circle border border-slate-400 bg-slate-100"><i className="bx bx-check bx-sm"></i></span>
                              <div className="me-2">Enter Link from Zoom Meeting</div>
                              <div className="ms-auto">
                                <img src="../assets/images/icons/zoom.svg" alt="" className="img-fluid" />
                              </div>
                            </div>
                          </li>
                          <li>
                            <div className="h-14 px-3 py-2 border border-slate-300 rounded text-sm font-medium text-slate-500 bg-white d-flex align-items-center">
                              <span className="me-2 d-flex justify-content-center align-items-center text-sm font-semibold text-slate-700 flex-none w-6 h-6 rounded-circle border border-slate-400 bg-slate-100"><i className="bx bx-check bx-sm"></i></span>
                              <div className="me-2">Enter Link from Skype</div>
                              <div className="ms-auto">
                                <img src="../assets/images/icons/skype.svg" alt="" className="img-fluid" />
                              </div>
                            </div>
                          </li>
                          <li>
                            <div className="h-14 px-3 py-2 border border-slate-300 rounded text-sm font-medium text-slate-500 bg-white d-flex align-items-center">
                              <span className="me-2 d-flex justify-content-center align-items-center text-sm font-semibold text-slate-700 flex-none w-6 h-6 rounded-circle border border-slate-400 bg-slate-100"><i className="bx bx-check bx-sm"></i></span>
                              <div className="me-2">Enter Link from other platforms</div>
                              {/* <div className="ms-auto">
                                <img src="../assets/images/icons/skype.svg" alt="" className="img-fluid" />
                              </div> */}
                            </div>
                          </li>
                        </ul>
                      </div>
                      <div className="modal-footer">
                        {/* <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button> */}
                        <button type="button" className="btn btn-primary">Done</button>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
              <Col lg={6} md={12} sm={12} xs={12}>
                <div className="mb-3">
                  <label for="enterLocation" className="form-label">Enter Location</label>
                  <input className="form-control" type="text" placeholder="" id="enterLocation" />
                </div>
              </Col>
              <Col lg={12} md={12} sm={12} xs={12}>
                <div className="mb-3">
                  <label for="timeZone" className="form-label">Select Timezone</label>
                  <select className="form-select" aria-label="Default select example" id="timeZone">
                    <option selected value="0">Indian Standard Time</option>
                    <option value="1">Hybrid</option>
                    <option value="2">Remote</option>
                    <option value="3">Onsite</option>
                  </select>
                </div>
              </Col>
              <Col lg={6} md={12} sm={12} xs={12}>
                <div className="mb-3">
                  <label for="eventName" className="form-label">Name of the Event</label>
                  <input className="form-control" type="text" placeholder="" id="eventName" />
                </div>
              </Col>
              <Col lg={6} md={12} sm={12} xs={12}>
                <div className="mb-3">
                  <label for="addDetails" className="form-label">Add details</label>
                  <input className="form-control" type="text" placeholder="" id="addDetails" />
                </div>
              </Col>
              <Col lg={4} md={4} sm={4} xs={12}>
                <div className="mb-3">
                  <label for="date" className="form-label">Date</label>
                  <input className="form-control" type="date" placeholder="" id="date" />
                </div>
              </Col>
              <Col lg={4} md={4} sm={4} xs={12}>
                <div className="mb-3">
                  <label for="time" className="form-label">Time</label>
                  <input className="form-control" type="time" placeholder="" id="time" />
                </div>
              </Col>
              <Col lg={4} md={4} sm={4} xs={12}>
                <div className="mb-3">
                  <label for="duration" className="form-label">Duration</label>
                  <select className="form-select" aria-label="Default select example" id="duration">
                    <option value="0">0</option>
                    <option selected value="1">15 min</option>
                    <option value="2">30 min</option>
                    <option value="3">45 min</option>
                  </select>
                </div>
              </Col>
              <Col lg={12} md={12} sm={12} xs={12}>
                <div className="mb-3">
                  <div className="d-flex align-items-center">
                    <div className="d-flex flex-column row-gap-2">
                      <label className="form-label mb-0">Add Special Guest / Speaker or Honorable Attendees</label>
                      <div className="d-flex flex-wrap gap-2">
                        <div className="p-1 rounded-pill d-flex align-items-center bg-slate-100 position-relative">
                          <button type="button" className="label-close w-4 h-4 rounded-circle border-0 bg-slate-200 position-absolute d-flex justify-content-center align-items-center"><i className="bx bx-x"></i></button>
                          <div className="w-10 h-10 rounded-circle overflow-hidden flex-none me-2 border border-white">
                            <img src="../assets/images/avatars/8.jpg" alt="" className="w-100 h-100 object-fit-cover" />
                          </div>
                          <span className="text-xs font-medium text-slate-500 me-3">Jamie Morgan</span>
                        </div>
                        <div className="p-1 rounded-pill d-flex align-items-center bg-slate-100 position-relative">
                          <button type="button" className="label-close w-4 h-4 rounded-circle border-0 bg-slate-200 position-absolute d-flex justify-content-center align-items-center"><i className="bx bx-x"></i></button>
                          <div className="w-10 h-10 rounded-circle overflow-hidden flex-none me-2 border border-white">
                            <img src="../assets/images/avatars/5.jpg" alt="" className="w-100 h-100 object-fit-cover" />
                          </div>
                          <span className="text-xs font-medium text-slate-500 me-3">Jamie Morgan</span>
                        </div>
                        <div className="p-1 rounded-pill d-flex align-items-center bg-slate-100 position-relative">
                          <button type="button" className="label-close w-4 h-4 rounded-circle border-0 bg-slate-200 position-absolute d-flex justify-content-center align-items-center"><i className="bx bx-x"></i></button>
                          <div className="w-10 h-10 rounded-circle overflow-hidden flex-none me-2 border border-white">
                            <img src="../assets/images/avatars/6.jpg" alt="" className="w-100 h-100 object-fit-cover" />
                          </div>
                          <span className="text-xs font-medium text-slate-500 me-3">Jamie Morgan</span>
                        </div>
                      </div>
                    </div>
                    <div className="ms-auto">
                      <button type="button" className="w-10 h-10 d-flex justify-content-center align-items-center rounded-circle border bg-transparent" data-bs-toggle="modal" data-bs-target="#addGuestModal"><i className="bx bx-user-plus bx-sm"></i></button>
                    </div>
                  </div>
                </div>

                <div className="modal fade" id="addGuestModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="addGuestModalLabel" aria-hidden="true">
                  <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h3 className="modal-title fs-5 text-slate-600" id="addGuestModalLabel">Add Guests</h3>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                      </div>
                      <div className="modal-body">
                        <div className="d-flex flex-column row-gap-3">
                          <div className="input-group">
                            <input type="text" className="form-control" placeholder="Add guest name or email" aria-label="Recipient's username" aria-describedby="basic-addon2" />
                            <label for="file" className="input-group-text align-items-center gap-1 text-slate-500 text-center cursor-pointer" id="basic-addon2">
                              <span className="material-symbols-outlined">cloud_upload</span>
                              Upload Picture
                              <input type="file" id="file" className="d-none" />
                            </label>
                          </div>
                          <div className="d-flex flex-wrap gap-2">
                            <div className="p-1 rounded-pill d-flex align-items-center bg-slate-100 position-relative">
                              <button type="button" className="label-close w-4 h-4 rounded-circle border-0 bg-slate-200 position-absolute d-flex justify-content-center align-items-center"><i className="bx bx-x"></i></button>
                              <div className="w-10 h-10 rounded-circle overflow-hidden flex-none me-2 border border-white">
                                <img src="../assets/images/avatars/8.jpg" alt="" className="w-100 h-100 object-fit-cover" />
                              </div>
                              <span className="text-xs font-medium text-slate-500 me-3">Jamie Morgan</span>
                            </div>
                            <div className="p-1 rounded-pill d-flex align-items-center bg-slate-100 position-relative">
                              <button type="button" className="label-close w-4 h-4 rounded-circle border-0 bg-slate-200 position-absolute d-flex justify-content-center align-items-center"><i className="bx bx-x"></i></button>
                              <div className="w-10 h-10 rounded-circle overflow-hidden flex-none me-2 border border-white">
                                <img src="../assets/images/avatars/5.jpg" alt="" className="w-100 h-100 object-fit-cover" />
                              </div>
                              <span className="text-xs font-medium text-slate-500 me-3">Jamie Morgan</span>
                            </div>
                            <div className="p-1 rounded-pill d-flex align-items-center bg-slate-100 position-relative">
                              <button type="button" className="label-close w-4 h-4 rounded-circle border-0 bg-slate-200 position-absolute d-flex justify-content-center align-items-center"><i className="bx bx-x"></i></button>
                              <div className="w-10 h-10 rounded-circle overflow-hidden flex-none me-2 border border-white">
                                <img src="../assets/images/avatars/6.jpg" alt="" className="w-100 h-100 object-fit-cover" />
                              </div>
                              <span className="text-xs font-medium text-slate-500 me-3">Jamie Morgan</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="modal-footer">
                        {/* <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button> */}
                        <button type="button" className="btn btn-primary">Done</button>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
              <Col lg={12} md={12} sm={12} xs={12}>
                <div className="mb-3">
                  <div className="d-flex align-items-center">
                    <div className="d-flex flex-column row-gap-2">
                      <label className="form-label mb-0">Add Sponsor images</label>
                      <div className="d-flex flex-wrap gap-2">
                        <div className="p-1 rounded-pill d-flex align-items-center bg-slate-100 position-relative">
                          <button type="button" className="label-close w-4 h-4 rounded-circle border-0 bg-slate-200 position-absolute d-flex justify-content-center align-items-center"><i className="bx bx-x"></i></button>
                          <div className="w-10 h-10 rounded-circle overflow-hidden flex-none me-2 border border-white">
                            <img src="../assets/images/avatars/7.jpg" alt="" className="w-100 h-100 object-fit-cover" />
                          </div>
                          <span className="text-xs font-medium text-slate-500 me-3">Morgan Light</span>
                        </div>
                      </div>
                    </div>

                    <div className="ms-auto">
                      <button type="button" className="w-10 h-10 d-flex justify-content-center align-items-center rounded-circle border bg-transparent" data-bs-toggle="modal" data-bs-target="#addSponsorimagesModal"><i className="bx bx-image-add bx-sm"></i></button>
                    </div>
                  </div>
                </div>
                <div className="modal fade" id="addSponsorimagesModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="addSponsorimagesModalLabel" aria-hidden="true">
                  <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h3 className="modal-title fs-5 text-slate-600" id="addSponsorimagesModalLabel">Add Sponsor</h3>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                      </div>
                      <div className="modal-body">
                        <div className="d-flex flex-column row-gap-3">
                          <div className="input-group">
                            <input type="text" className="form-control" placeholder="Add guest name or email" aria-label="Recipient's username" aria-describedby="basic-addon2" />
                            <label for="sponsorfile" className="input-group-text align-items-center gap-1 text-slate-500 text-center cursor-pointer" id="basic-addon2">
                              <span className="material-symbols-outlined">cloud_upload</span>
                              Upload Picture
                              <input type="file" id="sponsorfile" className="d-none" />
                            </label>
                          </div>
                          <div className="d-flex flex-wrap gap-2">
                            <div className="p-1 rounded-pill d-flex align-items-center bg-slate-100 position-relative">
                              <button type="button" className="label-close w-4 h-4 rounded-circle border-0 bg-slate-200 position-absolute d-flex justify-content-center align-items-center"><i className="bx bx-x"></i></button>
                              <div className="w-10 h-10 rounded-circle overflow-hidden flex-none me-2 border border-white">
                                <img src="../assets/images/avatars/7.jpg" alt="" className="w-100 h-100 object-fit-cover" />
                              </div>
                              <span className="text-xs font-medium text-slate-500 me-3">Jamie Morgan</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="modal-footer">
                        {/* <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button> */}
                        <button type="button" className="btn btn-primary">Done</button>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
              <Col lg={12} md={12} sm={12} xs={12}>
                <div className="mb-3">
                  <div className="d-flex align-items-center">
                    <label className="form-label mb-0">Food will be provided?</label>
                    <div className="ms-auto">
                      {/* <div>
                        <div className="form-check form-check-inline">
                          <input className="form-check-input" type="radio" name="food" id="yes" value="option1" />
                          <label className="form-check-label" for="yes">Yes</label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input className="form-check-input" type="radio" name="food" id="no" value="option2" />
                          <label className="form-check-label" for="no">No</label>
                        </div>
                      </div> */}

                      <div className="form-check form-switch form-switch-lg d-flex align-items-center justify-content-between form-switch-right form-switch-success">
                        <label className="text-sm font-medium">No</label>
                        <input className="form-check-input mt-0 mx-2" type="checkbox" role="switch" id="switchCheckDefault" />
                        <label className="text-sm font-medium">Yes</label>
                      </div>
                    </div>


                  </div>
                </div>
              </Col>
              <Col lg={12} md={12} sm={12} xs={12}>
                <div className="mb-3">
                  <label for="organized" className="form-label">Organized by</label>
                  <input className="form-control" type="text" placeholder="Enter your name" id="organized" />
                </div>
              </Col>
              <Col lg={12} md={12} sm={12} xs={12}>
                <div className="mb-3">
                  <label for="addBanner" className="form-label">Add Event Banner</label>
                  <div className="file-input-box bg-white border rounded">
                    <label for="file" className="d-block p-5 text-center">
                      <span className="material-symbols-outlined">cloud_upload</span>
                      <h6 className="mb-0 text-grey-700">Upload your Banner</h6>
                      {/* <small>File Size 20 MB</small> */}
                    </label>
                    <input type="file" id="addBanner" className="d-none" />
                  </div>
                </div>
              </Col>
            </Row>

            <div className="mt-2 d-flex flex-wrap gap-2 justify-content-center">
              <button type="button" className="btn btn-primary">Back</button>
              <button type="button" className="btn btn-secondary">Next Step</button>
            </div>
          </div>

        </div>
      </div>

      <div className="mb-4">
        <div className="p-3 rounded-3 bg-white position-relative">
          <div className="d-flex flex-wrap align-items-center row-gap-3 mb-3">
            <div className="">
              <h3 className="text-md font-semibold mb-0">
                Create Your Event
              </h3>
            </div>
            <div className="ms-md-auto">
              <button type="button" className="btn btn-transparent border-0">
                <i className="bx bx-expand-alt bx-sm"></i>
              </button>
            </div>
          </div>

          <div className="">
            <div className="d-flex justify-content-center">
              <ul className="event-step-list list-unstyled d-inline-flex justify-content-center p-4 bg-slate-50 rounded-2">
                <li className="pt-5 px-5 position-relative active">
                  <span className="font-medium text-slate-400">Basic Details</span>
                </li>
                <li className="pt-5 px-5 position-relative active"><span className="font-medium text-slate-400">Location & Accessibility</span></li>
                <li className="pt-5 px-5 position-relative"><span className="font-medium text-slate-400">Final Touches</span></li>
              </ul>
            </div>
            <div className="d-flex align-items-center mb-3">
              <h3 className="me-3 mb-0 text-sm text-nowrap text-grey-700">
                Location & Accessibility
              </h3>
              <div className="bg-slate-200 w-100 h-1"></div>
            </div>
            <Row>
              <Col lg={4} md={4} sm={4} xs={12}>
                <div className="mb-3">
                  <label for="frequencyEvent" className="form-label">Frequency of event</label>
                  <select className="form-select" aria-label="Default select example" id="frequencyEvent">
                    <option selected value="0">Repeat</option>
                    <option value="1">Hybrid</option>
                    <option value="2">Remote</option>
                    <option value="3">Onsite</option>
                  </select>
                </div>
              </Col>
              <Col lg={4} md={4} sm={4} xs={12}>
                <div className="mb-3">
                  <label for="weeks" className="form-label">Every</label>
                  <select className="form-select" aria-label="Default select example" id="weeks">
                    <option value="0">1 Week</option>
                    <option value="1">2 Weeks</option>
                    <option value="2" selected>3 Weeks</option>
                    <option value="3">4 Weeks</option>
                  </select>
                </div>
              </Col>
              <Col lg={4} md={4} sm={4} xs={12}>
                <div className="mb-3">
                  <label for="organized" className="form-label">End after (Occurrence)</label>
                  <input className="form-control" type="number" placeholder="Enter your name" id="organized" />
                </div>
              </Col>
              <Col lg={12} md={12} sm={12} xs={12}>
                <div className="mb-3">
                  <div className="d-flex align-items-center">
                    <label className="form-label mb-0">Wheelchair accessible</label>
                    <div className="ms-auto">
                      <div className="form-check form-switch form-switch-lg d-flex align-items-center justify-content-between form-switch-right form-switch-success">
                        <label className="text-sm font-medium">No</label>
                        <input className="form-check-input mt-0 mx-2" type="checkbox" role="switch" id="" />
                        <label className="text-sm font-medium">Yes</label>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
              <Col lg={12} md={12} sm={12} xs={12}>
                <div className="mb-3">
                  <div className="d-flex align-items-center">
                    <label className="form-label mb-0">Parking will be provided if applicable</label>
                    <div className="ms-auto">
                      <div className="form-check form-switch form-switch-lg d-flex align-items-center justify-content-between form-switch-right form-switch-success">
                        <label className="text-sm font-medium">No</label>
                        <input className="form-check-input mt-0 mx-2" type="checkbox" role="switch" id="" />
                        <label className="text-sm font-medium">Yes</label>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
              <Col lg={12} md={12} sm={12} xs={12}>
                <div className="mb-3">
                  <div className="d-flex align-items-center">
                    <label className="form-label mb-0">Self Check-in?</label>
                    <div className="ms-auto">
                      <div className="form-check form-switch form-switch-lg d-flex align-items-center justify-content-between form-switch-right form-switch-success">
                        <label className="text-sm font-medium">No</label>
                        <input className="form-check-input mt-0 mx-2" type="checkbox" role="switch" id="" />
                        <label className="text-sm font-medium">Yes</label>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
              <Col lg={12} md={12} sm={12} xs={12}>
                <div className="mb-3">
                  <div className="d-flex align-items-center">
                    <label className="form-label mb-0">Generate unique QR Code for Self Check-in</label>
                    <div className="ms-auto">
                      <div className="form-check form-switch form-switch-lg d-flex align-items-center justify-content-between form-switch-right form-switch-success">
                        <label className="text-sm font-medium">No</label>
                        <input className="form-check-input mt-0 mx-2" type="checkbox" role="switch" id="" />
                        <label className="text-sm font-medium">Yes</label>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
            <div className="mt-2 d-flex flex-wrap gap-2 justify-content-center">
              <button type="button" className="btn btn-primary">Back</button>
              <button type="button" className="btn btn-secondary">Next Step</button>
            </div>
          </div>
        </div>
      </div>

      <div className="mb-4">
        <div className="p-3 rounded-3 bg-white position-relative">
          <div className="d-flex flex-wrap align-items-center row-gap-3 mb-3">
            <div className="">
              <h3 className="text-md font-semibold mb-0">
                Create Your Event
              </h3>
            </div>
            <div className="ms-md-auto">
              <button type="button" className="btn btn-transparent border-0">
                <i className="bx bx-expand-alt bx-sm"></i>
              </button>
            </div>
          </div>

          <div className="">
            <div className="d-flex justify-content-center">
              <ul className="event-step-list list-unstyled d-inline-flex justify-content-center p-4 bg-slate-50 rounded-2">
                <li className="pt-5 px-5 position-relative active">
                  <span className="font-medium text-slate-400">Basic Details</span>
                </li>
                <li className="pt-5 px-5 position-relative active"><span className="font-medium text-slate-400">Location & Accessibility</span></li>
                <li className="pt-5 px-5 position-relative active"><span className="font-medium text-slate-400">Final Touches</span></li>
              </ul>
            </div>
            <div className="d-flex align-items-center mb-3">
              <h3 className="me-3 mb-0 text-sm text-nowrap text-grey-700">
                Final Touches
              </h3>
              <div className="bg-slate-200 w-100 h-1"></div>
            </div>
            <Row>
              <Col lg={12} md={12} sm={12} xs={12}>
                <div className="mb-3">
                  <label for="rsvpRegistrationOptions" className="form-label">RSVP & Registration Options</label>
                  <select className="form-select" aria-label="Default select example" id="rsvpRegistrationOptions">
                    <option selected value="0">Open to all</option>
                    <option value="1">Hybrid</option>
                    <option value="2">Remote</option>
                    <option value="3">Onsite</option>
                  </select>
                </div>
              </Col>
              <Col lg={12} md={12} sm={12} xs={12}>
                <div className="mb-3">
                  <div className="d-flex align-items-center">
                    <div className="d-flex flex-column row-gap-2">
                      <label className="form-label mb-0">Add Invite form</label>
                    </div>
                    <div className="ms-auto">
                      <button type="button" className="w-10 h-10 d-flex justify-content-center align-items-center rounded-circle border bg-transparent" data-bs-toggle="modal" data-bs-target="#addInviteformModal"><i className="bx bx-user-plus bx-sm"></i></button>
                    </div>
                  </div>
                </div>

                <div className="modal fade" id="addInviteformModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="addInviteformLabel" aria-hidden="true">
                  <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h3 className="modal-title fs-5 text-slate-600" id="addInviteformlLabel">Add Event registration link </h3>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                      </div>
                      <div className="modal-body">
                        <ul className="list-unstyled d-flex flex-column row-gap-3">
                          <li>
                            <div className="h-12 px-3 py-2 border border-slate-300 rounded text-sm font-medium text-slate-500 bg-slate-50 d-flex align-items-center">Event registration form by PlutoEdu <a href="" className="text-primary ms-2">Form Builder</a></div>
                          </li>
                          <li className="text-center"><span className="mx-auto d-flex justify-content-center align-items-center text-sm font-semibold text-slate-700 w-8 h-8 rounded-circle border border-slate-400 bg-slate-100">Or</span></li>
                          <li>
                            <div className="h-14 px-3 py-2 border border-slate-300 rounded text-sm font-medium text-slate-500 bg-white d-flex align-items-center">
                              <span className="me-2 d-flex justify-content-center align-items-center text-sm font-semibold text-slate-700 flex-none w-6 h-6 rounded-circle border border-slate-400 bg-slate-100"><i className="bx bx-check bx-sm"></i></span>
                              <div className="me-2">Enter form link from Typeform</div>
                              <div className="ms-auto">
                                <img src="../assets/images/icons/typeform.svg" alt="" className="img-fluid" />
                              </div>
                            </div>
                          </li>
                          <li>
                            <div className="h-14 px-3 py-2 border border-slate-300 rounded text-sm font-medium text-slate-500 bg-white d-flex align-items-center">
                              <span className="me-2 d-flex justify-content-center align-items-center text-sm font-semibold text-slate-700 flex-none w-6 h-6 rounded-circle border border-slate-400 bg-slate-100"><i className="bx bx-check bx-sm"></i></span>
                              <div className="me-2">Enter from link from Formstack</div>
                              <div className="ms-auto">
                                <img src="../assets/images/icons/farmstack.svg" alt="" className="img-fluid" />
                              </div>
                            </div>
                          </li>
                          <li>
                            <div className="h-14 px-3 py-2 border border-slate-300 rounded text-sm font-medium text-slate-500 bg-white d-flex align-items-center">
                              <span className="me-2 d-flex justify-content-center align-items-center text-sm font-semibold text-slate-700 flex-none w-6 h-6 rounded-circle border border-slate-400 bg-slate-100"><i className="bx bx-check bx-sm"></i></span>
                              <div className="me-2">Enter form Link from Eventbrite</div>
                              <div className="ms-auto">
                                <img src="../assets/images/icons/eventbrite.svg" alt="" className="img-fluid" />
                              </div>
                            </div>
                          </li>
                          <li>
                            <div className="h-14 px-3 py-2 border border-slate-300 rounded text-sm font-medium text-slate-500 bg-white d-flex align-items-center">
                              <span className="me-2 d-flex justify-content-center align-items-center text-sm font-semibold text-slate-700 flex-none w-6 h-6 rounded-circle border border-slate-400 bg-slate-100"><i className="bx bx-check bx-sm"></i></span>
                              <div className="me-2">Enter from link from other sites</div>
                              {/* <div className="ms-auto">
                                <img src="../assets/images/icons/skype.svg" alt="" className="img-fluid" />
                              </div> */}
                            </div>
                          </li>
                        </ul>
                      </div>
                      <div className="modal-footer">
                        {/* <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button> */}
                        <button type="button" className="btn btn-primary">Done</button>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
              <Col lg={12} md={12} sm={12} xs={12}>
                <div className="mb-3">
                  <label for="organized" className="form-label">Registration Closing date</label>
                  <input className="form-control" type="date" placeholder="Enter your name" id="organized" />
                </div>
              </Col>
              <Col lg={12} md={12} sm={12} xs={12}>
                <div className="mb-3">
                  <div className="d-flex align-items-center">
                    <label className="form-label mb-0">Is the event free, or will there be an entry fee?</label>
                    <div className="ms-auto">
                      <div className="form-check form-switch form-switch-lg d-flex align-items-center justify-content-between form-switch-right form-switch-success">
                        <label className="text-sm font-medium">Free</label>
                        <input className="form-check-input mt-0 mx-2" type="checkbox" role="switch" id="" />
                        <label className="text-sm font-medium">Paid</label>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
              <Col lg={12} md={12} sm={12} xs={12}>
                <div className="mb-3">
                  <label for="contactInformation" className="form-label">Contact Information for Queries</label>
                  <input className="form-control" type="text" placeholder="Add email or Phone No" id="contactInformation" />
                </div>
              </Col>
              <Col lg={12} md={12} sm={12} xs={12}>
                <div className="mb-3">
                  <label for="termsCondition" className="form-label">Terms & Condition</label>
                  <textarea className="form-control" placeholder="Add email or Phone No" id="termsCondition" ></textarea>
                </div>
              </Col>
              <Col lg={12} md={12} sm={12} xs={12}>
                <div className="mb-3">
                  <label for="attendeesAllowed" className="form-label">Maximum no. of attendees allowed</label>
                  <input className="form-control" type="number" placeholder="" id="attendeesAllowed" />
                </div>
              </Col>
              <Col lg={12} md={12} sm={12} xs={12}>
                <div className="mb-3">
                  <div className="d-flex align-items-center">
                    <label className="form-label mb-0">Open Waitlist if maximum no of attendees reached</label>
                    <div className="ms-auto">
                      <div className="form-check form-switch form-switch-lg d-flex align-items-center justify-content-between form-switch-right form-switch-success">
                        <label className="text-sm font-medium">No</label>
                        <input className="form-check-input mt-0 mx-2" type="checkbox" role="switch" id="" />
                        <label className="text-sm font-medium">Yes</label>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
              <Col lg={12} md={12} sm={12} xs={12}>
                <div className="mb-3">
                  <div className="d-flex align-items-center">
                    <label className="form-label mb-0">Allow registered attendees to bring guest</label>
                    <div className="ms-auto">
                      <div className="form-check form-switch form-switch-lg d-flex align-items-center justify-content-between form-switch-right form-switch-success">
                        <label className="text-sm font-medium">No</label>
                        <input className="form-check-input mt-0 mx-2" type="checkbox" role="switch" id="" />
                        <label className="text-sm font-medium">Yes</label>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
              <Col lg={12} md={12} sm={12} xs={12}>
                <div className="mb-3">
                  <label for="attendeesPerAllowed" className="form-label">Maximum no. of guests allowed per attendees</label>
                  <input className="form-control" type="number" placeholder="" id="attendeesPerAllowed" />
                </div>
              </Col>
              <Col lg={12} md={12} sm={12} xs={12}>
                <div className="mb-3">
                  <div className="d-flex align-items-center">
                    <label className="form-label mb-0">Keep the comment section Open?</label>
                    <div className="ms-auto">
                      <div className="form-check form-switch form-switch-lg d-flex align-items-center justify-content-between form-switch-right form-switch-success">
                        <label className="text-sm font-medium">No</label>
                        <input className="form-check-input mt-0 mx-2" type="checkbox" role="switch" id="" />
                        <label className="text-sm font-medium">Yes</label>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
              <Col lg={12} md={12} sm={12} xs={12}>
                <div className="mb-3">
                  <div className="d-flex align-items-center">
                    <label className="form-label mb-0">Keep the Q&A section Open?</label>
                    <div className="ms-auto">
                      <div className="form-check form-switch form-switch-lg d-flex align-items-center justify-content-between form-switch-right form-switch-success">
                        <label className="text-sm font-medium">No</label>
                        <input className="form-check-input mt-0 mx-2" type="checkbox" role="switch" id="" />
                        <label className="text-sm font-medium">Yes</label>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
              <Col lg={12} md={12} sm={12} xs={12}>
                <div className="mb-3">
                  <div className="d-flex align-items-center">
                    <label className="form-label mb-0">Show No of Attendees in the event?</label>
                    <div className="ms-auto">
                      <div className="form-check form-switch form-switch-lg d-flex align-items-center justify-content-between form-switch-right form-switch-success">
                        <label className="text-sm font-medium">No</label>
                        <input className="form-check-input mt-0 mx-2" type="checkbox" role="switch" id="" />
                        <label className="text-sm font-medium">Yes</label>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>

            <div className="mt-2 d-flex flex-wrap gap-2 justify-content-center">
              <button type="button" className="btn btn-primary">Back</button>
              <button type="button" className="btn btn-secondary">Next Step</button>
            </div>
          </div>

        </div>
      </div>

      <div className="mb-4">
        <div className="p-3 rounded-3 bg-white position-relative">
          <div className="d-flex flex-wrap align-items-center row-gap-3 mb-3">
            <div className="">
              <h3 className="text-md font-semibold mb-0">
                Preview your event
              </h3>
            </div>
            <div className="ms-md-auto">
              <button type="button" className="btn btn-transparent border-0">
                <i className="bx bx-x bx-sm"></i>
              </button>
            </div>
          </div>

          <div className="">
            <div className="rounded-3 overflow-hidden position-relative pre-event-banner mb-4">
              <img src="../assets/images/post-img.jpg" alt="" className="w-100 h-100 d-block object-fit-cover" />
              <div className="p-3 position-absolute start-0 bottom-0 end-0">
                <div className="d-grid gap-2 d-md-flex">
                  <a href="#" className="btn btn-green">₹ 250/-</a>
                  <a href="#" className="btn btn-light">Open for all</a>
                </div>
              </div>
            </div>

            <div className="d-flex align-items-center mb-3">
              <div className="px-3 py-2 text-sm font-medium rounded-2 border bg-light me-3">Technology & Innovation: 📺</div>
              <button className="btn btn-secondary ms-auto">Register Event</button>
            </div>

            <div className="mb-3">
              <h3 className="h5 font-semibold">Tech Innovators Summit 2024</h3>
            </div>
            <div className="mb-5">
              <ul className="m-0 mb-3 p-0 list-unstyled text-sm font-medium text-slate-600 d-flex flex-column row-gap-2">
                <li className="d-flex align-items-center column-gap-1">
                  <i className="bx bx-calendar bx-sm text-slate-500"></i> 10 April 2023 | 9:00 AM
                </li>
                <li className="d-flex align-items-center column-gap-1">
                  <i className="bx bx-map bx-sm text-slate-500"></i> Gillz Hall, University Campus <button className="text-slate-500 border-0 bg-transparent"><i className="bx bx-link-external bx-sm"></i></button>
                </li>
              </ul>
              <div className="d-flex flex-rap align-items-center">
                <div className="header_img me-2">
                  <div className="img-box overflow-hidden rounded-circle bg-white">
                    <img
                      src="../assets/images/avatars/9.jpg"
                      alt=""
                      className="w-100 h-100 object-fit-cover"
                    />
                  </div>
                  <div className="img-box overflow-hidden rounded-circle bg-white">
                    <img
                      src="../assets/images/avatars/10.jpg"
                      alt=""
                      className="w-100 h-100 object-fit-cover"
                    />
                  </div>
                  <div className="img-box overflow-hidden rounded-circle bg-white">
                    <img
                      src="../assets/images/avatars/8.jpg"
                      alt=""
                      className="w-100 h-100 object-fit-cover"
                    />
                  </div>
                  <div className="img-box overflow-hidden rounded-circle bg-white">
                    <img
                      src="../assets/images/avatars/6.jpg"
                      alt=""
                      className="w-100 h-100 object-fit-cover"
                    />
                  </div>
                  <a href="#" className="more-img">
                    +521
                  </a>
                </div>
                <span className="text-sm text-slate-500"><strong>521+</strong> registered attendees</span>
              </div>
            </div>
            <div className="mb-5">
              <div className="p-4 rounded-3 border border-orange-300 bg-orange-50 d-flex align-items-center gap-3">
                <div className="text-sm">
                  <h4 className="text-md font-medium ">Want the Latest Updates from this Event?</h4>
                  <p>Join others already excited about the <strong>Tech Innovators Summit 2024!</strong> Click 'Interested' to receive all the latest updates directly in your notification.</p>
                </div>
                <div className="ms-auto">
                  <a href="#" className="btn btn-outline-green ms-auto text-nowrap"><span className="material-symbols-outlined align-middle me-1">thumb_up</span>Interested</a>
                </div>
              </div>
            </div>

            <div className="mb-3">
              <div className="slide-status-nav position-relative bg-white position-sticky top-0 z-1 mb-3">
                {/* <button className="btn btn-transparent border-0 back-right-position position-absolute top-0 start-0 bottom-0 d-flex align-items-center">
                  <i className="bx bx-arrow-back bx-sm"></i>
                </button> */}
                <Slider {...settings}>
                  <div className="nav-status-item">
                    <Link>Details</Link>
                  </div>
                  <div className="nav-status-item">
                    <Link>Amenities</Link>
                  </div>
                  <div className="nav-status-item">
                    <Link>Terms & Condition</Link>
                  </div>
                  <div className="nav-status-item">
                    <Link>Q&A Section</Link>
                  </div>
                  <div className="nav-status-item">
                    <Link>Comments</Link>
                  </div>
                </Slider>
              </div>
              <div className="p-4 text-sm text-slate-600 border rounded-3 mb-3">
                <h4 className="text-md font-semibold">Details</h4>
                <div className="mb-3">
                  <div className="d-flex align-items-center mb-3">
                    <div className="w-12 h-12 me-2 d-flex flex-none justify-content-center align-items-center text-white rounded-circle bg-purple-600 overflow-hidden">
                      <img src="../assets/images/avatars/9.jpg" alt="" className="w-100 h-100 object-fit-cover" />
                    </div>
                    <span>Organized by <strong>Julia Shelby</strong></span>
                  </div>
                  <p>Join the brightest minds in technology as we explore the future of innovation. Expect keynote speeches, workshops, and networking sessions designed to inspire and connect.</p>
                </div>

                <div>
                  <h4 className="text-base font-medium text-slate-400">Guest Speakers</h4>
                  <div className="d-flex flex-wrap gap-2">
                    <div className="p-1 rounded-pill d-flex align-items-center bg-slate-100 position-relative">
                      <div className="w-10 h-10 rounded-circle overflow-hidden flex-none me-2 border border-white">
                        <img alt="" className="w-100 h-100 object-fit-cover" src="../assets/images/avatars/8.jpg" />
                      </div>
                      <span className="text-xs font-medium text-slate-500 me-3">Jamie Morgan</span>
                    </div>
                    <div className="p-1 rounded-pill d-flex align-items-center bg-slate-100 position-relative">
                      <div className="w-10 h-10 rounded-circle overflow-hidden flex-none me-2 border border-white">
                        <img alt="" className="w-100 h-100 object-fit-cover" src="../assets/images/avatars/5.jpg" />
                      </div>
                      <span className="text-xs font-medium text-slate-500 me-3">Jamie Morgan</span>
                    </div>
                    <div className="p-1 rounded-pill d-flex align-items-center bg-slate-100 position-relative">
                      <div className="w-10 h-10 rounded-circle overflow-hidden flex-none me-2 border border-white">
                        <img alt="" className="w-100 h-100 object-fit-cover" src="../assets/images/avatars/6.jpg" />
                      </div>
                      <span className="text-xs font-medium text-slate-500 me-3">Jamie Morgan</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="p-4 text-sm text-slate-600 border rounded-3 mb-3">
                <h3 className="text-md font-semibold">Amenities</h3>
                <ul className="list-unstyled d-flex flex-column gap-3">
                  <li className="d-flex align-items-center gap-2">
                    <span className="material-symbols-outlined">lunch_dining</span>
                    <span>Complimentary lunch</span>
                  </li>
                  <li className="d-flex align-items-center gap-2">
                    <span className="material-symbols-outlined">personal_places</span>
                    <span>On-site parking</span>
                  </li>
                  <li className="d-flex align-items-center gap-2">
                    <span className="material-symbols-outlined">wifi</span>
                    <span>Free Wi-Fi</span>
                  </li>
                  <li className="d-flex align-items-center gap-2">
                    <span className="material-symbols-outlined">accessible</span>
                    <span>Wheelchair accessible</span>
                  </li>
                </ul>
              </div>
              <div className="p-4 text-sm text-slate-600 border rounded-3 mb-3">
                <h3 className="text-md font-semibold">Terms & Condition</h3>
                <p>By joining the Tech Innovators Summit 2024, you're stepping into a realm of discovery and connection. Here are key points to ensure a smooth and enjoyable experience for everyone involved:</p>
                <ul className="d-flex flex-column gap-3">
                  <li>Registration: Ensure your registration is completed by 10th April. Late registrations may not guarantee full participation privileges.</li>
                  <li>Refunds: Refunds are available up to [specific date] before the event. A [percentage] processing fee applies. Post-deadline, refunds will not be processed except under exceptional circumstances.</li>
                  <li>Attendee Conduct: Respect, inclusivity, and professionalism are our pillars. Any behavior undermining these principles will result in immediate removal and potential barring from future events.</li>
                  <li>Data Privacy: Your privacy is paramount. Personal information is secured and will only be used for event-related communications unless otherwise consented.</li>
                  <li>Content Sharing: Photographs and videos taken during the event may be used for promotional purposes. Participants wishing not to be featured should notify the organizers beforehand.</li>
                  <li>Liability: While we ensure the highest safety standards, attendees participate at their own risk and are encouraged to have personal insurance coverage.</li>
                  <li>Accessibility: We strive for inclusive access. Please inform us of any accessibility needs in advance to accommodate you effectively.</li>
                </ul>
              </div>
              <div className="p-4 text-sm text-slate-600 border rounded-3 mb-3">
                <h3 className="text-md font-semibold">Q&A Section</h3>
                <div className="d-flex align-items-center gap-2 mb-3">
                  <span className="material-symbols-outlined">forum</span><span className="text-md font-medium">Ask anything</span>
                </div>
                <div className="mb-3">
                  <button type="button" className="px-3 py-2 text-sm font-medium rounded-3 border border-orange-300 bg-orange-50 d-flex align-items-center gap-1 w-100">
                    <span className="material-symbols-outlined">add</span>Ask a question
                  </button>
                </div>
                <div className="d-flex flex-column row-gap-3">
                  <div className="p-3 rounded-3 border">
                    <div className="d-flex align-items-start">
                      <div className="me-3 w-100">
                        <div className="d-flex align-items-center mb-3">
                          <div className="w-9 h-9 me-2 flex-none rounded-circle overflow-hidden">
                            <div className="w-100 h-100 text-xs text-white d-flex justify-content-center align-items-center bg-purple-800">A</div>
                          </div>
                          <span className="font-medium">Arifa Parvin asked</span>
                        </div>
                        <h5 className="mb-3 text-base font-medium">Ask a random question here</h5>
                        <button type="button" className="btn btn-orange">Answer</button>
                      </div>
                      <button type="button" className="ms-auto border-0 bg-transparent text-slate-500"><span className="material-symbols-outlined align-middle me-1">thumb_up</span></button>
                    </div>
                  </div>
                  <div className="p-3 rounded-3 border">
                    <div className="d-flex align-items-start">
                      <div className="me-3 w-100">
                        <div className="d-flex align-items-center mb-3">
                          <div className="w-9 h-9 me-2 flex-none rounded-circle overflow-hidden">
                            <div className="w-100 h-100 text-xs text-white d-flex justify-content-center align-items-center bg-purple-800">A</div>
                          </div>
                          <span className="font-medium">Arifa Parvin asked</span>
                        </div>
                        <h5 className="mb-3 text-base font-medium">Ask a random question here</h5>
                        <button type="button" className="btn btn-orange">Answer</button>
                      </div>
                      <button type="button" className="ms-auto border-0 bg-transparent text-slate-500"><span className="material-symbols-outlined align-middle me-1">thumb_up</span></button>
                    </div>
                  </div>
                  <div className="p-3 rounded-3 border">
                    <div className="d-flex align-items-start">
                      <div className="me-3 w-100">
                        <div className="d-flex align-items-center mb-3">
                          <div className="w-9 h-9 me-2 flex-none rounded-circle overflow-hidden">
                            <div className="w-100 h-100 text-xs text-white d-flex justify-content-center align-items-center bg-purple-800">A</div>
                          </div>
                          <span className="font-medium">Arifa Parvin asked</span>
                        </div>
                        <h5 className="mb-3 text-base font-medium">Ask a random question here</h5>
                        <button type="button" className="btn btn-orange">Answer</button>
                      </div>
                      <button type="button" className="ms-auto border-0 bg-transparent text-slate-500"><span className="material-symbols-outlined align-middle me-1">thumb_up</span></button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="p-4 text-sm text-slate-600 border rounded-3 mb-3">
                <h3 className="text-md font-semibold">Comments</h3>

                <ul className="comments-list-items mb-4">
                  <li>
                    <div>
                      <div className="d-flex align-items-center mb-2">
                        <div className="d-flex align-items-center">
                          <div className="w-9 h-9 me-2 flex-none rounded-circle overflow-hidden">
                            <img src="../assets/images/avatars/8.jpg" alt="" className="w-100 h-100 object-fit-cover" />
                          </div>
                          <span className="font-medium me-2">Amyrobson</span> <span className="text-xs font-medium text-slate-400">1 month ago</span>
                        </div>
                        <button type="button" className="ms-auto border-0 bg-transparent text-orange-500"><span className="material-symbols-outlined align-middle me-1">reply</span><span className="font-medium">Reply</span></button>
                      </div>
                      <p>Impressive! Though it seems the drag feature could be improved. But overall it looks incredible. You’ve nailed the design and the responsiveness at various breakpoints works really well.</p>
                    </div>
                  </li>
                  <li className="mb-3">
                    <div>
                      <div className="d-flex align-items-center mb-2">
                        <div className="d-flex align-items-center">
                          <div className="w-9 h-9 me-2 flex-none rounded-circle overflow-hidden">
                            <img src="../assets/images/avatars/8.jpg" alt="" className="w-100 h-100 object-fit-cover" />
                          </div>
                          <span className="font-medium me-2">Amyrobson</span> <span className="text-xs font-medium text-slate-400">2 weeks ago</span>
                        </div>
                        <button type="button" className="ms-auto border-0 bg-transparent text-orange-500"><span className="material-symbols-outlined align-middle me-1">reply</span><span className="font-medium">Reply</span></button>
                      </div>
                      <p>Woah, your project looks awesome! How long have you been coding for? I’m still new, but think I want to dive into React as well soon. Perhaps you can give me an insight on where I can learn React? Thanks!</p>
                    </div>
                    <ul>
                      <li>
                        <div>
                          <div className="d-flex align-items-center mb-2">
                            <div className="d-flex align-items-center">
                              <div className="w-9 h-9 me-2 flex-none rounded-circle overflow-hidden">
                                <img src="../assets/images/avatars/5.jpg" alt="" className="w-100 h-100 object-fit-cover" />
                              </div>
                              <span className="font-medium me-2">Amyrobson</span> <span className="text-xs font-medium text-slate-400">1 week ago</span>
                            </div>
                            <button type="button" className="ms-auto border-0 bg-transparent text-orange-500"><span className="material-symbols-outlined align-middle me-1">reply</span><span className="font-medium">Reply</span></button>
                          </div>
                          <p><a href="#">@maxblagun</a> If you're still new, I'd recommend focusing on the fundamentals of HTML, CSS, and JS before considering React. It's very tempting to jump ahead but lay a solid foundation first.</p>
                        </div>
                      </li>
                      <li>
                        <div>
                          <div className="d-flex align-items-center mb-2">
                            <div className="d-flex align-items-center">
                              <div className="w-9 h-9 me-2 flex-none rounded-circle overflow-hidden">
                                <img src="../assets/images/avatars/5.jpg" alt="" className="w-100 h-100 object-fit-cover" />
                              </div>
                              <span className="font-medium me-2">Amyrobson</span> <span className="text-xs font-medium text-slate-400">2 days ago</span>
                            </div>
                            <button type="button" className="ms-auto border-0 bg-transparent text-orange-500"><span className="material-symbols-outlined align-middle me-1">reply</span><span className="font-medium">Reply</span></button>
                          </div>
                          <p><a href="#">@maxblagun</a> If you're still new, I'd recommend focusing on the fundamentals of HTML, CSS, and JS before considering React. It's very tempting to jump ahead but lay a solid foundation first.</p>
                        </div>
                      </li>
                    </ul>
                  </li>
                </ul>
                <div>
                  <div className="mb-2">
                    <div className="d-flex align-items-start">
                      <div className="w-9 h-9 me-2 flex-none rounded-circle overflow-hidden">
                        <img src="../assets/images/avatars/5.jpg" alt="" className="w-100 h-100 object-fit-cover" />
                      </div>
                      <div className="w-100">
                        <div className="mb-3">
                          <textarea type="text" className="form-control" ></textarea>
                        </div>
                        <button type="submit" className="btn btn-orange">Send</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="mb-5 d-flex flex-wrap gap-2 justify-content-center">
              <button className="btn btn-primary" type="button">Go Back & Edit</button>
              <button className="btn btn-secondary" type="button">Publish Event</button>
            </div>
          </div>

          <div>
            <div className="d-flex flex-wrap align-items-center row-gap-3 mb-3">
              <div className="">
                <h3 className="text-md font-semibold text-slate-600 mb-0">Similar Events</h3>
              </div>
              <div className="ms-md-auto">
                <div className="btn-group" role="group" aria-label="Basic example">
                  <button type="button" className="btn btn-outline-orange border-2 active" >
                    <span className="material-symbols-outlined">event_note</span>
                  </button>
                  <button type="button" className="btn btn-outline-orange border-2" >
                    <span className="material-symbols-outlined">tune</span>
                  </button>
                </div>
              </div>
            </div>

            <div className="row gy-4">
              <div className="col-xxl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                <div className="rounded-3 bg-slate-50">
                  <div className="rounded-3 overflow-hidden position-relative pre-event-banner">
                    <img src="../assets/images/post-img.jpg" alt="" className="w-100 h-100 d-block object-fit-cover" />
                    <div className="p-3 position-absolute start-0 bottom-0 end-0">
                      <div className="d-grid gap-2 d-md-flex">
                        <a href="#" className="btn btn-green">₹ 250/-</a>
                        <a href="#" className="btn btn-light">Open for all</a>
                      </div>
                    </div>
                  </div>
                  <div className="p-3">
                    <div className="mb-3">
                      <h4 className="text-base font-semibold">Tech Innovators Summit 2024</h4>
                    </div>
                    <div className="mb-3">
                      <ul className="m-0 mb-3 p-0 list-unstyled text-xs font-medium text-slate-600 d-flex flex-column row-gap-2">
                        <li className="d-flex align-items-center column-gap-1">
                          <i className="bx bx-calendar text-lg text-slate-500 align-middle"></i> 10 April 2023 | 9:00 AM
                        </li>
                      </ul>
                    </div>

                    <div className="d-flex align-items-center">
                      <div className="px-3 py-2 text-sm font-medium rounded-2 border bg-white me-3">Technology & Innovation: 📺</div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xxl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                <div className="rounded-3 bg-slate-50">
                  <div className="rounded-3 overflow-hidden position-relative pre-event-banner">
                    <img src="../assets/images/post-img.jpg" alt="" className="w-100 h-100 d-block object-fit-cover" />
                    <div className="p-3 position-absolute start-0 bottom-0 end-0">
                      <div className="d-grid gap-2 d-md-flex">
                        <a href="#" className="btn btn-green">₹ 250/-</a>
                        <a href="#" className="btn btn-light">Open for all</a>
                      </div>
                    </div>
                  </div>
                  <div className="p-3">
                    <div className="mb-3">
                      <h4 className="text-base font-semibold">Tech Innovators Summit 2024</h4>
                    </div>
                    <div className="mb-3">
                      <ul className="m-0 mb-3 p-0 list-unstyled text-xs font-medium text-slate-600 d-flex flex-column row-gap-2">
                        <li className="d-flex align-items-center column-gap-1">
                          <i className="bx bx-calendar text-lg text-slate-500 align-middle"></i> 10 April 2023 | 9:00 AM
                        </li>
                      </ul>
                    </div>

                    <div className="d-flex align-items-center">
                      <div className="px-3 py-2 text-sm font-medium rounded-2 border bg-white me-3">Technology & Innovation: 📺</div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xxl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                <div className="rounded-3 bg-slate-50">
                  <div className="rounded-3 overflow-hidden position-relative pre-event-banner">
                    <img src="../assets/images/post-img.jpg" alt="" className="w-100 h-100 d-block object-fit-cover" />
                    <div className="p-3 position-absolute start-0 bottom-0 end-0">
                      <div className="d-grid gap-2 d-md-flex">
                        <a href="#" className="btn btn-green">₹ 250/-</a>
                        <a href="#" className="btn btn-light">Open for all</a>
                      </div>
                    </div>
                  </div>
                  <div className="p-3">
                    <div className="mb-3">
                      <h4 className="text-base font-semibold">Tech Innovators Summit 2024</h4>
                    </div>
                    <div className="mb-3">
                      <ul className="m-0 mb-3 p-0 list-unstyled text-xs font-medium text-slate-600 d-flex flex-column row-gap-2">
                        <li className="d-flex align-items-center column-gap-1">
                          <i className="bx bx-calendar text-lg text-slate-500 align-middle"></i> 10 April 2023 | 9:00 AM
                        </li>
                      </ul>
                    </div>

                    <div className="d-flex align-items-center">
                      <div className="px-3 py-2 text-sm font-medium rounded-2 border bg-white me-3">Technology & Innovation: 📺</div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xxl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                <div className="rounded-3 bg-slate-50">
                  <div className="rounded-3 overflow-hidden position-relative pre-event-banner">
                    <img src="../assets/images/post-img.jpg" alt="" className="w-100 h-100 d-block object-fit-cover" />
                    <div className="p-3 position-absolute start-0 bottom-0 end-0">
                      <div className="d-grid gap-2 d-md-flex">
                        <a href="#" className="btn btn-green">₹ 250/-</a>
                        <a href="#" className="btn btn-light">Open for all</a>
                      </div>
                    </div>
                  </div>
                  <div className="p-3">
                    <div className="mb-3">
                      <h4 className="text-base font-semibold">Tech Innovators Summit 2024</h4>
                    </div>
                    <div className="mb-3">
                      <ul className="m-0 mb-3 p-0 list-unstyled text-xs font-medium text-slate-600 d-flex flex-column row-gap-2">
                        <li className="d-flex align-items-center column-gap-1">
                          <i className="bx bx-calendar text-lg text-slate-500 align-middle"></i> 10 April 2023 | 9:00 AM
                        </li>
                      </ul>
                    </div>

                    <div className="d-flex align-items-center">
                      <div className="px-3 py-2 text-sm font-medium rounded-2 border bg-white me-3">Technology & Innovation: 📺</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="mb-4 p-4 rounded-3 bg-white">
        <div className="mb-3 p-4 text-white rounded-3 bg-gredient-1 position-relative overflow-hidden">
          <div className="parent-event-img position-absolute top-0 start-0 bottom-0 end-0">
            <img src="https://img.freepik.com/free-photo/free-time-students-bachelor-s-campus-life-rhythm-five-friendly-students-are-walking_8353-6408.jpg?t=st=1723899046~exp=1723902646~hmac=644b1ea53c82edda311982e259df875fd16cb1fbc5ad590a9f21a741377caaba&w=1380" alt="" className="w-100 h-100 object-fit-cover" />
          </div>
          <div className="row align-items-start gy-3 position-relative z-1">
            <div className="col-md-8 col-sm-12 col-12">
              <h2 className="h4">Discover, Participate, and Earn: Enrich Your Campus Journey!</h2>
              <p>Dive into a world of opportunities and fun on campus! Join any event listed here and start earning coins with each participation.</p>
              <a href="#" className="text-decoration-none text-white">Know more</a>
            </div>
            <div className="col-md-4 col-sm-12 col-12 text-md-end">
              <button className="btn btn-light" data-bs-toggle="modal" data-bs-target="#createEvent">
                <i className="bx bxs-magic-wand bx-sm me-1 align-middle"></i>{" "}
                Event Creation Wizard
              </button>
            </div>
          </div>
        </div>
        <div className="category-list mb-4">
          <Slider {...categoryList}>
            <div >
              <div className="p-1 d-flex align-items-center rounded-pill border border-slate-200 bg-white category-box cursor-pointer">
                <div className="flex-auto avatar-img w-8 h-8 d-flex justify-content-center align-items-center bg-slate-50 shadow-sm">🔥</div>
                <span className="d-inline-block px-2 py-1 text-sm font-medium">All</span>
              </div>
            </div>
            <div>
              <div className="p-1 d-flex align-items-center rounded-pill border border-slate-200 bg-white category-box cursor-pointer">
                <div className="flex-auto avatar-img w-8 h-8 d-flex justify-content-center align-items-center bg-slate-200 shadow-sm">🎶</div>
                <span className="d-inline-block px-2 py-1 text-sm font-medium">Music</span>
              </div>
            </div>
            <div>
              <div className="p-1 d-flex align-items-center rounded-pill border border-slate-200 bg-white category-box cursor-pointer">
                <div className="flex-auto avatar-img w-8 h-8 d-flex justify-content-center align-items-center bg-slate-200 shadow-sm">🍔</div>
                <span className="d-inline-block px-2 py-1 text-sm font-medium">Food Fest</span>
              </div>
            </div>
            <div>
              <div className="p-1 d-flex align-items-center rounded-pill border border-slate-200 bg-white category-box cursor-pointer">
                <div className="flex-auto avatar-img w-8 h-8 d-flex justify-content-center align-items-center bg-slate-200 shadow-sm">🎨</div>
                <span className="d-inline-block px-2 py-1 text-sm font-medium">Art & Culture</span>
              </div>
            </div>
            <div>
              <div className="p-1 d-flex align-items-center rounded-pill border border-slate-200 bg-white category-box cursor-pointer">
                <div className="flex-auto avatar-img w-8 h-8 d-flex justify-content-center align-items-center bg-slate-200 shadow-sm">🏋️</div>
                <span className="d-inline-block px-2 py-1 text-sm font-medium">Sports & Wellness</span>
              </div>
            </div>
            <div>
              <div className="p-1 d-flex align-items-center rounded-pill border border-slate-200 bg-white category-box cursor-pointer">
                <div className="flex-auto avatar-img w-8 h-8 d-flex justify-content-center align-items-center bg-slate-200 shadow-sm">🎓</div>
                <span className="d-inline-block px-2 py-1 text-sm font-medium">Academic & Networking</span>
              </div>
            </div>
            <div>
              <div className="p-1 d-flex align-items-center rounded-pill border border-slate-200 bg-white category-box cursor-pointer">
                <div className="flex-auto avatar-img w-8 h-8 d-flex justify-content-center align-items-center bg-slate-200 shadow-sm">💡</div>
                <span className="d-inline-block px-2 py-1 text-sm font-medium">Technology & Innovation</span>
              </div>
            </div>
            <div>
              <div className="p-1 d-flex align-items-center rounded-pill border border-slate-200 bg-white category-box cursor-pointer">
                <div className="flex-auto avatar-img w-8 h-8 d-flex justify-content-center align-items-center bg-slate-200 shadow-sm">🎶</div>
                <span className="d-inline-block px-2 py-1 text-sm font-medium">Music</span>
              </div>
            </div>
            <div>
              <div className="p-1 d-flex align-items-center rounded-pill border border-slate-200 bg-white category-box cursor-pointer">
                <div className="flex-auto avatar-img w-8 h-8 d-flex justify-content-center align-items-center bg-slate-200 shadow-sm">🍔</div>
                <span className="d-inline-block px-2 py-1 text-sm font-medium">Food Fest</span>
              </div>
            </div>
            <div>
              <div className="p-1 d-flex align-items-center rounded-pill border border-slate-200 bg-white category-box cursor-pointer">
                <div className="flex-auto avatar-img w-8 h-8 d-flex justify-content-center align-items-center bg-slate-200 shadow-sm">🎨</div>
                <span className="d-inline-block px-2 py-1 text-sm font-medium">Art & Culture</span>
              </div>
            </div>
            <div>
              <div className="p-1 d-flex align-items-center rounded-pill border border-slate-200 bg-white category-box cursor-pointer">
                <div className="flex-auto avatar-img w-8 h-8 d-flex justify-content-center align-items-center bg-slate-200 shadow-sm">🏋️</div>
                <span className="d-inline-block px-2 py-1 text-sm font-medium">Sports & Wellness</span>
              </div>
            </div>
            <div>
              <div className="p-1 d-flex align-items-center rounded-pill border border-slate-200 bg-white category-box cursor-pointer">
                <div className="flex-auto avatar-img w-8 h-8 d-flex justify-content-center align-items-center bg-slate-200 shadow-sm">🎓</div>
                <span className="d-inline-block px-2 py-1 text-sm font-medium">Academic & Networking</span>
              </div>
            </div>
            <div>
              <div className="p-1 d-flex align-items-center rounded-pill border border-slate-200 bg-white category-box cursor-pointer">
                <div className="flex-auto avatar-img w-8 h-8 d-flex justify-content-center align-items-center bg-slate-200 shadow-sm">💡</div>
                <span className="d-inline-block px-2 py-1 text-sm font-medium">Technology & Innovation</span>
              </div>
            </div>
          </Slider>
        </div>

        <div className="mb-4">
          <div className="d-flex flex-wrap align-items-center row-gap-3 mb-3">
            <ul className="list-unstyled mb-0 d-flex align-items-center gap-3 event-tabs">
              <li className="text-base font-medium active">Events you are attending</li>
              <li className="text-base font-medium">Events you created</li>
            </ul>
            <div className="ms-md-auto">
              <div className="btn-group" role="group" aria-label="Basic example">
                <button type="button" className="btn btn-outline-orange border-2 active" >
                  <span className="material-symbols-outlined">event_note</span>
                </button>
                <button type="button" className="btn btn-outline-orange border-2" >
                  <span className="material-symbols-outlined">tune</span>
                </button>
              </div>
            </div>
          </div>

          <div className="row gy-4">
            <div className="col-xxl-3 col-lg-4 col-md-6 col-sm-6 col-12">
              <div className="rounded-3 bg-slate-50">
                <div className="rounded-3 overflow-hidden position-relative pre-event-banner">
                  <img src="../assets/images/post-img.jpg" alt="" className="w-100 h-100 d-block object-fit-cover" />
                  <div className="p-3 position-absolute start-0 bottom-0 end-0">
                    <div className="d-grid gap-2 d-md-flex">
                      <a href="#" className="btn btn-green">₹ 250/-</a>
                      <a href="#" className="btn btn-light">Open for all</a>
                    </div>
                  </div>
                </div>
                <div className="p-3">
                  <div className="mb-3">
                    <h4 className="text-base font-semibold">Tech Innovators Summit 2024</h4>
                  </div>
                  <div className="mb-3">
                    <ul className="m-0 mb-3 p-0 list-unstyled text-xs font-medium text-slate-600 d-flex flex-column row-gap-2">
                      <li className="d-flex align-items-center column-gap-1">
                        <i className="bx bx-calendar text-lg text-slate-500 align-middle"></i> 10 April 2023 | 9:00 AM
                      </li>
                    </ul>
                  </div>

                  <div className="d-flex align-items-center">
                    <div className="px-3 py-2 text-sm font-medium rounded-2 border bg-white me-3">Technology & Innovation: 📺</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xxl-3 col-lg-4 col-md-6 col-sm-6 col-12">
              <div className="rounded-3 bg-slate-50">
                <div className="rounded-3 overflow-hidden position-relative pre-event-banner">
                  <img src="../assets/images/post-img.jpg" alt="" className="w-100 h-100 d-block object-fit-cover" />
                  <div className="p-3 position-absolute start-0 bottom-0 end-0">
                    <div className="d-grid gap-2 d-md-flex">
                      <a href="#" className="btn btn-green">₹ 250/-</a>
                      <a href="#" className="btn btn-light">Open for all</a>
                    </div>
                  </div>
                </div>
                <div className="p-3">
                  <div className="mb-3">
                    <h4 className="text-base font-semibold">Tech Innovators Summit 2024</h4>
                  </div>
                  <div className="mb-3">
                    <ul className="m-0 mb-3 p-0 list-unstyled text-xs font-medium text-slate-600 d-flex flex-column row-gap-2">
                      <li className="d-flex align-items-center column-gap-1">
                        <i className="bx bx-calendar text-lg text-slate-500 align-middle"></i> 10 April 2023 | 9:00 AM
                      </li>
                    </ul>
                  </div>

                  <div className="d-flex align-items-center">
                    <div className="px-3 py-2 text-sm font-medium rounded-2 border bg-white me-3">Technology & Innovation: 📺</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xxl-3 col-lg-4 col-md-6 col-sm-6 col-12">
              <div className="rounded-3 bg-slate-50">
                <div className="rounded-3 overflow-hidden position-relative pre-event-banner">
                  <img src="../assets/images/post-img.jpg" alt="" className="w-100 h-100 d-block object-fit-cover" />
                  <div className="p-3 position-absolute start-0 bottom-0 end-0">
                    <div className="d-grid gap-2 d-md-flex">
                      <a href="#" className="btn btn-green">₹ 250/-</a>
                      <a href="#" className="btn btn-light">Open for all</a>
                    </div>
                  </div>
                </div>
                <div className="p-3">
                  <div className="mb-3">
                    <h4 className="text-base font-semibold">Tech Innovators Summit 2024</h4>
                  </div>
                  <div className="mb-3">
                    <ul className="m-0 mb-3 p-0 list-unstyled text-xs font-medium text-slate-600 d-flex flex-column row-gap-2">
                      <li className="d-flex align-items-center column-gap-1">
                        <i className="bx bx-calendar text-lg text-slate-500 align-middle"></i> 10 April 2023 | 9:00 AM
                      </li>
                    </ul>
                  </div>

                  <div className="d-flex align-items-center">
                    <div className="px-3 py-2 text-sm font-medium rounded-2 border bg-white me-3">Technology & Innovation: 📺</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xxl-3 col-lg-4 col-md-6 col-sm-6 col-12">
              <div className="rounded-3 bg-slate-50">
                <div className="rounded-3 overflow-hidden position-relative pre-event-banner">
                  <img src="../assets/images/post-img.jpg" alt="" className="w-100 h-100 d-block object-fit-cover" />
                  <div className="p-3 position-absolute start-0 bottom-0 end-0">
                    <div className="d-grid gap-2 d-md-flex">
                      <a href="#" className="btn btn-green">₹ 250/-</a>
                      <a href="#" className="btn btn-light">Open for all</a>
                    </div>
                  </div>
                </div>
                <div className="p-3">
                  <div className="mb-3">
                    <h4 className="text-base font-semibold">Tech Innovators Summit 2024</h4>
                  </div>
                  <div className="mb-3">
                    <ul className="m-0 mb-3 p-0 list-unstyled text-xs font-medium text-slate-600 d-flex flex-column row-gap-2">
                      <li className="d-flex align-items-center column-gap-1">
                        <i className="bx bx-calendar text-lg text-slate-500 align-middle"></i> 10 April 2023 | 9:00 AM
                      </li>
                    </ul>
                  </div>

                  <div className="d-flex align-items-center">
                    <div className="px-3 py-2 text-sm font-medium rounded-2 border bg-white me-3">Technology & Innovation: 📺</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div>
          <div className="d-flex flex-wrap align-items-center row-gap-3 mb-3">
            <ul className="list-unstyled mb-0 d-flex align-items-center gap-3 event-tabs">
              <li className="text-base font-medium active">Trending Events near you</li>
              {/* <li className="text-base font-medium">Events you created</li> */}
            </ul>
            <div className="ms-md-auto">
              <div className="btn-group" role="group" aria-label="Basic example">
                <button type="button" className="btn btn-outline-orange border-2 active" >
                  <span className="material-symbols-outlined">event_note</span>
                </button>
                <button type="button" className="btn btn-outline-orange border-2" >
                  <span className="material-symbols-outlined">tune</span>
                </button>
              </div>
            </div>
          </div>

          <div className="row gy-4">
            <div className="col-xxl-3 col-lg-4 col-md-6 col-sm-6 col-12">
              <div className="rounded-3 bg-slate-50">
                <div className="rounded-3 overflow-hidden position-relative pre-event-banner">
                  <img src="../assets/images/post-img.jpg" alt="" className="w-100 h-100 d-block object-fit-cover" />
                  <div className="p-3 position-absolute start-0 bottom-0 end-0">
                    <div className="d-grid gap-2 d-md-flex">
                      <a href="#" className="btn btn-green">₹ 250/-</a>
                      <a href="#" className="btn btn-light">Open for all</a>
                    </div>
                  </div>
                </div>
                <div className="p-3">
                  <div className="mb-3">
                    <h4 className="text-base font-semibold">Tech Innovators Summit 2024</h4>
                  </div>
                  <div className="mb-3">
                    <ul className="m-0 mb-3 p-0 list-unstyled text-xs font-medium text-slate-600 d-flex flex-column row-gap-2">
                      <li className="d-flex align-items-center column-gap-1">
                        <i className="bx bx-calendar text-lg text-slate-500 align-middle"></i> 10 April 2023 | 9:00 AM
                      </li>
                    </ul>
                  </div>

                  <div className="d-flex align-items-center">
                    <div className="px-3 py-2 text-sm font-medium rounded-2 border bg-white me-3">Technology & Innovation: 📺</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xxl-3 col-lg-4 col-md-6 col-sm-6 col-12">
              <div className="rounded-3 bg-slate-50">
                <div className="rounded-3 overflow-hidden position-relative pre-event-banner">
                  <img src="../assets/images/post-img.jpg" alt="" className="w-100 h-100 d-block object-fit-cover" />
                  <div className="p-3 position-absolute start-0 bottom-0 end-0">
                    <div className="d-grid gap-2 d-md-flex">
                      <a href="#" className="btn btn-green">₹ 250/-</a>
                      <a href="#" className="btn btn-light">Open for all</a>
                    </div>
                  </div>
                </div>
                <div className="p-3">
                  <div className="mb-3">
                    <h4 className="text-base font-semibold">Tech Innovators Summit 2024</h4>
                  </div>
                  <div className="mb-3">
                    <ul className="m-0 mb-3 p-0 list-unstyled text-xs font-medium text-slate-600 d-flex flex-column row-gap-2">
                      <li className="d-flex align-items-center column-gap-1">
                        <i className="bx bx-calendar text-lg text-slate-500 align-middle"></i> 10 April 2023 | 9:00 AM
                      </li>
                    </ul>
                  </div>

                  <div className="d-flex align-items-center">
                    <div className="px-3 py-2 text-sm font-medium rounded-2 border bg-white me-3">Technology & Innovation: 📺</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xxl-3 col-lg-4 col-md-6 col-sm-6 col-12">
              <div className="rounded-3 bg-slate-50">
                <div className="rounded-3 overflow-hidden position-relative pre-event-banner">
                  <img src="../assets/images/post-img.jpg" alt="" className="w-100 h-100 d-block object-fit-cover" />
                  <div className="p-3 position-absolute start-0 bottom-0 end-0">
                    <div className="d-grid gap-2 d-md-flex">
                      <a href="#" className="btn btn-green">₹ 250/-</a>
                      <a href="#" className="btn btn-light">Open for all</a>
                    </div>
                  </div>
                </div>
                <div className="p-3">
                  <div className="mb-3">
                    <h4 className="text-base font-semibold">Tech Innovators Summit 2024</h4>
                  </div>
                  <div className="mb-3">
                    <ul className="m-0 mb-3 p-0 list-unstyled text-xs font-medium text-slate-600 d-flex flex-column row-gap-2">
                      <li className="d-flex align-items-center column-gap-1">
                        <i className="bx bx-calendar text-lg text-slate-500 align-middle"></i> 10 April 2023 | 9:00 AM
                      </li>
                    </ul>
                  </div>

                  <div className="d-flex align-items-center">
                    <div className="px-3 py-2 text-sm font-medium rounded-2 border bg-white me-3">Technology & Innovation: 📺</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xxl-3 col-lg-4 col-md-6 col-sm-6 col-12">
              <div className="rounded-3 bg-slate-50">
                <div className="rounded-3 overflow-hidden position-relative pre-event-banner">
                  <img src="../assets/images/post-img.jpg" alt="" className="w-100 h-100 d-block object-fit-cover" />
                  <div className="p-3 position-absolute start-0 bottom-0 end-0">
                    <div className="d-grid gap-2 d-md-flex">
                      <a href="#" className="btn btn-green">₹ 250/-</a>
                      <a href="#" className="btn btn-light">Open for all</a>
                    </div>
                  </div>
                </div>
                <div className="p-3">
                  <div className="mb-3">
                    <h4 className="text-base font-semibold">Tech Innovators Summit 2024</h4>
                  </div>
                  <div className="mb-3">
                    <ul className="m-0 mb-3 p-0 list-unstyled text-xs font-medium text-slate-600 d-flex flex-column row-gap-2">
                      <li className="d-flex align-items-center column-gap-1">
                        <i className="bx bx-calendar text-lg text-slate-500 align-middle"></i> 10 April 2023 | 9:00 AM
                      </li>
                    </ul>
                  </div>

                  <div className="d-flex align-items-center">
                    <div className="px-3 py-2 text-sm font-medium rounded-2 border bg-white me-3">Technology & Innovation: 📺</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="p-4 rounded-3 bg-white">
        <div className="invite-search-box my-3">
          <div className="input-group gap-2">
            <input
              type="text"
              className="form-control form-control-lg rounded-2 border-2"
              placeholder="Add email here"
            />
            <button
              className="btn btn-secondary px-4 text-white rounded-2"
              type="button"
              id="button-addon2"
            >
              Invite
            </button>
          </div>
        </div>

        <h4 className="h6 mb-4 text-grey-800">Recent invite</h4>
        <form className="from-box from-box-lg">
          <ul className="m-0 p-0">
            <li className="row align-items-center">
              <div className="col-md-4 col-sm-6 col-12">
                <div className="mb-4">
                  <div className="d-flex align-items-center">
                    <div className="w-16 h-16 me-2 d-flex flex-none justify-content-center align-items-center text-white rounded-circle bg-purple-600">
                      SA
                    </div>
                    <a
                      href="mailto:roberto@gmail.com"
                      className="text-grey-800 text-decoration-none"
                    >
                      roberto@gmail.com
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-md-3 col-sm-6 col-12">
                <div className="mb-4">
                  <label htmlFor="firstName2" className="form-label">
                    First Name
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-lg"
                    id="firstName2"
                  />{" "}
                </div>
              </div>
              <div className="col-md-3 col-sm-6 col-12">
                <div className="mb-4">
                  <label htmlFor="lastName2" className="form-label">
                    Last Name
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-lg"
                    id="lastName2"
                  />{" "}
                </div>
              </div>
              <div className="col-md-2 col-sm-6 col-12">
                <div className="mb-4">
                  <label htmlFor="role" className="form-label">
                    Role
                  </label>
                  <select
                    className="form-select form-select-lg"
                    aria-label="Default select example"
                  >
                    <option selected>Default</option>
                    <option value="1">One</option>
                    <option value="2">Two</option>
                    <option value="3">Three</option>
                  </select>
                </div>
              </div>
            </li>
            <li className="row align-items-center">
              <div className="col-md-4 col-sm-6 col-12">
                <div className="mb-4">
                  <div className="d-flex align-items-center">
                    <div className="w-16 h-16 me-2 d-flex flex-none justify-content-center align-items-center text-white rounded-circle bg-purple-600">
                      SA
                    </div>
                    <a
                      href="mailto:roberto@gmail.com"
                      className="text-grey-800 text-decoration-none"
                    >
                      roberto@gmail.com
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-md-3 col-sm-6 col-12">
                <div className="mb-4">
                  <label htmlFor="firstName2" className="form-label">
                    First Name
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-lg"
                    id="firstName2"
                  />{" "}
                </div>
              </div>
              <div className="col-md-3 col-sm-6 col-12">
                <div className="mb-4">
                  <label htmlFor="lastName2" className="form-label">
                    Last Name
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-lg"
                    id="lastName2"
                  />{" "}
                </div>
              </div>
              <div className="col-md-2 col-sm-6 col-12">
                <div className="mb-4">
                  <label htmlFor="role" className="form-label">
                    Role
                  </label>
                  <select
                    className="form-select form-select-lg"
                    aria-label="Default select example"
                  >
                    <option selected>Default</option>
                    <option value="1">One</option>
                    <option value="2">Two</option>
                    <option value="3">Three</option>
                  </select>
                </div>
              </div>
            </li>
            <li className="row align-items-center">
              <div className="col-md-4 col-sm-6 col-12">
                <div className="mb-4">
                  <div className="d-flex align-items-center">
                    <div className="w-16 h-16 me-2 d-flex flex-none justify-content-center align-items-center text-white rounded-circle bg-purple-600">
                      SA
                    </div>
                    <a
                      href="mailto:roberto@gmail.com"
                      className="text-grey-800 text-decoration-none"
                    >
                      roberto@gmail.com
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-md-3 col-sm-6 col-12">
                <div className="mb-4">
                  <label htmlFor="firstName2" className="form-label">
                    First Name
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-lg"
                    id="firstName2"
                  />{" "}
                </div>
              </div>
              <div className="col-md-3 col-sm-6 col-12">
                <div className="mb-4">
                  <label htmlFor="lastName2" className="form-label">
                    Last Name
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-lg"
                    id="lastName2"
                  />{" "}
                </div>
              </div>
              <div className="col-md-2 col-sm-6 col-12">
                <div className="mb-4">
                  <label htmlFor="role" className="form-label">
                    Role
                  </label>
                  <select
                    className="form-select form-select-lg"
                    aria-label="Default select example"
                  >
                    <option selected>Default</option>
                    <option value="1">One</option>
                    <option value="2">Two</option>
                    <option value="3">Three</option>
                  </select>
                </div>
              </div>
            </li>
            <li className="row align-items-center">
              <div className="col-md-4 col-sm-6 col-12">
                <div className="mb-4">
                  <div className="d-flex align-items-center">
                    <div className="w-16 h-16 me-2 d-flex flex-none justify-content-center align-items-center text-white rounded-circle bg-purple-600">
                      SA
                    </div>
                    <a
                      href="mailto:roberto@gmail.com"
                      className="text-grey-800 text-decoration-none"
                    >
                      roberto@gmail.com
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-md-3 col-sm-6 col-12">
                <div className="mb-4">
                  <label htmlFor="firstName2" className="form-label">
                    First Name
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-lg"
                    id="firstName2"
                  />{" "}
                </div>
              </div>
              <div className="col-md-3 col-sm-6 col-12">
                <div className="mb-4">
                  <label htmlFor="lastName2" className="form-label">
                    Last Name
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-lg"
                    id="lastName2"
                  />{" "}
                </div>
              </div>
              <div className="col-md-2 col-sm-6 col-12">
                <div className="mb-4">
                  <label htmlFor="role" className="form-label">
                    Role
                  </label>
                  <select
                    className="form-select form-select-lg"
                    aria-label="Default select example"
                  >
                    <option selected>Default</option>
                    <option value="1">One</option>
                    <option value="2">Two</option>
                    <option value="3">Three</option>
                  </select>
                </div>
              </div>
            </li>
          </ul>
        </form>
      </div>
      <div className="mt-3">
        <div className="d-flex flex-wrap align-items-start gap-4">
          <div className="w-48 p-3 rounded-2 bg-white position-relative mt-3">
            <div className="new-avater">
              <div className="avater-box mb-2 p-2 position-relative">
                <div className="mx-auto w-22 h-22 rounded-circle bg-grey-100 position-relative overflow-hidden">
                  {/* <div className="short-name w-100 h-100 d-flex justify-content-center align-items-center">AD</div> */}
                  <img
                    src="../assets/images/avatars/8.jpg"
                    alt=""
                    className="w-100 h-100 object-fit-cover"
                  />
                </div>
              </div>

              <div className="new-av-details">
                <h4 className="text-sm font-semibold">Anna De </h4>

                <ul className="m-0 p-0 list-unstyled text-xs d-flex flex-column row-gap-1">
                  <li>
                    <i className="bx bx-user"></i> Admin
                  </li>
                  <li>
                    <i className="bx bx-envelope"></i> naim@gmail.com
                  </li>
                  <li>
                    <i className="bx bx-time"></i> 4:30 local time
                  </li>
                </ul>

                <div className="d-grid gap-1 mt-3">
                  <a href="#" className="btn btn-mini btn-block btn-light">
                    View Profile
                  </a>
                  <button
                    type="button"
                    className="btn btn-mini btn-block btn-dark"
                  >
                    Send Message
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="w-48 p-3 rounded-2 bg-white position-relative mt-3">
            <div className="new-avater">
              <div className="avater-box mb-2 p-2 position-relative">
                <div className="mx-auto w-22 h-22 rounded-circle bg-grey-100 position-relative overflow-hidden">
                  <div className="short-name w-100 h-100 d-flex justify-content-center align-items-center">
                    AD
                  </div>
                  {/* <img src="../assets/images/avatars/8.jpg" alt="" className="w-100 h-100 object-fit-cover" /> */}
                </div>
              </div>

              <div className="new-av-details">
                <h4 className="text-sm font-semibold">Anna De </h4>

                <ul className="m-0 p-0 list-unstyled text-xs d-flex flex-column row-gap-1">
                  <li>
                    <i className="bx bx-user"></i> Admin
                  </li>
                  <li>
                    <i className="bx bx-envelope"></i> naim@gmail.com
                  </li>
                  <li>
                    <i className="bx bx-time"></i> 4:30 local time
                  </li>
                </ul>

                <div className="d-grid gap-1 mt-3">
                  <a href="#" className="btn btn-mini btn-block btn-light">
                    View Profile
                  </a>
                  <button
                    type="button"
                    className="btn btn-mini btn-block btn-dark"
                  >
                    Send Message
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="p-3 rounded-2 bg-white position-relative mt-3">
            <div className="new-avater d-flex">
              <div className="mb-2 position-relative">
                <div className="me-2 w-24 h-24 rounded-circle bg-grey-100 position-relative overflow-hidden">
                  {/* <div className="short-name w-100 h-100 d-flex justify-content-center align-items-center">AD</div> */}
                  <img
                    src="../assets/images/avatars/8.jpg"
                    alt=""
                    className="w-100 h-100 object-fit-cover"
                  />
                </div>
              </div>

              <div className="new-av-details">
                <h4 className="text-sm font-semibold">Anna De </h4>

                <ul className="m-0 p-0 list-unstyled text-xs d-flex flex-column row-gap-1">
                  <li className="d-flex align-items-center">
                    <i className="bx bx-user me-1"></i> Admin
                  </li>
                  <li>
                    <i className="bx bx-envelope me-1"></i> naim@gmail.com
                  </li>
                  <li>
                    <i className="bx bx-time me-1"></i> 4:30 local time
                  </li>
                </ul>

                <div className="d-flex gap-1 mt-3">
                  <a href="#" className="btn btn-mini btn-light text-nowrap">
                    View Profile
                  </a>
                  <button
                    type="button"
                    className="btn btn-mini btn-dark text-nowrap"
                  >
                    Send Message
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="p-3 rounded-2 bg-white position-relative mt-3">
            <div className="new-avater d-flex">
              <div className="mb-2 position-relative">
                <div className="me-2 w-24 h-24 rounded-circle bg-grey-100 position-relative overflow-hidden">
                  <div className="short-name w-100 h-100 d-flex justify-content-center align-items-center">
                    AD
                  </div>
                  {/* <img src="../assets/images/avatars/8.jpg" alt="" className="w-100 h-100 object-fit-cover" /> */}
                </div>
              </div>

              <div className="new-av-details">
                <h4 className="text-sm font-semibold">Anna De </h4>

                <ul className="m-0 p-0 list-unstyled text-xs d-flex flex-column row-gap-1">
                  <li className="d-flex align-items-center">
                    <i className="bx bx-user me-1"></i> Admin
                  </li>
                  <li>
                    <i className="bx bx-envelope me-1"></i> naim@gmail.com
                  </li>
                  <li>
                    <i className="bx bx-time me-1"></i> 4:30 local time
                  </li>
                </ul>

                <div className="d-flex gap-1 mt-3">
                  <a href="#" className="btn btn-mini btn-light text-nowrap">
                    View Profile
                  </a>
                  <button
                    type="button"
                    className="btn btn-mini btn-dark text-nowrap"
                  >
                    Send Message
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="rounded-3 bg-white mt-3">
        <div className="d-flex p-4 border-bottom border-slate-200">
          <div className="w-24 h-24 flex-auto me-2 rounded-circle bg-grey-500 position-relative overflow-hidden">
            <div className="short-name w-100 h-100 d-flex justify-content-center align-items-center">
              AD
            </div>
          </div>
          <div className="d-flex flex-column row-gap-1 align-items-start">
            <h3 className="h5 mb-0 font-semibold text-slate-700">
              James Whitekar
            </h3>
            <ul className="m-0 p-0 list-unstyled text-sm text-slate-400 d-flex flex-wrap column-gap-2">
              <li>Student</li>
              <li>|</li>
              <li>Vancouver, Canada</li>
            </ul>
            <ul className="m-0 p-0 list-unstyled text-sm text-slate-500 d-flex flex-wrap column-gap-3 font-medium">
              <li className="d-flex align-items-center">
                <span className="material-symbols-outlined text-base me-1 text-slate-400">
                  calendar_today
                </span>
                Joined March 22, 2023
              </li>
              <li className="d-flex align-items-center">
                <span className="material-symbols-outlined text-base me-1 text-slate-400">
                  schedule
                </span>
                6:45 local time
              </li>
            </ul>
            <ul className="m-0 p-0 list-unstyled text-sm text-slate-500 d-flex flex-wrap column-gap-3 font-medium">
              <li className="d-flex align-items-center">
                <span className="material-symbols-outlined text-base me-1 text-slate-400">
                  mail
                </span>
                james@gmail.com
              </li>
            </ul>
          </div>
        </div>
        <div className="p-4 border-bottom border-slate-200">
          <h3 className="text-md font-semibold text-slate-600">Programs</h3>
          <div className="slick-top-nav">
            <Slider {...settings}>
              <div className="px-1">
                <div className="p-3 rounded-2 border border-slate-200 d-flex align-items-start flex-column row-gap-2">
                  <span className="px-3 py-1 text-xs font-medium text-green-600 rounded-1 border border-green-300 bg-green-100">
                    Active
                  </span>
                  <h4 className="mb-0 text-sm font-medium text-slate-600">
                    Bachelor in Business Administration
                  </h4>
                  <p className="mb-0 text-xs font-medium text-slate-400">
                    School of Management Studies (SOMS)
                  </p>
                </div>
              </div>
              <div className="px-1">
                <div className="p-3 rounded-2 border border-slate-200 d-flex align-items-start flex-column row-gap-2">
                  <span className="px-3 py-1 text-xs font-medium text-red-600 rounded-1 border border-red-300 bg-red-100">
                    Rejected
                  </span>
                  <h4 className="mb-0 text-sm font-medium text-slate-600">
                    Bachelor in Business Administration
                  </h4>
                  <p className="mb-0 text-xs font-medium text-slate-400">
                    School of Management Studies (SOMS)
                  </p>
                </div>
              </div>
              <div className="px-1">
                <div className="p-3 rounded-2 border border-slate-200 d-flex align-items-start flex-column row-gap-2">
                  <span className="px-3 py-1 text-xs font-medium text-red-600 rounded-1 border border-red-300 bg-red-100">
                    Rejected
                  </span>
                  <h4 className="mb-0 text-sm font-medium text-slate-600">
                    Bachelor in Business Administration
                  </h4>
                  <p className="mb-0 text-xs font-medium text-slate-400">
                    School of Management Studies (SOMS)
                  </p>
                </div>
              </div>
              <div className="px-1">
                <div className="p-3 rounded-2 border border-slate-200 d-flex align-items-start flex-column row-gap-2">
                  <span className="px-3 py-1 text-xs font-medium text-green-600 rounded-1 border border-green-300 bg-green-100">
                    Active
                  </span>
                  <h4 className="mb-0 text-sm font-medium text-slate-600">
                    Bachelor in Business Administration
                  </h4>
                  <p className="mb-0 text-xs font-medium text-slate-400">
                    School of Management Studies (SOMS)
                  </p>
                </div>
              </div>
              <div className="px-1">
                <div className="p-3 rounded-2 border border-slate-200 d-flex align-items-start flex-column row-gap-2">
                  <span className="px-3 py-1 text-xs font-medium text-green-600 rounded-1 border border-green-300 bg-green-100">
                    Active
                  </span>
                  <h4 className="mb-0 text-sm font-medium text-slate-600">
                    Bachelor in Business Administration
                  </h4>
                  <p className="mb-0 text-xs font-medium text-slate-400">
                    School of Management Studies (SOMS)
                  </p>
                </div>
              </div>
            </Slider>
          </div>
        </div>

        <div className="p-4 border-bottom border-slate-200">
          <h3 className="text-md font-semibold text-slate-600">Activity</h3>
          <div className="slide-status-nav position-relative ps-5 bg-grey-50 position-sticky top-0 z-1">
            <button className="btn btn-transparent border-0 back-right-position position-absolute top-0 start-0 bottom-0 d-flex align-items-center">
              <i className="bx bx-arrow-back bx-sm"></i>
            </button>
            <Slider {...settings}>
              <div
                className={`nav-status-item ${pathname.includes(overview) ? "active" : ""
                  }`}
              >
                <Link
                  to={
                    projectId && stageId
                      ? `${root}/${gid}${overview}?projectId=${projectId}&stageId=${stageId}`
                      : `${root}/${gid}${overview}`
                  }
                >
                  {t("common.button.overview")}
                </Link>
              </div>
              <div
                className={`nav-status-item ${pathname.includes(chat) ? "active" : ""
                  }`}
              >
                <Link
                  to={
                    projectId && stageId
                      ? `${root}/${gid}${chat}?projectId=${projectId}&stageId=${stageId}`
                      : `${root}/${gid}${chat}`
                  }
                >
                  {t("common.button.chat")}
                </Link>
              </div>
              <div
                className={`nav-status-item ${pathname.includes(email) ? "active" : ""
                  }`}
              >
                <Link
                  to={
                    projectId && stageId
                      ? `${root}/${gid}${email}?projectId=${projectId}&stageId=${stageId}`
                      : `${root}/${gid}${email}`
                  }
                >
                  {t("common.button.email")}
                </Link>
              </div>
              <div
                className={`nav-status-item ${pathname.includes(logs) ? "active" : ""
                  }`}
              >
                <Link
                  to={
                    projectId && stageId
                      ? `${root}/${gid}${logs}?projectId=${projectId}&stageId=${stageId}`
                      : `${root}/${gid}${logs}`
                  }
                >
                  {t("common.button.logs")}
                </Link>
              </div>
              <div
                className={`nav-status-item ${pathname.includes(timeline) ? "active" : ""
                  }`}
              >
                <Link
                  to={
                    projectId && stageId
                      ? `${root}/${gid}${timeline}?projectId=${projectId}&stageId=${stageId}`
                      : `${root}/${gid}${timeline}?`
                  }
                >
                  {t("common.button.timeline")}
                </Link>
              </div>
              <div
                className={`nav-status-item ${pathname.includes(document) ? "active" : ""
                  }`}
              >
                <Link
                  to={
                    projectId && stageId
                      ? `${root}/${gid}${document}?projectId=${projectId}&stageId=${stageId}`
                      : `${root}/${gid}${document}?`
                  }
                >
                  {t("Document")}
                </Link>
              </div>
            </Slider>
          </div>
          <div className="py-4">
            <ul className="timeline-list m-0 p-0 d-flex flex-wrap flex-column align-items-start">
              <li className="d-flex position-relative">
                <div className="w-10 h-10 me-3 rounded-circle border border-slate-200 bg-slate-100 d-flex flex-auto justify-content-center align-items-center position-relative z-1">
                  <span className="material-symbols-outlined">
                    text_snippet
                  </span>
                </div>
                <div className="d-flex flex-wrap flex-column row-gap-1 align-items-start">
                  <h4 className="mb-0 text-sm text-slate-600">
                    Submitted application for the Certificate Course{" "}
                    <a href="">AI Technologies</a>
                  </h4>
                  <span className="text-xs font-medium text-slate-400">
                    Feb 20, 2024 at 04:35 PM
                  </span>
                  <span className="px-2 py-1 text-xs font-medium text-green-800 rounded-1 bg-green-200">
                    AI Technologies
                  </span>
                </div>
              </li>
              <li className="d-flex position-relative">
                <div className="w-10 h-10 me-3 rounded-circle border border-slate-200 bg-slate-100 d-flex flex-auto justify-content-center align-items-center position-relative z-1">
                  <span className="material-symbols-outlined">publish</span>
                </div>
                <div className="d-flex flex-wrap flex-column row-gap-1 align-items-start">
                  <h4 className="mb-0 text-sm text-slate-600">
                    Uploaded <a href="#">high school transcripts</a> and{" "}
                    <a href="#">letters of recommendation</a>.
                  </h4>
                  <span className="text-xs font-medium text-slate-400">
                    Feb 16, 2024 at 08:00 AM
                  </span>
                  <span className="px-2 py-1 text-xs font-medium text-green-800 rounded-1 bg-green-200">
                    Bachelor in Business Administrator
                  </span>
                </div>
              </li>
              <li className="d-flex position-relative">
                <div className="w-10 h-10 me-3 rounded-circle border border-slate-200 bg-slate-100 d-flex flex-auto justify-content-center align-items-center position-relative z-1">
                  <span className="material-symbols-outlined">mail</span>
                </div>
                <div className="d-flex flex-wrap flex-column row-gap-1 align-items-start">
                  <h4 className="mb-0 text-sm text-slate-600">
                    Sent an email to <a href="#">admissions@university.edu</a>{" "}
                    inquiring about the status of the scholarship application.
                  </h4>
                  <span className="text-xs font-medium text-slate-400">
                    Feb 20, 2024 at 04:35 PM
                  </span>
                  <span className="px-2 py-1 text-xs font-medium text-green-800 rounded-1 bg-green-200">
                    Bachelor in Business...
                  </span>
                </div>
              </li>
              <li className="d-flex position-relative">
                <div className="w-10 h-10 me-3 rounded-circle border border-slate-200 bg-slate-100 d-flex flex-auto justify-content-center align-items-center position-relative z-1">
                  <span className="material-symbols-outlined">edit</span>
                </div>
                <div className="d-flex flex-wrap flex-column row-gap-1 align-items-start">
                  <h4 className="mb-0 text-sm text-slate-600">
                    Updated <a href="#">personal information</a> including
                    contact number and home address.
                  </h4>
                  <span className="text-xs font-medium text-slate-400">
                    Feb 20, 2024 at 04:35 PM
                  </span>
                  <span className="px-2 py-1 text-xs font-medium text-green-800 rounded-1 bg-green-200">
                    Bachelor in Business...
                  </span>
                </div>
              </li>
              <li className="d-flex position-relative">
                <div className="w-10 h-10 me-3 rounded-circle border border-slate-200 bg-slate-100 d-flex flex-auto justify-content-center align-items-center position-relative z-1">
                  <span className="material-symbols-outlined">description</span>
                </div>
                <div className="d-flex flex-wrap flex-column row-gap-1 align-items-start">
                  <h4 className="mb-0 text-sm text-slate-600">
                    Admin <a href="#">John Doe</a> requested additional{" "}
                    <a href="#">documents</a> for financial aid verification.
                  </h4>
                  <span className="text-xs font-medium text-slate-400">
                    Feb 20, 2024 at 04:35 PM
                  </span>
                  <span className="px-2 py-1 text-xs font-medium text-green-800 rounded-1 bg-green-200">
                    Bachelor in Business...
                  </span>
                </div>
              </li>
              <li className="d-flex position-relative">
                <div className="w-10 h-10 me-3 rounded-circle border border-slate-200 bg-slate-100 d-flex flex-auto justify-content-center align-items-center position-relative z-1">
                  <span className="material-symbols-outlined">description</span>
                </div>
                <div className="d-flex flex-wrap flex-column row-gap-1 align-items-start">
                  <h4 className="mb-0 text-sm text-slate-600">
                    Uploaded a <a href="#">recommendation letter</a> from the
                    high school math teacher.
                  </h4>
                  <span className="text-xs font-medium text-slate-400">
                    Feb 20, 2024 at 04:35 PM
                  </span>
                  <span className="px-2 py-1 text-xs font-medium text-green-800 rounded-1 bg-green-200">
                    Bachelor in Business...
                  </span>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div className="d-flex flex-column row-gap-4 p-4">
          <div className="rounded-2 bord</div>er border-slate-200">
            <div className="d-flex align-items-center mb-3">
              <h3 className="me-3 mb-0 text-sm text-uppercase text-nowrap">
                Student Info
              </h3>
              <div className="bg-slate-200 w-100 h-1"></div>
            </div>
            <Row>
              <Col lg={6} md={12} sm={12} xs={12}>
                <Form.Group
                  className="mb-3 position-relative"
                  controlId="StudentName"
                >
                  <Form.Label className="d-flex">Student name</Form.Label>
                  <Form.Control type="text" placeholder="Catherine Munres" />
                </Form.Group>
              </Col>
              <Col lg={6} md={12} sm={12} xs={12}>
                <Form.Group
                  className="mb-3 position-relative"
                  controlId="Residentialaddress"
                >
                  <Form.Label className="d-flex position-relative">
                    Residential address
                  </Form.Label>
                  <InputGroup className="mb-3">
                    <Form.Control
                      placeholder="Residential address"
                      aria-label="Recipient's username"
                      aria-describedby="basic-addon2"
                    />
                    <InputGroup.Text id="basic-addon2">
                      <span className="material-symbols-outlined">
                        location_on
                      </span>
                    </InputGroup.Text>
                  </InputGroup>
                </Form.Group>
              </Col>
              <Col lg={6} md={12} sm={12} xs={12}>
                <Form.Group
                  className="mb-3 position-relative"
                  controlId="StudentName"
                >
                  <Form.Label className="d-flex">Student age</Form.Label>
                  <Form.Select aria-label="Default select example">
                    <option>Open this select menu</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col lg={6} md={12} sm={12} xs={12}>
                <Form.Group
                  className="mb-3 position-relative"
                  controlId="Residentialaddress"
                >
                  <Form.Label className="d-flex position-relative">
                    Date of birth
                  </Form.Label>
                  <Form.Control type="date" placeholder="Catherine Munres" />
                </Form.Group>
              </Col>
              <Col lg={6} md={12} sm={12} xs={12}>
                <Form.Group
                  className="mb-3 position-relative"
                  controlId="Residentialaddress"
                >
                  <Form.Label className="d-flex position-relative">
                    Contact No
                  </Form.Label>
                  <Form.Control type="tel" placeholder="91 234567809" />
                </Form.Group>
              </Col>
              <Col lg={6} md={12} sm={12} xs={12}>
                <Form.Group
                  className="mb-3 position-relative"
                  controlId="Residentialaddress"
                >
                  <Form.Label className="d-flex position-relative">
                    Contact No
                  </Form.Label>
                  <Form.Control type="text" placeholder="@catherine890" />
                </Form.Group>
              </Col>
            </Row>
          </div>

          <div className="p-4 rounded-2 border border-slate-200">
            <div className="d-flex align-items-center mb-3">
              <h3 className="me-3 mb-0 text-sm text-uppercase text-nowrap">
                Educational Details
              </h3>
              <div className="bg-slate-200 w-100 h-1"></div>
            </div>
            <Row>
              <Col lg={6} md={12} sm={12} xs={12}>
                <Form.Group
                  className="mb-3 position-relative"
                  controlId="StudentName"
                >
                  <Form.Label className="d-flex">H.S School</Form.Label>
                  <Form.Control type="text" placeholder="XYZ High School" />
                </Form.Group>
              </Col>
              <Col lg={6} md={12} sm={12} xs={12}>
                <Form.Group
                  className="mb-3 position-relative"
                  controlId="Residentialaddress"
                >
                  <Form.Label className="d-flex position-relative">
                    School Address
                  </Form.Label>
                  <InputGroup className="mb-3">
                    <Form.Control
                      placeholder="435-2 Gastown St. Vancouver VCX-36B"
                      aria-label="Recipient's username"
                      aria-describedby="basic-addon2"
                    />
                    <InputGroup.Text id="basic-addon2">
                      <span className="material-symbols-outlined">
                        location_on
                      </span>
                    </InputGroup.Text>
                  </InputGroup>
                </Form.Group>
              </Col>
              <Col lg={6} md={12} sm={12} xs={12}>
                <Form.Group
                  className="mb-3 position-relative"
                  controlId="StudentName"
                >
                  <Form.Label className="d-flex">Pass out Year</Form.Label>
                  <Form.Select aria-label="Default select example">
                    <option>Open this select menu</option>
                    <option value="2020">2020</option>
                    <option value="2021">2021</option>
                    <option value="2022">2022</option>
                    <option value="2023">2023</option>
                    <option value="2024">2024</option>
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col lg={6} md={12} sm={12} xs={12}>
                <Form.Group
                  className="mb-3 position-relative"
                  controlId="Residentialaddress"
                >
                  <Form.Label className="d-flex position-relative">
                    GPA
                  </Form.Label>
                  <Form.Control type="number" placeholder="5.8" />
                </Form.Group>
              </Col>
            </Row>
          </div>
        </div>
      </div>

      <div className="rounded-3 bg-white mt-3">
        <ul className="nav nav-tabs mb-3 gray-tab" id="nav-tab" role="tablist">
          <li className="nav-item col" role="presentation">
            <button
              className="nav-link d-block w-100 px-4 py-4 text-md active"
              id="ask-tab"
              data-bs-toggle="pill"
              data-bs-target="#ask"
              type="button"
              role="tab"
              aria-controls="ask"
              aria-selected="true"
            >
              <span className="material-symbols-outlined align-middle me-2">
                quiz
              </span>
              Ask a recommendation
            </button>
          </li>
          <li className="nav-item col" role="presentation">
            <button
              className="nav-link d-block w-100 px-4 py-4 text-md"
              id="give-tab"
              data-bs-toggle="pill"
              data-bs-target="#give"
              type="button"
              role="tab"
              aria-controls="give"
              aria-selected="false"
            >
              <span className="material-symbols-outlined align-middle me-2">
                border_color
              </span>
              Give a recommendation
            </button>
          </li>
        </ul>
        <div className="tab-content" id="nav-tabContent">
          <div
            className="tab-pane px-4 py-3 fade show active"
            id="ask"
            role="tabpanel"
            aria-labelledby="ask-tab"
            tabindex="0"
          >
            <div className="d-flex align-items-center row-gap-3 mb-3">
              <h3 className="h6 mb-0 me-3">Requested Recommendations</h3>
              <ul className="filter-list ms-auto">
                <li>
                  <button
                    className="bg-transparent border-0 py-2 px-4"
                    type="button"
                  >
                    <i className="pluto-filter"></i> Filters
                  </button>
                </li>
                <li>
                  <button
                    className="btn btn-secondary py-2 px-4"
                    type="button"
                    data-bs-toggle="modal"
                    data-bs-target="#newRecommendationRequestModal"
                    data-bs-whatever="@mdo"
                  >
                    Get new recommendation
                  </button>
                </li>
              </ul>
            </div>

            <div
              className="modal text-start modal-slider fade right modal-max-w-780"
              id="newRecommendationRequestModal"
              aria-hidden="true"
              aria-labelledby="exampleModalLabel"
              tabindex="-1"
            >
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                  <div className="modal-header">
                    <h3
                      className="modal-title fs-5"
                      id="exampleModalToggleLabel"
                    >
                      New recommendation request
                    </h3>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <div className="modal-body p-4">
                    <div className="d-flex flex-column row-gap-4">
                      <div>
                        <div className="d-flex align-items-center mb-3">
                          <h3 className="me-3 mb-0 text-sm text-uppercase text-nowrap">
                            Recommender details
                          </h3>
                          <div className="bg-slate-200 w-100 h-1"></div>
                        </div>
                        <div className="p-4 rounded-2 border border-slate-200 bg-slate-100">
                          <Row className="gy-3">
                            <Col lg={12} md={12} sm={12} xs={12}>
                              <div className="">
                                <label for="email" className="form-label">
                                  Email address
                                </label>
                                <input
                                  type="email"
                                  className="form-control"
                                  id="email"
                                  placeholder="johndoes@gmail.com"
                                />
                              </div>
                            </Col>
                            <Col lg={6} md={12} sm={12} xs={12}>
                              <div className="">
                                <label for="firstName" className="form-label">
                                  First name
                                </label>
                                <input
                                  type="firstName"
                                  className="form-control"
                                  id="firstName"
                                  placeholder=""
                                />
                              </div>
                            </Col>
                            <Col lg={6} md={12} sm={12} xs={12}>
                              <div className="">
                                <label for="lastName" className="form-label">
                                  Last name
                                </label>
                                <input
                                  type="lastName"
                                  className="form-control"
                                  id="lastName"
                                  placeholder=""
                                />
                              </div>
                            </Col>
                            <Col lg={6} md={12} sm={12} xs={12}>
                              <div className="">
                                <label for="institute" className="form-label">
                                  Institute
                                </label>
                                <select
                                  className="form-select"
                                  aria-label="Small select example"
                                  for="institute"
                                  id="institute"
                                >
                                  <option>Open this select menu</option>
                                  <option selected value="1">
                                    IIT Kanpur
                                  </option>
                                  <option value="2">Two</option>
                                  <option value="3">Three</option>
                                </select>
                              </div>
                            </Col>
                            <Col lg={6} md={12} sm={12} xs={12}>
                              <div className="">
                                <label for="position" className="form-label">
                                  Position
                                </label>
                                <select
                                  className="form-select"
                                  aria-label="Small select example"
                                  for="position"
                                  id="position"
                                >
                                  <option>Open this select menu</option>
                                  <option selected value="1">
                                    Phd in Microbiology
                                  </option>
                                  <option value="2">Two</option>
                                  <option value="3">Three</option>
                                </select>
                              </div>
                            </Col>
                          </Row>
                        </div>
                      </div>

                      <div>
                        <div className="d-flex align-items-center mb-3">
                          <h3 className="me-3 mb-0 text-sm text-uppercase text-nowrap">
                            Recommendation request
                          </h3>
                          <div className="bg-slate-200 w-100 h-1"></div>
                        </div>
                        <div className="p-4 rounded-2 border border-slate-200 bg-slate-100">
                          <Row className="gy-3">
                            <Col lg={12} md={12} sm={12} xs={12}>
                              <div className="">
                                <label for="dueDate" className="form-label">
                                  Due date
                                </label>
                                <input
                                  type="date"
                                  className="form-control"
                                  id="dueDate"
                                  placeholder=""
                                />
                              </div>
                            </Col>
                            <Col lg={12} md={12} sm={12} xs={12}>
                              <div className="">
                                <label
                                  for="requestTitle"
                                  className="form-label"
                                >
                                  Request Title
                                </label>
                                <input
                                  type="requestTitle"
                                  className="form-control"
                                  id="requestTitle"
                                  placeholder=""
                                />
                              </div>
                            </Col>
                            <Col lg={12} md={12} sm={12} xs={12}>
                              <div className="">
                                <label
                                  for="applyingPosition"
                                  className="form-label"
                                >
                                  Applying position
                                </label>
                                <input
                                  type="applyingPosition"
                                  className="form-control"
                                  id="applyingPosition"
                                  placeholder=""
                                />
                              </div>
                            </Col>
                            <Col lg={12} md={12} sm={12} xs={12}>
                              <div className="">
                                <label for="institute" className="form-label">
                                  Custom message
                                </label>
                                <textarea
                                  name=""
                                  id=""
                                  className="form-control"
                                ></textarea>
                              </div>
                            </Col>
                            <Col lg={12} md={12} sm={12} xs={12}>
                              <div className="">
                                <label for="position" className="form-label">
                                  Upload supporting document{" "}
                                  <small className="small text-slate-400">
                                    (File Size 5 MB)
                                  </small>
                                </label>
                                <div className="mb-3 file-input-box bg-white border rounded">
                                  <label
                                    for="file"
                                    className="d-block p-5 text-center"
                                  >
                                    <span className="material-symbols-outlined">
                                      cloud_upload
                                    </span>
                                    <h5 className="mb-0">
                                      <strong>Choose file</strong> or{" "}
                                      <strong>Drag here</strong>
                                    </h5>
                                    <small>File Size 20 MB</small>
                                  </label>
                                  <input
                                    type="file"
                                    id="file"
                                    className="d-none"
                                  />
                                </div>
                                <div className="file-view-list d-flex flex-wrap gap-2 mb-3">
                                  <div className="file-view-details py-2 px-2 ms-2 bg-white border rounded d-flex align-items-center">
                                    <i className="bx bxs-file-pdf"></i>{" "}
                                    <label className="ms-1">PDF file.pdf</label>
                                    <button className="bg-transparent border-0 close-btn">
                                      <i className="bx bx-x"></i>
                                    </button>
                                  </div>
                                  <div className="file-view-details py-2 px-2 ms-2 bg-white border rounded d-flex align-items-center">
                                    <i className="bx bxs-file-jpg"></i>{" "}
                                    <label className="ms-1">JPG file.jpg</label>
                                    <button className="bg-transparent border-0 close-btn">
                                      <i className="bx bx-x"></i>
                                    </button>
                                  </div>
                                  <div className="file-view-details py-2 px-2 ms-2 bg-white border rounded d-flex align-items-center">
                                    <i className="bx bxs-file-png"></i>{" "}
                                    <label className="ms-1">PNG file.png</label>
                                    <button className="bg-transparent border-0 close-btn">
                                      <i className="bx bx-x"></i>
                                    </button>
                                  </div>
                                  <div className="file-view-details py-2 px-2 ms-2 bg-white border rounded d-flex align-items-center">
                                    <i className="bx bxs-file-doc"></i>{" "}
                                    <label className="ms-1">
                                      Document file.doc
                                    </label>
                                    <button className="bg-transparent border-0 close-btn">
                                      <i className="bx bx-x"></i>
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer justify-content-center">
                    <button className="btn btn-secondary flex-none">
                      Request recommendation
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className="row gy-4">
              <div className="col-xxl-3 col-lg-4 col-sm-6 col-12">
                <div className="requested-box border-2 border success rounded-2 bg-white overflow-hidden">
                  <div className="p-3 border-bottom">
                    <div className="d-flex align-items-center row-gap-3 mb-3">
                      <h4 className="text-sm mb-0 me-3 text-black-600">
                        Recommender
                      </h4>
                      <div className="ms-auto">
                        <button
                          className="button bg-transparent border-0 d-flex align-items-center"
                          type="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <i className="bx bx-dots-vertical-rounded bx-sm"></i>
                        </button>
                        <ul className="dropdown-menu dropdown-menu-end border-0 shadow-sm">
                          <li>
                            <button
                              type="button"
                              className="dropdown-item text-xs font-medium"
                            >
                              Edit
                            </button>
                          </li>
                          <li>
                            <button
                              type="button"
                              className="dropdown-item text-xs font-medium"
                            >
                              Copy Link
                            </button>
                          </li>
                          <li>
                            <button
                              type="button"
                              className="dropdown-item text-xs font-medium"
                              data-bs-toggle="modal"
                              data-bs-target="#sendReminderModal"
                              data-bs-whatever="@mdo"
                            >
                              Send Reminder
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="hover-effect">
                      <div className="new-avater d-flex align-items-center">
                        <div className="mb-2 position-relative">
                          <div className="me-2 w-16 h-16 rounded-circle bg-grey-100 position-relative overflow-hidden">
                            <img
                              alt=""
                              className="w-100 h-100 object-fit-cover"
                              src="../assets/images/avatars/5.jpg"
                            />
                          </div>
                        </div>
                        <div className="new-av-details">
                          <h4 className="text-sm font-semibold">Naim Hashim</h4>
                          <ul className="m-0 p-0 list-unstyled text-xs d-flex flex-column row-gap-1">
                            <li className="d-flex align-items-center">
                              <i className="bx bx-envelope me-1"></i>{" "}
                              naim@gmail.com
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="hover-box p-3 rounded-2 bg-white position-absolute  shadow z-3">
                        <div className="new-avater d-flex">
                          <div className="mb-2 position-relative">
                            <div className="me-2 w-24 h-24 rounded-circle bg-grey-100 position-relative overflow-hidden">
                              {/* <div className="short-name w-100 h-100 d-flex justify-content-center align-items-center">
                                AD
                              </div> */}
                              <img
                                src="../assets/images/avatars/5.jpg"
                                alt=""
                                className="w-100 h-100 object-fit-cover"
                              />
                            </div>
                          </div>

                          <div className="new-av-details">
                            <h4 className="text-sm font-semibold">Anna De </h4>

                            <ul className="m-0 p-0 list-unstyled text-xs d-flex flex-column row-gap-1">
                              <li className="d-flex align-items-center">
                                <i className="bx bx-user me-1"></i> Admin
                              </li>
                              <li>
                                <i className="bx bx-envelope me-1"></i>{" "}
                                naim@gmail.com
                              </li>
                              <li>
                                <i className="bx bx-time me-1"></i> 4:30 local
                                time
                              </li>
                            </ul>

                            <div className="d-flex gap-1 mt-3">
                              <a
                                href="#"
                                className="btn btn-mini btn-light text-nowrap"
                              >
                                View Profile
                              </a>
                              <button
                                type="button"
                                className="btn btn-mini btn-dark text-nowrap"
                              >
                                Send Message
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="p-3">
                    <ul className="m-0 p-0 list-unstyled text-sm d-flex flex-column row-gap-1">
                      <li className="py-1 d-flex align-items-center font-medium">
                        <i className="me-1">
                          <img
                            src="../assets/images/icons/pluto-user-status.svg"
                            alt=""
                          />
                        </i>
                        <span>
                          Status:{" "}
                          <span className="text-uppercase text-green-600">
                            Submitted
                          </span>
                        </span>
                      </li>
                      <li className="py-1 d-flex align-items-center font-medium">
                        <i className="me-1">
                          <img
                            src="../assets/images/icons/icon-calendar-outline.svg"
                            alt=""
                          />
                        </i>
                        <span>
                          Due date:{" "}
                          <span className="font-semibold">21 July 2023</span>
                        </span>
                      </li>
                      <li className="py-1 d-flex align-items-center font-medium">
                        <i className="me-1">
                          <img
                            src="../assets/images/icons/pluto-education.svg"
                            alt=""
                          />
                        </i>
                        <span>
                          Position:{" "}
                          <span className="font-semibold">
                            Masters in Microbiology
                          </span>
                        </span>
                      </li>
                      <li className="py-1 d-flex align-items-center font-medium">
                        <i className="me-1">
                          <img
                            src="../assets/images/icons/pluto-datetime.svg"
                            alt=""
                          />
                        </i>
                        <span>
                          Submission date:{" "}
                          <span className="font-semibold">
                            17 July 2023 | 13:45
                          </span>
                        </span>
                      </li>
                      <li className="py-1 d-flex align-items-center font-medium">
                        <i className="me-1">
                          <img
                            src="../assets/images/icons/pluto-document.svg"
                            alt=""
                          />
                        </i>
                        <span>
                          Supporting document:{" "}
                          <a href="#" className="font-semibold text-blue-700">
                            previouswork.pdf
                          </a>
                        </span>
                      </li>
                    </ul>
                  </div>
                  <div className="status-line"></div>
                </div>
              </div>
              <div className="col-xxl-3 col-lg-4 col-sm-6 col-12">
                <div className="requested-box border-2 border pending rounded-2 bg-white overflow-hidden">
                  <div className="p-3 border-bottom">
                    <div className="d-flex align-items-center row-gap-3 mb-3">
                      <h4 className="text-sm mb-0 me-3 text-black-600">
                        Recommender
                      </h4>
                      <div className="ms-auto">
                        <button
                          className="button bg-transparent border-0 d-flex align-items-center"
                          type="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <i className="bx bx-dots-vertical-rounded bx-sm"></i>
                        </button>
                        <ul className="dropdown-menu dropdown-menu-end border-0 shadow-sm">
                          <li>
                            <button
                              type="button"
                              className="dropdown-item text-xs font-medium"
                            >
                              Edit
                            </button>
                          </li>
                          <li>
                            <button
                              type="button"
                              className="dropdown-item text-xs font-medium"
                            >
                              Copy Link
                            </button>
                          </li>
                          <li>
                            <button
                              type="button"
                              className="dropdown-item text-xs font-medium"
                            >
                              Send Reminder
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>

                    <div className="new-avater d-flex align-items-center">
                      <div className="mb-2 position-relative">
                        <div className="me-2 w-16 h-16 rounded-circle bg-grey-100 position-relative overflow-hidden">
                          <img
                            alt=""
                            className="w-100 h-100 object-fit-cover"
                            src="../assets/images/avatars/5.jpg"
                          />
                        </div>
                      </div>
                      <div className="new-av-details">
                        <h4 className="text-sm font-semibold">Naim Hashim</h4>
                        <ul className="m-0 p-0 list-unstyled text-xs d-flex flex-column row-gap-1">
                          <li className="d-flex align-items-center">
                            <i className="bx bx-envelope me-1"></i>{" "}
                            naim@gmail.com
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="p-3">
                    <ul className="m-0 p-0 list-unstyled text-sm d-flex flex-column row-gap-1">
                      <li className="py-1 d-flex align-items-center font-medium">
                        <i className="me-1">
                          <img
                            src="../assets/images/icons/pluto-user-status.svg"
                            alt=""
                          />
                        </i>
                        <span>
                          Status:{" "}
                          <span className="text-uppercase text-green-600">
                            Submitted
                          </span>
                        </span>
                      </li>
                      <li className="py-1 d-flex align-items-center font-medium">
                        <i className="me-1">
                          <img
                            src="../assets/images/icons/icon-calendar-outline.svg"
                            alt=""
                          />
                        </i>
                        <span>
                          Due date:{" "}
                          <span className="font-semibold">21 July 2023</span>
                        </span>
                      </li>
                      <li className="py-1 d-flex align-items-center font-medium">
                        <i className="me-1">
                          <img
                            src="../assets/images/icons/pluto-education.svg"
                            alt=""
                          />
                        </i>
                        <span>
                          Position:{" "}
                          <span className="font-semibold">
                            Masters in Microbiology
                          </span>
                        </span>
                      </li>
                      <li className="py-1 d-flex align-items-center font-medium">
                        <i className="me-1">
                          <img
                            src="../assets/images/icons/pluto-datetime.svg"
                            alt=""
                          />
                        </i>
                        <span>
                          Submission date:{" "}
                          <span className="font-semibold">
                            17 July 2023 | 13:45
                          </span>
                        </span>
                      </li>
                      <li className="py-1 d-flex align-items-center font-medium">
                        <i className="me-1">
                          <img
                            src="../assets/images/icons/pluto-document.svg"
                            alt=""
                          />
                        </i>
                        <span>
                          Supporting document:{" "}
                          <a href="#" className="font-semibold text-blue-700">
                            previouswork.pdf
                          </a>
                        </span>
                      </li>
                    </ul>
                  </div>
                  <div className="status-line"></div>
                </div>
              </div>
              <div className="col-xxl-3 col-lg-4 col-sm-6 col-12">
                <div className="requested-box border-2 border reject rounded-2 bg-white overflow-hidden">
                  <div className="p-3 border-bottom">
                    <div className="d-flex align-items-center row-gap-3 mb-3">
                      <h4 className="text-sm mb-0 me-3 text-black-600">
                        Recommender
                      </h4>
                      <div className="ms-auto">
                        <button
                          className="button bg-transparent border-0 d-flex align-items-center"
                          type="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <i className="bx bx-dots-vertical-rounded bx-sm"></i>
                        </button>
                        <ul className="dropdown-menu dropdown-menu-end border-0 shadow-sm">
                          <li>
                            <button
                              type="button"
                              className="dropdown-item text-xs font-medium"
                            >
                              Edit
                            </button>
                          </li>
                          <li>
                            <button
                              type="button"
                              className="dropdown-item text-xs font-medium"
                            >
                              Copy Link
                            </button>
                          </li>
                          <li>
                            <button
                              type="button"
                              className="dropdown-item text-xs font-medium"
                            >
                              Send Reminder
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>

                    <div className="new-avater d-flex align-items-center">
                      <div className="mb-2 position-relative">
                        <div className="me-2 w-16 h-16 rounded-circle bg-grey-100 position-relative overflow-hidden">
                          <img
                            alt=""
                            className="w-100 h-100 object-fit-cover"
                            src="../assets/images/avatars/5.jpg"
                          />
                        </div>
                      </div>
                      <div className="new-av-details">
                        <h4 className="text-sm font-semibold">Naim Hashim</h4>
                        <ul className="m-0 p-0 list-unstyled text-xs d-flex flex-column row-gap-1">
                          <li className="d-flex align-items-center">
                            <i className="bx bx-envelope me-1"></i>{" "}
                            naim@gmail.com
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="p-3">
                    <ul className="m-0 p-0 list-unstyled text-sm d-flex flex-column row-gap-1">
                      <li className="py-1 d-flex align-items-center font-medium">
                        <i className="me-1">
                          <img
                            src="../assets/images/icons/pluto-user-status.svg"
                            alt=""
                          />
                        </i>
                        <span>
                          Status:{" "}
                          <span className="text-uppercase text-green-600">
                            Submitted
                          </span>
                        </span>
                      </li>
                      <li className="py-1 d-flex align-items-center font-medium">
                        <i className="me-1">
                          <img
                            src="../assets/images/icons/icon-calendar-outline.svg"
                            alt=""
                          />
                        </i>
                        <span>
                          Due date:{" "}
                          <span className="font-semibold">21 July 2023</span>
                        </span>
                      </li>
                      <li className="py-1 d-flex align-items-center font-medium">
                        <i className="me-1">
                          <img
                            src="../assets/images/icons/pluto-education.svg"
                            alt=""
                          />
                        </i>
                        <span>
                          Position:{" "}
                          <span className="font-semibold">
                            Masters in Microbiology
                          </span>
                        </span>
                      </li>
                      <li className="py-1 d-flex align-items-center font-medium">
                        <i className="me-1">
                          <img
                            src="../assets/images/icons/pluto-datetime.svg"
                            alt=""
                          />
                        </i>
                        <span>
                          Submission date:{" "}
                          <span className="font-semibold">
                            17 July 2023 | 13:45
                          </span>
                        </span>
                      </li>
                      <li className="py-1 d-flex align-items-center font-medium">
                        <i className="me-1">
                          <img
                            src="../assets/images/icons/pluto-document.svg"
                            alt=""
                          />
                        </i>
                        <span>
                          Supporting document:{" "}
                          <a href="#" className="font-semibold text-blue-700">
                            previouswork.pdf
                          </a>
                        </span>
                      </li>
                    </ul>
                  </div>
                  <div className="status-line"></div>
                </div>
              </div>
              <div className="col-xxl-3 col-lg-4 col-sm-6 col-12">
                <div className="requested-box border-2 border pending rounded-2 bg-white overflow-hidden">
                  <div className="p-3 border-bottom">
                    <div className="d-flex align-items-center row-gap-3 mb-3">
                      <h4 className="text-sm mb-0 me-3 text-black-600">
                        Recommender
                      </h4>
                      <div className="ms-auto">
                        <button
                          className="button bg-transparent border-0 d-flex align-items-center"
                          type="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <i className="bx bx-dots-vertical-rounded bx-sm"></i>
                        </button>
                        <ul className="dropdown-menu dropdown-menu-end border-0 shadow-sm">
                          <li>
                            <button
                              type="button"
                              className="dropdown-item text-xs font-medium"
                            >
                              Edit
                            </button>
                          </li>
                          <li>
                            <button
                              type="button"
                              className="dropdown-item text-xs font-medium"
                            >
                              Copy Link
                            </button>
                          </li>
                          <li>
                            <button
                              type="button"
                              className="dropdown-item text-xs font-medium"
                            >
                              Send Reminder
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>

                    <div className="new-avater d-flex align-items-center">
                      <div className="mb-2 position-relative">
                        <div className="me-2 w-16 h-16 rounded-circle bg-grey-100 position-relative overflow-hidden">
                          <img
                            alt=""
                            className="w-100 h-100 object-fit-cover"
                            src="../assets/images/avatars/5.jpg"
                          />
                        </div>
                      </div>
                      <div className="new-av-details">
                        <h4 className="text-sm font-semibold">Naim Hashim</h4>
                        <ul className="m-0 p-0 list-unstyled text-xs d-flex flex-column row-gap-1">
                          <li className="d-flex align-items-center">
                            <i className="bx bx-envelope me-1"></i>{" "}
                            naim@gmail.com
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="p-3">
                    <ul className="m-0 p-0 list-unstyled text-sm d-flex flex-column row-gap-1">
                      <li className="py-1 d-flex align-items-center font-medium">
                        <i className="me-1">
                          <img
                            src="../assets/images/icons/pluto-user-status.svg"
                            alt=""
                          />
                        </i>
                        <span>
                          Status:{" "}
                          <span className="text-uppercase text-green-600">
                            Submitted
                          </span>
                        </span>
                      </li>
                      <li className="py-1 d-flex align-items-center font-medium">
                        <i className="me-1">
                          <img
                            src="../assets/images/icons/icon-calendar-outline.svg"
                            alt=""
                          />
                        </i>
                        <span>
                          Due date:{" "}
                          <span className="font-semibold">21 July 2023</span>
                        </span>
                      </li>
                      <li className="py-1 d-flex align-items-center font-medium">
                        <i className="me-1">
                          <img
                            src="../assets/images/icons/pluto-education.svg"
                            alt=""
                          />
                        </i>
                        <span>
                          Position:{" "}
                          <span className="font-semibold">
                            Masters in Microbiology
                          </span>
                        </span>
                      </li>
                      <li className="py-1 d-flex align-items-center font-medium">
                        <i className="me-1">
                          <img
                            src="../assets/images/icons/pluto-datetime.svg"
                            alt=""
                          />
                        </i>
                        <span>
                          Submission date:{" "}
                          <span className="font-semibold">
                            17 July 2023 | 13:45
                          </span>
                        </span>
                      </li>
                      <li className="py-1 d-flex align-items-center font-medium">
                        <i className="me-1">
                          <img
                            src="../assets/images/icons/pluto-document.svg"
                            alt=""
                          />
                        </i>
                        <span>
                          Supporting document:{" "}
                          <a href="#" className="font-semibold text-blue-700">
                            previouswork.pdf
                          </a>
                        </span>
                      </li>
                    </ul>
                  </div>
                  <div className="status-line"></div>
                </div>
              </div>
            </div>

            <div
              className="modal text-start modal-slider fade right modal-max-w-780"
              id="sendReminderModal"
              aria-hidden="true"
              aria-labelledby="sendReminderModalLabel"
              tabindex="-1"
            >
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                  <div className="modal-header">
                    <h3
                      className="modal-title fs-5"
                      id="exampleModalToggleLabel"
                    >
                      Send Reminder
                    </h3>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <div className="modal-body p-4">
                    <div className="d-flex flex-column row-gap-4">
                      <div>
                        <div className="p-4 rounded-2 border border-slate-200 bg-slate-100">
                          <Row className="gy-3">
                            <Col lg={12} md={12} sm={12} xs={12}>
                              <div className="">
                                <label for="dueDate" className="form-label">
                                  Due date
                                </label>
                                <input
                                  type="date"
                                  className="form-control"
                                  id="dueDate"
                                  placeholder=""
                                />
                              </div>
                            </Col>
                            <Col lg={12} md={12} sm={12} xs={12}>
                              <div className="">
                                <label for="institute" className="form-label">
                                  Custom message
                                </label>
                                <textarea
                                  name=""
                                  id=""
                                  className="form-control"
                                ></textarea>
                              </div>
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer justify-content-center">
                    <button className="btn btn-secondary flex-none">
                      Send reminder
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="tab-pane p-4 fade"
            id="give"
            role="tabpanel"
            aria-labelledby="give-tab"
            tabindex="0"
          >
            <div className="d-flex align-items-center row-gap-3 mb-3">
              <h3 className="h6 mb-0 me-3">Given Recommendations</h3>
              {/* <ul className="filter-list ms-auto">
                <li><button className="bg-transparent border-0 py-2 px-4" type="button"><i className="pluto-filter"></i> Filters</button></li>
                <li><button className="btn btn-secondary py-2 px-4" type="button" data-bs-toggle="modal" data-bs-target="#newRecommendationRequestModal" data-bs-whatever="@mdo">Get new recommendation</button></li>
              </ul> */}
            </div>

            <div className="row gy-4">
              <div className="col-xxl-3 col-lg-4 col-sm-6 col-12">
                <div className="requested-box border-2 border rounded-2 bg-white overflow-hidden">
                  <div className="p-3 border-bottom">
                    <div className="d-flex align-items-center row-gap-3 mb-3">
                      <h4 className="text-sm mb-0 me-3 text-black-600">
                        Recommender
                      </h4>
                      <div className="ms-auto">
                        <button
                          className="button bg-transparent border-0 d-flex align-items-center"
                          type="button"
                          data-bs-toggle="modal"
                          data-bs-target="#recommenderModal"
                        >
                          <span className="material-symbols-outlined">
                            pan_zoom
                          </span>
                        </button>
                      </div>
                    </div>
                    <div className="hover-effect">
                      <div className="new-avater d-flex align-items-center">
                        <div className="mb-2 position-relative">
                          <div className="me-2 w-16 h-16 rounded-circle bg-grey-100 position-relative overflow-hidden">
                            <img
                              alt=""
                              className="w-100 h-100 object-fit-cover"
                              src="../assets/images/avatars/5.jpg"
                            />
                          </div>
                        </div>
                        <div className="new-av-details">
                          <h4 className="text-sm font-semibold">Naim Hashim</h4>
                          <ul className="m-0 p-0 list-unstyled text-xs d-flex flex-column row-gap-1">
                            <li className="d-flex align-items-center">
                              <i className="bx bx-envelope me-1"></i>{" "}
                              naim@gmail.com
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="hover-box p-3 rounded-2 bg-white position-absolute  shadow z-3">
                        <div className="new-avater d-flex">
                          <div className="mb-2 position-relative">
                            <div className="me-2 w-24 h-24 rounded-circle bg-grey-100 position-relative overflow-hidden">
                              {/* <div className="short-name w-100 h-100 d-flex justify-content-center align-items-center">
                                AD
                              </div> */}
                              <img
                                src="../assets/images/avatars/5.jpg"
                                alt=""
                                className="w-100 h-100 object-fit-cover"
                              />
                            </div>
                          </div>

                          <div className="new-av-details">
                            <h4 className="text-sm font-semibold">Anna De </h4>

                            <ul className="m-0 p-0 list-unstyled text-xs d-flex flex-column row-gap-1">
                              <li className="d-flex align-items-center">
                                <i className="bx bx-user me-1"></i> Admin
                              </li>
                              <li>
                                <i className="bx bx-envelope me-1"></i>{" "}
                                naim@gmail.com
                              </li>
                              <li>
                                <i className="bx bx-time me-1"></i> 4:30 local
                                time
                              </li>
                            </ul>

                            <div className="d-flex gap-1 mt-3">
                              <a
                                href="#"
                                className="btn btn-mini btn-light text-nowrap"
                              >
                                View Profile
                              </a>
                              <button
                                type="button"
                                className="btn btn-mini btn-dark text-nowrap"
                              >
                                Send Message
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="p-3 recommender-show-content">
                    <ul className="m-0 mb-3 p-0 list-unstyled text-sm d-flex flex-column row-gap-1">
                      <li className="py-1 d-flex align-items-center font-medium">
                        <i className="me-1">
                          <img
                            src="../assets/images/icons/pluto-user-status.svg"
                            alt=""
                          />
                        </i>
                        <span>
                          Status:{" "}
                          <span className="text-uppercase text-green-600">
                            Submitted
                          </span>
                        </span>
                      </li>
                      <li className="py-1 d-flex align-items-center font-medium">
                        <i className="me-1">
                          <img
                            src="../assets/images/icons/icon-calendar-outline.svg"
                            alt=""
                          />
                        </i>
                        <span>
                          Due date:{" "}
                          <span className="font-semibold">21 July 2023</span>
                        </span>
                      </li>
                      <li className="py-1 d-flex align-items-center font-medium">
                        <i className="me-1">
                          <img
                            src="../assets/images/icons/pluto-education.svg"
                            alt=""
                          />
                        </i>
                        <span>
                          Position:{" "}
                          <span className="font-semibold">
                            Masters in Microbiology
                          </span>
                        </span>
                      </li>
                      <li className="py-1 d-flex align-items-center font-medium">
                        <i className="me-1">
                          <img
                            src="../assets/images/icons/pluto-datetime.svg"
                            alt=""
                          />
                        </i>
                        <span>
                          Submission date:{" "}
                          <span className="font-semibold">
                            17 July 2023 | 13:45
                          </span>
                        </span>
                      </li>
                      <li className="py-1 d-flex align-items-center font-medium">
                        <i className="me-1">
                          <img
                            src="../assets/images/icons/pluto-document.svg"
                            alt=""
                          />
                        </i>
                        <span>
                          Supporting document:{" "}
                          <a href="#" className="font-semibold text-blue-700">
                            previouswork.pdf
                          </a>
                        </span>
                      </li>
                    </ul>

                    <div className="d-flex gap-2 mx-auto">
                      <a href="#" className="btn btn-success py-2 px-4 col">
                        Proceed
                      </a>
                      <a href="#" className="btn btn-danger py-2 px-4 col">
                        Decline
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xxl-3 col-lg-4 col-sm-6 col-12">
                <div className="requested-box border-2 border rounded-2 bg-white overflow-hidden">
                  <div className="p-3 border-bottom">
                    <div className="d-flex align-items-center row-gap-3 mb-3">
                      <h4 className="text-sm mb-0 me-3 text-black-600">
                        Recommender
                      </h4>
                      <div className="ms-auto">
                        <button
                          className="button bg-transparent border-0 d-flex align-items-center"
                          type="button"
                          data-bs-toggle="modal"
                          data-bs-target="#recommenderModal"
                        >
                          <span className="material-symbols-outlined">
                            pan_zoom
                          </span>
                        </button>
                      </div>
                    </div>
                    <div className="hover-effect">
                      <div className="new-avater d-flex align-items-center">
                        <div className="mb-2 position-relative">
                          <div className="me-2 w-16 h-16 rounded-circle bg-grey-100 position-relative overflow-hidden">
                            <img
                              alt=""
                              className="w-100 h-100 object-fit-cover"
                              src="../assets/images/avatars/5.jpg"
                            />
                          </div>
                        </div>
                        <div className="new-av-details">
                          <h4 className="text-sm font-semibold">Naim Hashim</h4>
                          <ul className="m-0 p-0 list-unstyled text-xs d-flex flex-column row-gap-1">
                            <li className="d-flex align-items-center">
                              <i className="bx bx-envelope me-1"></i>{" "}
                              naim@gmail.com
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="hover-box p-3 rounded-2 bg-white position-absolute  shadow z-3">
                        <div className="new-avater d-flex">
                          <div className="mb-2 position-relative">
                            <div className="me-2 w-24 h-24 rounded-circle bg-grey-100 position-relative overflow-hidden">
                              {/* <div className="short-name w-100 h-100 d-flex justify-content-center align-items-center">
                                AD
                              </div> */}
                              <img
                                src="../assets/images/avatars/5.jpg"
                                alt=""
                                className="w-100 h-100 object-fit-cover"
                              />
                            </div>
                          </div>

                          <div className="new-av-details">
                            <h4 className="text-sm font-semibold">Anna De </h4>

                            <ul className="m-0 p-0 list-unstyled text-xs d-flex flex-column row-gap-1">
                              <li className="d-flex align-items-center">
                                <i className="bx bx-user me-1"></i> Admin
                              </li>
                              <li>
                                <i className="bx bx-envelope me-1"></i>{" "}
                                naim@gmail.com
                              </li>
                              <li>
                                <i className="bx bx-time me-1"></i> 4:30 local
                                time
                              </li>
                            </ul>

                            <div className="d-flex gap-1 mt-3">
                              <a
                                href="#"
                                className="btn btn-mini btn-light text-nowrap"
                              >
                                View Profile
                              </a>
                              <button
                                type="button"
                                className="btn btn-mini btn-dark text-nowrap"
                              >
                                Send Message
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="p-3 recommender-show-content">
                    <ul className="m-0 mb-3 p-0 list-unstyled text-sm d-flex flex-column row-gap-1">
                      <li className="py-1 d-flex align-items-center font-medium">
                        <i className="me-1">
                          <img
                            src="../assets/images/icons/pluto-user-status.svg"
                            alt=""
                          />
                        </i>
                        <span>
                          Status:{" "}
                          <span className="text-uppercase text-green-600">
                            Submitted
                          </span>
                        </span>
                      </li>
                      <li className="py-1 d-flex align-items-center font-medium">
                        <i className="me-1">
                          <img
                            src="../assets/images/icons/icon-calendar-outline.svg"
                            alt=""
                          />
                        </i>
                        <span>
                          Due date:{" "}
                          <span className="font-semibold">21 July 2023</span>
                        </span>
                      </li>
                      <li className="py-1 d-flex align-items-center font-medium">
                        <i className="me-1">
                          <img
                            src="../assets/images/icons/pluto-education.svg"
                            alt=""
                          />
                        </i>
                        <span>
                          Position:{" "}
                          <span className="font-semibold">
                            Masters in Microbiology
                          </span>
                        </span>
                      </li>
                      <li className="py-1 d-flex align-items-center font-medium">
                        <i className="me-1">
                          <img
                            src="../assets/images/icons/pluto-datetime.svg"
                            alt=""
                          />
                        </i>
                        <span>
                          Submission date:{" "}
                          <span className="font-semibold">
                            17 July 2023 | 13:45
                          </span>
                        </span>
                      </li>
                      <li className="py-1 d-flex align-items-center font-medium">
                        <i className="me-1">
                          <img
                            src="../assets/images/icons/pluto-document.svg"
                            alt=""
                          />
                        </i>
                        <span>
                          Supporting document:{" "}
                          <a href="#" className="font-semibold text-blue-700">
                            previouswork.pdf
                          </a>
                        </span>
                      </li>
                    </ul>

                    <div className="d-flex gap-2 mx-auto">
                      {/* <a href="#" className="btn btn-success py-2 px-4 col">Proceed</a> */}
                      <a
                        href="#"
                        className="btn btn-outline-danger py-2 px-4 col"
                      >
                        Delect
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xxl-3 col-lg-4 col-sm-6 col-12">
                <div className="requested-box border-2 border rounded-2 bg-white overflow-hidden">
                  <div className="p-3 border-bottom">
                    <div className="d-flex align-items-center row-gap-3 mb-3">
                      <h4 className="text-sm mb-0 me-3 text-black-600">
                        Recommender
                      </h4>
                      <div className="ms-auto">
                        <button
                          className="button bg-transparent border-0 d-flex align-items-center"
                          type="button"
                          data-bs-toggle="modal"
                          data-bs-target="#recommenderModal"
                        >
                          <span className="material-symbols-outlined">
                            pan_zoom
                          </span>
                        </button>
                      </div>
                    </div>
                    <div className="hover-effect">
                      <div className="new-avater d-flex align-items-center">
                        <div className="mb-2 position-relative">
                          <div className="me-2 w-16 h-16 rounded-circle bg-grey-100 position-relative overflow-hidden">
                            <img
                              alt=""
                              className="w-100 h-100 object-fit-cover"
                              src="../assets/images/avatars/5.jpg"
                            />
                          </div>
                        </div>
                        <div className="new-av-details">
                          <h4 className="text-sm font-semibold">Naim Hashim</h4>
                          <ul className="m-0 p-0 list-unstyled text-xs d-flex flex-column row-gap-1">
                            <li className="d-flex align-items-center">
                              <i className="bx bx-envelope me-1"></i>{" "}
                              naim@gmail.com
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="hover-box p-3 rounded-2 bg-white position-absolute  shadow z-3">
                        <div className="new-avater d-flex">
                          <div className="mb-2 position-relative">
                            <div className="me-2 w-24 h-24 rounded-circle bg-grey-100 position-relative overflow-hidden">
                              {/* <div className="short-name w-100 h-100 d-flex justify-content-center align-items-center">
                                AD
                              </div> */}
                              <img
                                src="../assets/images/avatars/5.jpg"
                                alt=""
                                className="w-100 h-100 object-fit-cover"
                              />
                            </div>
                          </div>

                          <div className="new-av-details">
                            <h4 className="text-sm font-semibold">Anna De </h4>

                            <ul className="m-0 p-0 list-unstyled text-xs d-flex flex-column row-gap-1">
                              <li className="d-flex align-items-center">
                                <i className="bx bx-user me-1"></i> Admin
                              </li>
                              <li>
                                <i className="bx bx-envelope me-1"></i>{" "}
                                naim@gmail.com
                              </li>
                              <li>
                                <i className="bx bx-time me-1"></i> 4:30 local
                                time
                              </li>
                            </ul>

                            <div className="d-flex gap-1 mt-3">
                              <a
                                href="#"
                                className="btn btn-mini btn-light text-nowrap"
                              >
                                View Profile
                              </a>
                              <button
                                type="button"
                                className="btn btn-mini btn-dark text-nowrap"
                              >
                                Send Message
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="p-3 recommender-show-content">
                    <ul className="m-0 mb-3 p-0 list-unstyled text-sm d-flex flex-column row-gap-1">
                      <li className="py-1 d-flex align-items-center font-medium">
                        <i className="me-1">
                          <img
                            src="../assets/images/icons/pluto-user-status.svg"
                            alt=""
                          />
                        </i>
                        <span>
                          Status:{" "}
                          <span className="text-uppercase text-green-600">
                            Submitted
                          </span>
                        </span>
                      </li>
                      <li className="py-1 d-flex align-items-center font-medium">
                        <i className="me-1">
                          <img
                            src="../assets/images/icons/icon-calendar-outline.svg"
                            alt=""
                          />
                        </i>
                        <span>
                          Due date:{" "}
                          <span className="font-semibold">21 July 2023</span>
                        </span>
                      </li>
                      <li className="py-1 d-flex align-items-center font-medium">
                        <i className="me-1">
                          <img
                            src="../assets/images/icons/pluto-education.svg"
                            alt=""
                          />
                        </i>
                        <span>
                          Position:{" "}
                          <span className="font-semibold">
                            Masters in Microbiology
                          </span>
                        </span>
                      </li>
                      <li className="py-1 d-flex align-items-center font-medium">
                        <i className="me-1">
                          <img
                            src="../assets/images/icons/pluto-datetime.svg"
                            alt=""
                          />
                        </i>
                        <span>
                          Submission date:{" "}
                          <span className="font-semibold">
                            17 July 2023 | 13:45
                          </span>
                        </span>
                      </li>
                      <li className="py-1 d-flex align-items-center font-medium">
                        <i className="me-1">
                          <img
                            src="../assets/images/icons/pluto-document.svg"
                            alt=""
                          />
                        </i>
                        <span>
                          Supporting document:{" "}
                          <a href="#" className="font-semibold text-blue-700">
                            previouswork.pdf
                          </a>
                        </span>
                      </li>
                    </ul>

                    <div className="d-flex gap-2 mx-auto">
                      <a href="#" className="btn btn-success py-2 px-4 col">
                        Proceed
                      </a>
                      <a href="#" className="btn btn-danger py-2 px-4 col">
                        Decline
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xxl-3 col-lg-4 col-sm-6 col-12">
                <div className="requested-box border-2 border rounded-2 bg-white overflow-hidden">
                  <div className="p-3 border-bottom">
                    <div className="d-flex align-items-center row-gap-3 mb-3">
                      <h4 className="text-sm mb-0 me-3 text-black-600">
                        Recommender
                      </h4>
                      <div className="ms-auto">
                        <button
                          className="button bg-transparent border-0 d-flex align-items-center"
                          type="button"
                          data-bs-toggle="modal"
                          data-bs-target="#recommenderModal"
                        >
                          <span className="material-symbols-outlined">
                            pan_zoom
                          </span>
                        </button>
                      </div>
                    </div>
                    <div className="hover-effect">
                      <div className="new-avater d-flex align-items-center">
                        <div className="mb-2 position-relative">
                          <div className="me-2 w-16 h-16 rounded-circle bg-grey-100 position-relative overflow-hidden">
                            <img
                              alt=""
                              className="w-100 h-100 object-fit-cover"
                              src="../assets/images/avatars/5.jpg"
                            />
                          </div>
                        </div>
                        <div className="new-av-details">
                          <h4 className="text-sm font-semibold">Naim Hashim</h4>
                          <ul className="m-0 p-0 list-unstyled text-xs d-flex flex-column row-gap-1">
                            <li className="d-flex align-items-center">
                              <i className="bx bx-envelope me-1"></i>{" "}
                              naim@gmail.com
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="hover-box p-3 rounded-2 bg-white position-absolute  shadow z-3">
                        <div className="new-avater d-flex">
                          <div className="mb-2 position-relative">
                            <div className="me-2 w-24 h-24 rounded-circle bg-grey-100 position-relative overflow-hidden">
                              {/* <div className="short-name w-100 h-100 d-flex justify-content-center align-items-center">
                                AD
                              </div> */}
                              <img
                                src="../assets/images/avatars/5.jpg"
                                alt=""
                                className="w-100 h-100 object-fit-cover"
                              />
                            </div>
                          </div>

                          <div className="new-av-details">
                            <h4 className="text-sm font-semibold">Anna De </h4>

                            <ul className="m-0 p-0 list-unstyled text-xs d-flex flex-column row-gap-1">
                              <li className="d-flex align-items-center">
                                <i className="bx bx-user me-1"></i> Admin
                              </li>
                              <li>
                                <i className="bx bx-envelope me-1"></i>{" "}
                                naim@gmail.com
                              </li>
                              <li>
                                <i className="bx bx-time me-1"></i> 4:30 local
                                time
                              </li>
                            </ul>

                            <div className="d-flex gap-1 mt-3">
                              <a
                                href="#"
                                className="btn btn-mini btn-light text-nowrap"
                              >
                                View Profile
                              </a>
                              <button
                                type="button"
                                className="btn btn-mini btn-dark text-nowrap"
                              >
                                Send Message
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="p-3 recommender-show-content">
                    <ul className="m-0 mb-3 p-0 list-unstyled text-sm d-flex flex-column row-gap-1">
                      <li className="py-1 d-flex align-items-center font-medium">
                        <i className="me-1">
                          <img
                            src="../assets/images/icons/pluto-user-status.svg"
                            alt=""
                          />
                        </i>
                        <span>
                          Status:{" "}
                          <span className="text-uppercase text-green-600">
                            Submitted
                          </span>
                        </span>
                      </li>
                      <li className="py-1 d-flex align-items-center font-medium">
                        <i className="me-1">
                          <img
                            src="../assets/images/icons/icon-calendar-outline.svg"
                            alt=""
                          />
                        </i>
                        <span>
                          Due date:{" "}
                          <span className="font-semibold">21 July 2023</span>
                        </span>
                      </li>
                      <li className="py-1 d-flex align-items-center font-medium">
                        <i className="me-1">
                          <img
                            src="../assets/images/icons/pluto-education.svg"
                            alt=""
                          />
                        </i>
                        <span>
                          Position:{" "}
                          <span className="font-semibold">
                            Masters in Microbiology
                          </span>
                        </span>
                      </li>
                      <li className="py-1 d-flex align-items-center font-medium">
                        <i className="me-1">
                          <img
                            src="../assets/images/icons/pluto-datetime.svg"
                            alt=""
                          />
                        </i>
                        <span>
                          Submission date:{" "}
                          <span className="font-semibold">
                            17 July 2023 | 13:45
                          </span>
                        </span>
                      </li>
                      <li className="py-1 d-flex align-items-center font-medium">
                        <i className="me-1">
                          <img
                            src="../assets/images/icons/pluto-document.svg"
                            alt=""
                          />
                        </i>
                        <span>
                          Supporting document:{" "}
                          <a href="#" className="font-semibold text-blue-700">
                            previouswork.pdf
                          </a>
                        </span>
                      </li>
                    </ul>

                    <div className="d-flex gap-2 mx-auto">
                      <a href="#" className="btn btn-success py-2 px-4 col">
                        Proceed
                      </a>
                      <a href="#" className="btn btn-danger py-2 px-4 col">
                        Decline
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="modal fade"
              id="recommenderModal"
              tabindex="-1"
              aria-labelledby="exampleModalLabel"
              aria-hidden="true"
            >
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <h1 className="modal-title fs-5" id="exampleModalLabel">
                      Recommender
                    </h1>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <div className="modal-body p-0">
                    <div className="p-3 border-bottom">
                      <div className="hover-effect">
                        <div className="new-avater d-flex align-items-center">
                          <div className="mb-2 position-relative">
                            <div className="me-2 w-16 h-16 rounded-circle bg-grey-100 position-relative overflow-hidden">
                              <img
                                alt=""
                                className="w-100 h-100 object-fit-cover"
                                src="../assets/images/avatars/5.jpg"
                              />
                            </div>
                          </div>
                          <div className="new-av-details">
                            <h4 className="text-sm font-semibold">
                              Naim Hashim
                            </h4>
                            <ul className="m-0 p-0 list-unstyled text-xs d-flex flex-column row-gap-1">
                              <li className="d-flex align-items-center">
                                <i className="bx bx-envelope me-1"></i>{" "}
                                naim@gmail.com
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div className="hover-box p-3 rounded-2 bg-white position-absolute  shadow z-3">
                          <div className="new-avater d-flex">
                            <div className="mb-2 position-relative">
                              <div className="me-2 w-24 h-24 rounded-circle bg-grey-100 position-relative overflow-hidden">
                                {/* <div className="short-name w-100 h-100 d-flex justify-content-center align-items-center">
                                  AD
                                </div> */}
                                <img
                                  src="../assets/images/avatars/5.jpg"
                                  alt=""
                                  className="w-100 h-100 object-fit-cover"
                                />
                              </div>
                            </div>

                            <div className="new-av-details">
                              <h4 className="text-sm font-semibold">
                                Anna De{" "}
                              </h4>

                              <ul className="m-0 p-0 list-unstyled text-xs d-flex flex-column row-gap-1">
                                <li className="d-flex align-items-center">
                                  <i className="bx bx-user me-1"></i> Admin
                                </li>
                                <li>
                                  <i className="bx bx-envelope me-1"></i>{" "}
                                  naim@gmail.com
                                </li>
                                <li>
                                  <i className="bx bx-time me-1"></i> 4:30 local
                                  time
                                </li>
                              </ul>

                              <div className="d-flex gap-1 mt-3">
                                <a
                                  href="#"
                                  className="btn btn-mini btn-light text-nowrap"
                                >
                                  View Profile
                                </a>
                                <button
                                  type="button"
                                  className="btn btn-mini btn-dark text-nowrap"
                                >
                                  Send Message
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="p-3 recommender-show-content border-bottom">
                      <ul className="m-0 p-0 list-unstyled text-sm d-flex flex-column row-gap-1">
                        <li className="py-1 d-flex align-items-center font-medium">
                          <i className="me-1">
                            <img
                              src="../assets/images/icons/pluto-user-status.svg"
                              alt=""
                            />
                          </i>
                          <span>
                            Status:{" "}
                            <span className="text-uppercase text-green-600">
                              Submitted
                            </span>
                          </span>
                        </li>
                        <li className="py-1 d-flex align-items-center font-medium">
                          <i className="me-1">
                            <img
                              src="../assets/images/icons/icon-calendar-outline.svg"
                              alt=""
                            />
                          </i>
                          <span>
                            Due date:{" "}
                            <span className="font-semibold">21 July 2023</span>
                          </span>
                        </li>
                        <li className="py-1 d-flex align-items-center font-medium">
                          <i className="me-1">
                            <img
                              src="../assets/images/icons/pluto-education.svg"
                              alt=""
                            />
                          </i>
                          <span>
                            Position:{" "}
                            <span className="font-semibold">
                              Masters in Microbiology
                            </span>
                          </span>
                        </li>
                        <li className="py-1 d-flex align-items-center font-medium">
                          <i className="me-1">
                            <img
                              src="../assets/images/icons/pluto-datetime.svg"
                              alt=""
                            />
                          </i>
                          <span>
                            Submission date:{" "}
                            <span className="font-semibold">
                              17 July 2023 | 13:45
                            </span>
                          </span>
                        </li>
                        <li className="py-1 d-flex align-items-center font-medium">
                          <i className="me-1">
                            <img
                              src="../assets/images/icons/pluto-document.svg"
                              alt=""
                            />
                          </i>
                          <span>
                            Supporting document:{" "}
                            <a href="#" className="font-semibold text-blue-700">
                              previouswork.pdf
                            </a>
                          </span>
                        </li>
                      </ul>
                    </div>
                    <div className="p-3">
                      <h5 className="h6 fot-bold">Request for a reference</h5>
                      <p className="text-sm">
                        I hope you're doing well. I'm reaching out to ask if you
                        would be willing to provide me with a recommendation.
                        Your insights and perspective would be incredibly
                        valuable, and I believe your feedback could greatly
                        benefit my profile. If you need any additional
                        information or details, please let me know.{" "}
                      </p>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <div className="d-flex gap-2 mx-auto w-100">
                      <a href="#" className="btn btn-success py-2 px-4 col">
                        Proceed
                      </a>
                      <a href="#" className="btn btn-danger py-2 px-4 col">
                        Decline
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="p-4 rounded-3 bg-white mt-3">
        <div className="d-flex gap-5">
          <div className="max-w-600 p-4 rounded-3 shadow">
            <table className="status-table preview-table w-100 text-xs">
              <thead>
                <tr>
                  <th>Assignee</th>
                  <th>Stage</th>
                  <th>Due date</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div className="new-avater d-flex align-items-center">
                      <div className="position-relative">
                        <div className="me-2 w-10 h-10 rounded-circle bg-grey-100 position-relative overflow-hidden">
                          <img
                            alt=""
                            className="w-100 h-100 object-fit-cover"
                            src="../assets/images/avatars/5.jpg"
                          />
                        </div>
                      </div>
                      <div className="new-av-details">
                        <h4 className="mb-0 text-sm font-medium">You</h4>
                      </div>
                    </div>
                  </td>
                  <td>
                    <span className="px-2 py-1 text-blue-600 rounded-1 border-blue-300 bg-blue-100">
                      Stage 3
                    </span>
                  </td>
                  <td>May 5, 4:20 PM</td>
                  <td>
                    <span className="px-2 py-1 text-orange-600 rounded-1 border-orange-300 bg-orange-100">
                      Pending
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className="new-avater d-flex align-items-center">
                      <div className="position-relative">
                        <div className="me-2 w-10 h-10 rounded-circle bg-grey-100 position-relative overflow-hidden">
                          <img
                            alt=""
                            className="w-100 h-100 object-fit-cover"
                            src="../assets/images/avatars/6.jpg"
                          />
                        </div>
                      </div>
                      <div className="new-av-details">
                        <h4 className="mb-0 text-sm font-medium">
                          Najer Salman
                        </h4>
                      </div>
                    </div>
                  </td>
                  <td>
                    <span className="px-2 py-1 text-blue-600 rounded-1 border-blue-300 bg-blue-100">
                      Stage 3
                    </span>
                  </td>
                  <td>May 5, 4:20 PM</td>
                  <td>
                    <span className="px-2 py-1 text-green-600 rounded-1 border-green-300 bg-green-100">
                      Approve
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className="new-avater d-flex align-items-center">
                      <div className="position-relative">
                        <div className="me-2 w-10 h-10 rounded-circle bg-grey-100 position-relative overflow-hidden">
                          <img
                            alt=""
                            className="w-100 h-100 object-fit-cover"
                            src="../assets/images/avatars/6.jpg"
                          />
                        </div>
                      </div>
                      <div className="new-av-details">
                        <h4 className="mb-0 text-sm font-medium">
                          Najer Salman
                        </h4>
                      </div>
                    </div>
                  </td>
                  <td>
                    <span className="px-2 py-1 text-blue-600 rounded-1 border-blue-300 bg-blue-100">
                      Stage 3
                    </span>
                  </td>
                  <td>May 5, 4:20 PM</td>
                  <td>
                    <span className="px-2 py-1 text-green-600 rounded-1 border-green-300 bg-green-100">
                      Approve
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className="new-avater d-flex align-items-center">
                      <div className="position-relative">
                        <div className="me-2 w-10 h-10 rounded-circle bg-grey-100 position-relative overflow-hidden">
                          <img
                            alt=""
                            className="w-100 h-100 object-fit-cover"
                            src="../assets/images/avatars/6.jpg"
                          />
                        </div>
                      </div>
                      <div className="new-av-details">
                        <h4 className="mb-0 text-sm font-medium">
                          Najer Salman
                        </h4>
                      </div>
                    </div>
                  </td>
                  <td>
                    <span className="px-2 py-1 text-blue-600 rounded-1 border-blue-300 bg-blue-100">
                      Stage 3
                    </span>
                  </td>
                  <td>May 5, 4:20 PM</td>
                  <td>
                    <span className="px-2 py-1 text-green-600 rounded-1 border-green-300 bg-green-100">
                      Approve
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className="new-avater d-flex align-items-center">
                      <div className="position-relative">
                        <div className="me-2 w-10 h-10 rounded-circle bg-grey-100 position-relative overflow-hidden">
                          <img
                            alt=""
                            className="w-100 h-100 object-fit-cover"
                            src="../assets/images/avatars/6.jpg"
                          />
                        </div>
                      </div>
                      <div className="new-av-details">
                        <h4 className="mb-0 text-sm font-medium">
                          Najer Salman
                        </h4>
                      </div>
                    </div>
                  </td>
                  <td>
                    <span className="px-2 py-1 text-blue-600 rounded-1 border-blue-300 bg-blue-100">
                      Stage 3
                    </span>
                  </td>
                  <td>May 5, 4:20 PM</td>
                  <td>
                    <span className="px-2 py-1 text-green-600 rounded-1 border-green-300 bg-green-100">
                      Approve
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="univercity-ranking max-w-400">
            <div className="rounded-3 shadow bg-white">
              <div className="p-3 border-bottom">
                <h4 className="mb-0 text-md font-semibold text-black-800">
                  Delhi University
                </h4>
              </div>
              <div className="p-3">
                <ul className="list-unstyled d-flex flex-column row-gap-3">
                  <li className="d-flex align-items-center text-sm">
                    <div className="flex-none w-10 h-10 rounded-circle overflow-hidden me-2 bg-black-100">
                      <img
                        src="../assets/images/universityranking-icon/nirf.png"
                        alt=""
                        className="w-100 h-100 object-fit-contain"
                      />
                    </div>
                    <span className="me-2 font-medium">NIRF Ranking</span>{" "}
                    <span className="ms-auto px-2 py-1 rounded-1 text-xs font-semibold text-red-600 bg-red-100">
                      82
                    </span>
                  </li>
                  <li className="d-flex align-items-center text-sm">
                    <div className="flex-none w-10 h-10 rounded-circle overflow-hidden me-2 bg-black-100">
                      <img
                        src="../assets/images/universityranking-icon/qs.svg"
                        alt=""
                        className="w-100 h-100 object-fit-contain"
                      />
                    </div>
                    <span className="me-2 font-medium">QS Ranking</span>{" "}
                    <span className="ms-auto px-2 py-1 rounded-1 text-xs font-semibold text-green-600 bg-green-100">
                      34
                    </span>
                  </li>
                  <li className="d-flex align-items-center text-sm">
                    <div className="flex-none w-10 h-10 rounded-circle overflow-hidden me-2 bg-black-100">
                      <img
                        src="../assets/images/universityranking-icon/aiur.svg"
                        alt=""
                        className="w-100 h-100 object-fit-contain"
                      />
                    </div>
                    <span className="me-2 font-medium">AIUR</span>{" "}
                    <span className="ms-auto px-2 py-1 rounded-1 text-xs font-semibold text-blue-600 bg-blue-100">
                      46
                    </span>
                  </li>
                  <li className="d-flex align-items-center text-sm">
                    <div className="flex-none w-10 h-10 rounded-circle overflow-hidden me-2 bg-black-100">
                      <img
                        src="../assets/images/universityranking-icon/the.svg"
                        alt=""
                        className="w-100 h-100 object-fit-contain"
                      />
                    </div>
                    <span className="me-2 font-medium">The</span>{" "}
                    <span className="ms-auto px-2 py-1 rounded-1 text-xs font-semibold text-blue-600 bg-blue-100">
                      46
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}
